/*!
 * Webflow: Front-end site library
 * @license MIT
 * Inline scripts may access the api using an async handler:
 *   var Webflow = Webflow || [];
 *   Webflow.push(readyFunction);
 */

(() => {
  var u = (e, t) => () => (t || e((t = { exports: {} }).exports, t), t.exports);
  var Fi = u(() => {
    window.tram = (function (e) {
      function t(l, E) {
        var _ = new me.Bare();
        return _.init(l, E);
      }
      function r(l) {
        return l.replace(/[A-Z]/g, function (E) {
          return "-" + E.toLowerCase();
        });
      }
      function n(l) {
        var E = parseInt(l.slice(1), 16),
          _ = (E >> 16) & 255,
          m = (E >> 8) & 255,
          w = 255 & E;
        return [_, m, w];
      }
      function o(l, E, _) {
        return (
          "#" + ((1 << 24) | (l << 16) | (E << 8) | _).toString(16).slice(1)
        );
      }
      function i() {}
      function a(l, E) {
        f("Type warning: Expected: [" + l + "] Got: [" + typeof E + "] " + E);
      }
      function s(l, E, _) {
        f("Units do not match [" + l + "]: " + E + ", " + _);
      }
      function c(l, E, _) {
        if ((E !== void 0 && (_ = E), l === void 0)) return _;
        var m = _;
        return (
          Or.test(l) || !Nt.test(l)
            ? (m = parseInt(l, 10))
            : Nt.test(l) && (m = 1e3 * parseFloat(l)),
          0 > m && (m = 0),
          m === m ? m : _
        );
      }
      function f(l) {
        ce.debug && window && window.console.warn(l);
      }
      function p(l) {
        for (var E = -1, _ = l ? l.length : 0, m = []; ++E < _; ) {
          var w = l[E];
          w && m.push(w);
        }
        return m;
      }
      var d = (function (l, E, _) {
          function m($) {
            return typeof $ == "object";
          }
          function w($) {
            return typeof $ == "function";
          }
          function S() {}
          function H($, le) {
            function G() {
              var Pe = new te();
              return w(Pe.init) && Pe.init.apply(Pe, arguments), Pe;
            }
            function te() {}
            le === _ && ((le = $), ($ = Object)), (G.Bare = te);
            var re,
              he = (S[l] = $[l]),
              et = (te[l] = G[l] = new S());
            return (
              (et.constructor = G),
              (G.mixin = function (Pe) {
                return (te[l] = G[l] = H(G, Pe)[l]), G;
              }),
              (G.open = function (Pe) {
                if (
                  ((re = {}),
                  w(Pe) ? (re = Pe.call(G, et, he, G, $)) : m(Pe) && (re = Pe),
                  m(re))
                )
                  for (var br in re) E.call(re, br) && (et[br] = re[br]);
                return w(et.init) || (et.init = $), G;
              }),
              G.open(le)
            );
          }
          return H;
        })("prototype", {}.hasOwnProperty),
        h = {
          ease: [
            "ease",
            function (l, E, _, m) {
              var w = (l /= m) * l,
                S = w * l;
              return (
                E +
                _ * (-2.75 * S * w + 11 * w * w + -15.5 * S + 8 * w + 0.25 * l)
              );
            },
          ],
          "ease-in": [
            "ease-in",
            function (l, E, _, m) {
              var w = (l /= m) * l,
                S = w * l;
              return E + _ * (-1 * S * w + 3 * w * w + -3 * S + 2 * w);
            },
          ],
          "ease-out": [
            "ease-out",
            function (l, E, _, m) {
              var w = (l /= m) * l,
                S = w * l;
              return (
                E +
                _ * (0.3 * S * w + -1.6 * w * w + 2.2 * S + -1.8 * w + 1.9 * l)
              );
            },
          ],
          "ease-in-out": [
            "ease-in-out",
            function (l, E, _, m) {
              var w = (l /= m) * l,
                S = w * l;
              return E + _ * (2 * S * w + -5 * w * w + 2 * S + 2 * w);
            },
          ],
          linear: [
            "linear",
            function (l, E, _, m) {
              return (_ * l) / m + E;
            },
          ],
          "ease-in-quad": [
            "cubic-bezier(0.550, 0.085, 0.680, 0.530)",
            function (l, E, _, m) {
              return _ * (l /= m) * l + E;
            },
          ],
          "ease-out-quad": [
            "cubic-bezier(0.250, 0.460, 0.450, 0.940)",
            function (l, E, _, m) {
              return -_ * (l /= m) * (l - 2) + E;
            },
          ],
          "ease-in-out-quad": [
            "cubic-bezier(0.455, 0.030, 0.515, 0.955)",
            function (l, E, _, m) {
              return (l /= m / 2) < 1
                ? (_ / 2) * l * l + E
                : (-_ / 2) * (--l * (l - 2) - 1) + E;
            },
          ],
          "ease-in-cubic": [
            "cubic-bezier(0.550, 0.055, 0.675, 0.190)",
            function (l, E, _, m) {
              return _ * (l /= m) * l * l + E;
            },
          ],
          "ease-out-cubic": [
            "cubic-bezier(0.215, 0.610, 0.355, 1)",
            function (l, E, _, m) {
              return _ * ((l = l / m - 1) * l * l + 1) + E;
            },
          ],
          "ease-in-out-cubic": [
            "cubic-bezier(0.645, 0.045, 0.355, 1)",
            function (l, E, _, m) {
              return (l /= m / 2) < 1
                ? (_ / 2) * l * l * l + E
                : (_ / 2) * ((l -= 2) * l * l + 2) + E;
            },
          ],
          "ease-in-quart": [
            "cubic-bezier(0.895, 0.030, 0.685, 0.220)",
            function (l, E, _, m) {
              return _ * (l /= m) * l * l * l + E;
            },
          ],
          "ease-out-quart": [
            "cubic-bezier(0.165, 0.840, 0.440, 1)",
            function (l, E, _, m) {
              return -_ * ((l = l / m - 1) * l * l * l - 1) + E;
            },
          ],
          "ease-in-out-quart": [
            "cubic-bezier(0.770, 0, 0.175, 1)",
            function (l, E, _, m) {
              return (l /= m / 2) < 1
                ? (_ / 2) * l * l * l * l + E
                : (-_ / 2) * ((l -= 2) * l * l * l - 2) + E;
            },
          ],
          "ease-in-quint": [
            "cubic-bezier(0.755, 0.050, 0.855, 0.060)",
            function (l, E, _, m) {
              return _ * (l /= m) * l * l * l * l + E;
            },
          ],
          "ease-out-quint": [
            "cubic-bezier(0.230, 1, 0.320, 1)",
            function (l, E, _, m) {
              return _ * ((l = l / m - 1) * l * l * l * l + 1) + E;
            },
          ],
          "ease-in-out-quint": [
            "cubic-bezier(0.860, 0, 0.070, 1)",
            function (l, E, _, m) {
              return (l /= m / 2) < 1
                ? (_ / 2) * l * l * l * l * l + E
                : (_ / 2) * ((l -= 2) * l * l * l * l + 2) + E;
            },
          ],
          "ease-in-sine": [
            "cubic-bezier(0.470, 0, 0.745, 0.715)",
            function (l, E, _, m) {
              return -_ * Math.cos((l / m) * (Math.PI / 2)) + _ + E;
            },
          ],
          "ease-out-sine": [
            "cubic-bezier(0.390, 0.575, 0.565, 1)",
            function (l, E, _, m) {
              return _ * Math.sin((l / m) * (Math.PI / 2)) + E;
            },
          ],
          "ease-in-out-sine": [
            "cubic-bezier(0.445, 0.050, 0.550, 0.950)",
            function (l, E, _, m) {
              return (-_ / 2) * (Math.cos((Math.PI * l) / m) - 1) + E;
            },
          ],
          "ease-in-expo": [
            "cubic-bezier(0.950, 0.050, 0.795, 0.035)",
            function (l, E, _, m) {
              return l === 0 ? E : _ * Math.pow(2, 10 * (l / m - 1)) + E;
            },
          ],
          "ease-out-expo": [
            "cubic-bezier(0.190, 1, 0.220, 1)",
            function (l, E, _, m) {
              return l === m
                ? E + _
                : _ * (-Math.pow(2, (-10 * l) / m) + 1) + E;
            },
          ],
          "ease-in-out-expo": [
            "cubic-bezier(1, 0, 0, 1)",
            function (l, E, _, m) {
              return l === 0
                ? E
                : l === m
                ? E + _
                : (l /= m / 2) < 1
                ? (_ / 2) * Math.pow(2, 10 * (l - 1)) + E
                : (_ / 2) * (-Math.pow(2, -10 * --l) + 2) + E;
            },
          ],
          "ease-in-circ": [
            "cubic-bezier(0.600, 0.040, 0.980, 0.335)",
            function (l, E, _, m) {
              return -_ * (Math.sqrt(1 - (l /= m) * l) - 1) + E;
            },
          ],
          "ease-out-circ": [
            "cubic-bezier(0.075, 0.820, 0.165, 1)",
            function (l, E, _, m) {
              return _ * Math.sqrt(1 - (l = l / m - 1) * l) + E;
            },
          ],
          "ease-in-out-circ": [
            "cubic-bezier(0.785, 0.135, 0.150, 0.860)",
            function (l, E, _, m) {
              return (l /= m / 2) < 1
                ? (-_ / 2) * (Math.sqrt(1 - l * l) - 1) + E
                : (_ / 2) * (Math.sqrt(1 - (l -= 2) * l) + 1) + E;
            },
          ],
          "ease-in-back": [
            "cubic-bezier(0.600, -0.280, 0.735, 0.045)",
            function (l, E, _, m, w) {
              return (
                w === void 0 && (w = 1.70158),
                _ * (l /= m) * l * ((w + 1) * l - w) + E
              );
            },
          ],
          "ease-out-back": [
            "cubic-bezier(0.175, 0.885, 0.320, 1.275)",
            function (l, E, _, m, w) {
              return (
                w === void 0 && (w = 1.70158),
                _ * ((l = l / m - 1) * l * ((w + 1) * l + w) + 1) + E
              );
            },
          ],
          "ease-in-out-back": [
            "cubic-bezier(0.680, -0.550, 0.265, 1.550)",
            function (l, E, _, m, w) {
              return (
                w === void 0 && (w = 1.70158),
                (l /= m / 2) < 1
                  ? (_ / 2) * l * l * (((w *= 1.525) + 1) * l - w) + E
                  : (_ / 2) *
                      ((l -= 2) * l * (((w *= 1.525) + 1) * l + w) + 2) +
                    E
              );
            },
          ],
        },
        g = {
          "ease-in-back": "cubic-bezier(0.600, 0, 0.735, 0.045)",
          "ease-out-back": "cubic-bezier(0.175, 0.885, 0.320, 1)",
          "ease-in-out-back": "cubic-bezier(0.680, 0, 0.265, 1)",
        },
        O = document,
        I = window,
        C = "bkwld-tram",
        A = /[\-\.0-9]/g,
        R = /[A-Z]/,
        T = "number",
        q = /^(rgb|#)/,
        x = /(em|cm|mm|in|pt|pc|px)$/,
        N = /(em|cm|mm|in|pt|pc|px|%)$/,
        F = /(deg|rad|turn)$/,
        U = "unitless",
        W = /(all|none) 0s ease 0s/,
        ee = /^(width|height)$/,
        K = " ",
        L = O.createElement("a"),
        y = ["Webkit", "Moz", "O", "ms"],
        P = ["-webkit-", "-moz-", "-o-", "-ms-"],
        M = function (l) {
          if (l in L.style) return { dom: l, css: l };
          var E,
            _,
            m = "",
            w = l.split("-");
          for (E = 0; E < w.length; E++)
            m += w[E].charAt(0).toUpperCase() + w[E].slice(1);
          for (E = 0; E < y.length; E++)
            if (((_ = y[E] + m), _ in L.style))
              return { dom: _, css: P[E] + l };
        },
        D = (t.support = {
          bind: Function.prototype.bind,
          transform: M("transform"),
          transition: M("transition"),
          backface: M("backface-visibility"),
          timing: M("transition-timing-function"),
        });
      if (D.transition) {
        var j = D.timing.dom;
        if (((L.style[j] = h["ease-in-back"][0]), !L.style[j]))
          for (var z in g) h[z][0] = g[z];
      }
      var ie = (t.frame = (function () {
          var l =
            I.requestAnimationFrame ||
            I.webkitRequestAnimationFrame ||
            I.mozRequestAnimationFrame ||
            I.oRequestAnimationFrame ||
            I.msRequestAnimationFrame;
          return l && D.bind
            ? l.bind(I)
            : function (E) {
                I.setTimeout(E, 16);
              };
        })()),
        Ne = (t.now = (function () {
          var l = I.performance,
            E = l && (l.now || l.webkitNow || l.msNow || l.mozNow);
          return E && D.bind
            ? E.bind(l)
            : Date.now ||
                function () {
                  return +new Date();
                };
        })()),
        Ve = d(function (l) {
          function E(k, ne) {
            var pe = p(("" + k).split(K)),
              oe = pe[0];
            ne = ne || {};
            var qe = V[oe];
            if (!qe) return f("Unsupported property: " + oe);
            if (!ne.weak || !this.props[oe]) {
              var He = qe[0],
                De = this.props[oe];
              return (
                De || (De = this.props[oe] = new He.Bare()),
                De.init(this.$el, pe, qe, ne),
                De
              );
            }
          }
          function _(k, ne, pe) {
            if (k) {
              var oe = typeof k;
              if (
                (ne ||
                  (this.timer && this.timer.destroy(),
                  (this.queue = []),
                  (this.active = !1)),
                oe == "number" && ne)
              )
                return (
                  (this.timer = new ht({
                    duration: k,
                    context: this,
                    complete: S,
                  })),
                  void (this.active = !0)
                );
              if (oe == "string" && ne) {
                switch (k) {
                  case "hide":
                    G.call(this);
                    break;
                  case "stop":
                    H.call(this);
                    break;
                  case "redraw":
                    te.call(this);
                    break;
                  default:
                    E.call(this, k, pe && pe[1]);
                }
                return S.call(this);
              }
              if (oe == "function") return void k.call(this, this);
              if (oe == "object") {
                var qe = 0;
                et.call(
                  this,
                  k,
                  function (ge, cI) {
                    ge.span > qe && (qe = ge.span), ge.stop(), ge.animate(cI);
                  },
                  function (ge) {
                    "wait" in ge && (qe = c(ge.wait, 0));
                  },
                ),
                  he.call(this),
                  qe > 0 &&
                    ((this.timer = new ht({ duration: qe, context: this })),
                    (this.active = !0),
                    ne && (this.timer.complete = S));
                var He = this,
                  De = !1,
                  sn = {};
                ie(function () {
                  et.call(He, k, function (ge) {
                    ge.active && ((De = !0), (sn[ge.name] = ge.nextStyle));
                  }),
                    De && He.$el.css(sn);
                });
              }
            }
          }
          function m(k) {
            (k = c(k, 0)),
              this.active
                ? this.queue.push({ options: k })
                : ((this.timer = new ht({
                    duration: k,
                    context: this,
                    complete: S,
                  })),
                  (this.active = !0));
          }
          function w(k) {
            return this.active
              ? (this.queue.push({ options: k, args: arguments }),
                void (this.timer.complete = S))
              : f(
                  "No active transition timer. Use start() or wait() before then().",
                );
          }
          function S() {
            if (
              (this.timer && this.timer.destroy(),
              (this.active = !1),
              this.queue.length)
            ) {
              var k = this.queue.shift();
              _.call(this, k.options, !0, k.args);
            }
          }
          function H(k) {
            this.timer && this.timer.destroy(),
              (this.queue = []),
              (this.active = !1);
            var ne;
            typeof k == "string"
              ? ((ne = {}), (ne[k] = 1))
              : (ne = typeof k == "object" && k != null ? k : this.props),
              et.call(this, ne, Pe),
              he.call(this);
          }
          function $(k) {
            H.call(this, k), et.call(this, k, br, sI);
          }
          function le(k) {
            typeof k != "string" && (k = "block"), (this.el.style.display = k);
          }
          function G() {
            H.call(this), (this.el.style.display = "none");
          }
          function te() {
            this.el.offsetHeight;
          }
          function re() {
            H.call(this), e.removeData(this.el, C), (this.$el = this.el = null);
          }
          function he() {
            var k,
              ne,
              pe = [];
            this.upstream && pe.push(this.upstream);
            for (k in this.props)
              (ne = this.props[k]), ne.active && pe.push(ne.string);
            (pe = pe.join(",")),
              this.style !== pe &&
                ((this.style = pe), (this.el.style[D.transition.dom] = pe));
          }
          function et(k, ne, pe) {
            var oe,
              qe,
              He,
              De,
              sn = ne !== Pe,
              ge = {};
            for (oe in k)
              (He = k[oe]),
                oe in fe
                  ? (ge.transform || (ge.transform = {}),
                    (ge.transform[oe] = He))
                  : (R.test(oe) && (oe = r(oe)),
                    oe in V ? (ge[oe] = He) : (De || (De = {}), (De[oe] = He)));
            for (oe in ge) {
              if (((He = ge[oe]), (qe = this.props[oe]), !qe)) {
                if (!sn) continue;
                qe = E.call(this, oe);
              }
              ne.call(this, qe, He);
            }
            pe && De && pe.call(this, De);
          }
          function Pe(k) {
            k.stop();
          }
          function br(k, ne) {
            k.set(ne);
          }
          function sI(k) {
            this.$el.css(k);
          }
          function We(k, ne) {
            l[k] = function () {
              return this.children
                ? uI.call(this, ne, arguments)
                : (this.el && ne.apply(this, arguments), this);
            };
          }
          function uI(k, ne) {
            var pe,
              oe = this.children.length;
            for (pe = 0; oe > pe; pe++) k.apply(this.children[pe], ne);
            return this;
          }
          (l.init = function (k) {
            if (
              ((this.$el = e(k)),
              (this.el = this.$el[0]),
              (this.props = {}),
              (this.queue = []),
              (this.style = ""),
              (this.active = !1),
              ce.keepInherited && !ce.fallback)
            ) {
              var ne = X(this.el, "transition");
              ne && !W.test(ne) && (this.upstream = ne);
            }
            D.backface &&
              ce.hideBackface &&
              v(this.el, D.backface.css, "hidden");
          }),
            We("add", E),
            We("start", _),
            We("wait", m),
            We("then", w),
            We("next", S),
            We("stop", H),
            We("set", $),
            We("show", le),
            We("hide", G),
            We("redraw", te),
            We("destroy", re);
        }),
        me = d(Ve, function (l) {
          function E(_, m) {
            var w = e.data(_, C) || e.data(_, C, new Ve.Bare());
            return w.el || w.init(_), m ? w.start(m) : w;
          }
          l.init = function (_, m) {
            var w = e(_);
            if (!w.length) return this;
            if (w.length === 1) return E(w[0], m);
            var S = [];
            return (
              w.each(function (H, $) {
                S.push(E($, m));
              }),
              (this.children = S),
              this
            );
          };
        }),
        Y = d(function (l) {
          function E() {
            var S = this.get();
            this.update("auto");
            var H = this.get();
            return this.update(S), H;
          }
          function _(S, H, $) {
            return H !== void 0 && ($ = H), S in h ? S : $;
          }
          function m(S) {
            var H = /rgba?\((\d+),\s*(\d+),\s*(\d+)/.exec(S);
            return (H ? o(H[1], H[2], H[3]) : S).replace(
              /#(\w)(\w)(\w)$/,
              "#$1$1$2$2$3$3",
            );
          }
          var w = { duration: 500, ease: "ease", delay: 0 };
          (l.init = function (S, H, $, le) {
            (this.$el = S), (this.el = S[0]);
            var G = H[0];
            $[2] && (G = $[2]),
              B[G] && (G = B[G]),
              (this.name = G),
              (this.type = $[1]),
              (this.duration = c(H[1], this.duration, w.duration)),
              (this.ease = _(H[2], this.ease, w.ease)),
              (this.delay = c(H[3], this.delay, w.delay)),
              (this.span = this.duration + this.delay),
              (this.active = !1),
              (this.nextStyle = null),
              (this.auto = ee.test(this.name)),
              (this.unit = le.unit || this.unit || ce.defaultUnit),
              (this.angle = le.angle || this.angle || ce.defaultAngle),
              ce.fallback || le.fallback
                ? (this.animate = this.fallback)
                : ((this.animate = this.transition),
                  (this.string =
                    this.name +
                    K +
                    this.duration +
                    "ms" +
                    (this.ease != "ease" ? K + h[this.ease][0] : "") +
                    (this.delay ? K + this.delay + "ms" : "")));
          }),
            (l.set = function (S) {
              (S = this.convert(S, this.type)), this.update(S), this.redraw();
            }),
            (l.transition = function (S) {
              (this.active = !0),
                (S = this.convert(S, this.type)),
                this.auto &&
                  (this.el.style[this.name] == "auto" &&
                    (this.update(this.get()), this.redraw()),
                  S == "auto" && (S = E.call(this))),
                (this.nextStyle = S);
            }),
            (l.fallback = function (S) {
              var H =
                this.el.style[this.name] || this.convert(this.get(), this.type);
              (S = this.convert(S, this.type)),
                this.auto &&
                  (H == "auto" && (H = this.convert(this.get(), this.type)),
                  S == "auto" && (S = E.call(this))),
                (this.tween = new Ct({
                  from: H,
                  to: S,
                  duration: this.duration,
                  delay: this.delay,
                  ease: this.ease,
                  update: this.update,
                  context: this,
                }));
            }),
            (l.get = function () {
              return X(this.el, this.name);
            }),
            (l.update = function (S) {
              v(this.el, this.name, S);
            }),
            (l.stop = function () {
              (this.active || this.nextStyle) &&
                ((this.active = !1),
                (this.nextStyle = null),
                v(this.el, this.name, this.get()));
              var S = this.tween;
              S && S.context && S.destroy();
            }),
            (l.convert = function (S, H) {
              if (S == "auto" && this.auto) return S;
              var $,
                le = typeof S == "number",
                G = typeof S == "string";
              switch (H) {
                case T:
                  if (le) return S;
                  if (G && S.replace(A, "") === "") return +S;
                  $ = "number(unitless)";
                  break;
                case q:
                  if (G) {
                    if (S === "" && this.original) return this.original;
                    if (H.test(S))
                      return S.charAt(0) == "#" && S.length == 7 ? S : m(S);
                  }
                  $ = "hex or rgb string";
                  break;
                case x:
                  if (le) return S + this.unit;
                  if (G && H.test(S)) return S;
                  $ = "number(px) or string(unit)";
                  break;
                case N:
                  if (le) return S + this.unit;
                  if (G && H.test(S)) return S;
                  $ = "number(px) or string(unit or %)";
                  break;
                case F:
                  if (le) return S + this.angle;
                  if (G && H.test(S)) return S;
                  $ = "number(deg) or string(angle)";
                  break;
                case U:
                  if (le || (G && N.test(S))) return S;
                  $ = "number(unitless) or string(unit or %)";
              }
              return a($, S), S;
            }),
            (l.redraw = function () {
              this.el.offsetHeight;
            });
        }),
        Oe = d(Y, function (l, E) {
          l.init = function () {
            E.init.apply(this, arguments),
              this.original || (this.original = this.convert(this.get(), q));
          };
        }),
        wt = d(Y, function (l, E) {
          (l.init = function () {
            E.init.apply(this, arguments), (this.animate = this.fallback);
          }),
            (l.get = function () {
              return this.$el[this.name]();
            }),
            (l.update = function (_) {
              this.$el[this.name](_);
            });
        }),
        Ht = d(Y, function (l, E) {
          function _(m, w) {
            var S, H, $, le, G;
            for (S in m)
              (le = fe[S]),
                ($ = le[0]),
                (H = le[1] || S),
                (G = this.convert(m[S], $)),
                w.call(this, H, G, $);
          }
          (l.init = function () {
            E.init.apply(this, arguments),
              this.current ||
                ((this.current = {}),
                fe.perspective &&
                  ce.perspective &&
                  ((this.current.perspective = ce.perspective),
                  v(this.el, this.name, this.style(this.current)),
                  this.redraw()));
          }),
            (l.set = function (m) {
              _.call(this, m, function (w, S) {
                this.current[w] = S;
              }),
                v(this.el, this.name, this.style(this.current)),
                this.redraw();
            }),
            (l.transition = function (m) {
              var w = this.values(m);
              this.tween = new mr({
                current: this.current,
                values: w,
                duration: this.duration,
                delay: this.delay,
                ease: this.ease,
              });
              var S,
                H = {};
              for (S in this.current) H[S] = S in w ? w[S] : this.current[S];
              (this.active = !0), (this.nextStyle = this.style(H));
            }),
            (l.fallback = function (m) {
              var w = this.values(m);
              this.tween = new mr({
                current: this.current,
                values: w,
                duration: this.duration,
                delay: this.delay,
                ease: this.ease,
                update: this.update,
                context: this,
              });
            }),
            (l.update = function () {
              v(this.el, this.name, this.style(this.current));
            }),
            (l.style = function (m) {
              var w,
                S = "";
              for (w in m) S += w + "(" + m[w] + ") ";
              return S;
            }),
            (l.values = function (m) {
              var w,
                S = {};
              return (
                _.call(this, m, function (H, $, le) {
                  (S[H] = $),
                    this.current[H] === void 0 &&
                      ((w = 0),
                      ~H.indexOf("scale") && (w = 1),
                      (this.current[H] = this.convert(w, le)));
                }),
                S
              );
            });
        }),
        Ct = d(function (l) {
          function E(G) {
            $.push(G) === 1 && ie(_);
          }
          function _() {
            var G,
              te,
              re,
              he = $.length;
            if (he)
              for (ie(_), te = Ne(), G = he; G--; )
                (re = $[G]), re && re.render(te);
          }
          function m(G) {
            var te,
              re = e.inArray(G, $);
            re >= 0 &&
              ((te = $.slice(re + 1)),
              ($.length = re),
              te.length && ($ = $.concat(te)));
          }
          function w(G) {
            return Math.round(G * le) / le;
          }
          function S(G, te, re) {
            return o(
              G[0] + re * (te[0] - G[0]),
              G[1] + re * (te[1] - G[1]),
              G[2] + re * (te[2] - G[2]),
            );
          }
          var H = { ease: h.ease[1], from: 0, to: 1 };
          (l.init = function (G) {
            (this.duration = G.duration || 0), (this.delay = G.delay || 0);
            var te = G.ease || H.ease;
            h[te] && (te = h[te][1]),
              typeof te != "function" && (te = H.ease),
              (this.ease = te),
              (this.update = G.update || i),
              (this.complete = G.complete || i),
              (this.context = G.context || this),
              (this.name = G.name);
            var re = G.from,
              he = G.to;
            re === void 0 && (re = H.from),
              he === void 0 && (he = H.to),
              (this.unit = G.unit || ""),
              typeof re == "number" && typeof he == "number"
                ? ((this.begin = re), (this.change = he - re))
                : this.format(he, re),
              (this.value = this.begin + this.unit),
              (this.start = Ne()),
              G.autoplay !== !1 && this.play();
          }),
            (l.play = function () {
              this.active ||
                (this.start || (this.start = Ne()),
                (this.active = !0),
                E(this));
            }),
            (l.stop = function () {
              this.active && ((this.active = !1), m(this));
            }),
            (l.render = function (G) {
              var te,
                re = G - this.start;
              if (this.delay) {
                if (re <= this.delay) return;
                re -= this.delay;
              }
              if (re < this.duration) {
                var he = this.ease(re, 0, 1, this.duration);
                return (
                  (te = this.startRGB
                    ? S(this.startRGB, this.endRGB, he)
                    : w(this.begin + he * this.change)),
                  (this.value = te + this.unit),
                  void this.update.call(this.context, this.value)
                );
              }
              (te = this.endHex || this.begin + this.change),
                (this.value = te + this.unit),
                this.update.call(this.context, this.value),
                this.complete.call(this.context),
                this.destroy();
            }),
            (l.format = function (G, te) {
              if (((te += ""), (G += ""), G.charAt(0) == "#"))
                return (
                  (this.startRGB = n(te)),
                  (this.endRGB = n(G)),
                  (this.endHex = G),
                  (this.begin = 0),
                  void (this.change = 1)
                );
              if (!this.unit) {
                var re = te.replace(A, ""),
                  he = G.replace(A, "");
                re !== he && s("tween", te, G), (this.unit = re);
              }
              (te = parseFloat(te)),
                (G = parseFloat(G)),
                (this.begin = this.value = te),
                (this.change = G - te);
            }),
            (l.destroy = function () {
              this.stop(),
                (this.context = null),
                (this.ease = this.update = this.complete = i);
            });
          var $ = [],
            le = 1e3;
        }),
        ht = d(Ct, function (l) {
          (l.init = function (E) {
            (this.duration = E.duration || 0),
              (this.complete = E.complete || i),
              (this.context = E.context),
              this.play();
          }),
            (l.render = function (E) {
              var _ = E - this.start;
              _ < this.duration ||
                (this.complete.call(this.context), this.destroy());
            });
        }),
        mr = d(Ct, function (l, E) {
          (l.init = function (_) {
            (this.context = _.context),
              (this.update = _.update),
              (this.tweens = []),
              (this.current = _.current);
            var m, w;
            for (m in _.values)
              (w = _.values[m]),
                this.current[m] !== w &&
                  this.tweens.push(
                    new Ct({
                      name: m,
                      from: this.current[m],
                      to: w,
                      duration: _.duration,
                      delay: _.delay,
                      ease: _.ease,
                      autoplay: !1,
                    }),
                  );
            this.play();
          }),
            (l.render = function (_) {
              var m,
                w,
                S = this.tweens.length,
                H = !1;
              for (m = S; m--; )
                (w = this.tweens[m]),
                  w.context &&
                    (w.render(_), (this.current[w.name] = w.value), (H = !0));
              return H
                ? void (this.update && this.update.call(this.context))
                : this.destroy();
            }),
            (l.destroy = function () {
              if ((E.destroy.call(this), this.tweens)) {
                var _,
                  m = this.tweens.length;
                for (_ = m; _--; ) this.tweens[_].destroy();
                (this.tweens = null), (this.current = null);
              }
            });
        }),
        ce = (t.config = {
          debug: !1,
          defaultUnit: "px",
          defaultAngle: "deg",
          keepInherited: !1,
          hideBackface: !1,
          perspective: "",
          fallback: !D.transition,
          agentTests: [],
        });
      (t.fallback = function (l) {
        if (!D.transition) return (ce.fallback = !0);
        ce.agentTests.push("(" + l + ")");
        var E = new RegExp(ce.agentTests.join("|"), "i");
        ce.fallback = E.test(navigator.userAgent);
      }),
        t.fallback("6.0.[2-5] Safari"),
        (t.tween = function (l) {
          return new Ct(l);
        }),
        (t.delay = function (l, E, _) {
          return new ht({ complete: E, duration: l, context: _ });
        }),
        (e.fn.tram = function (l) {
          return t.call(null, this, l);
        });
      var v = e.style,
        X = e.css,
        B = { transform: D.transform && D.transform.css },
        V = {
          color: [Oe, q],
          background: [Oe, q, "background-color"],
          "outline-color": [Oe, q],
          "border-color": [Oe, q],
          "border-top-color": [Oe, q],
          "border-right-color": [Oe, q],
          "border-bottom-color": [Oe, q],
          "border-left-color": [Oe, q],
          "border-width": [Y, x],
          "border-top-width": [Y, x],
          "border-right-width": [Y, x],
          "border-bottom-width": [Y, x],
          "border-left-width": [Y, x],
          "border-spacing": [Y, x],
          "letter-spacing": [Y, x],
          margin: [Y, x],
          "margin-top": [Y, x],
          "margin-right": [Y, x],
          "margin-bottom": [Y, x],
          "margin-left": [Y, x],
          padding: [Y, x],
          "padding-top": [Y, x],
          "padding-right": [Y, x],
          "padding-bottom": [Y, x],
          "padding-left": [Y, x],
          "outline-width": [Y, x],
          opacity: [Y, T],
          top: [Y, N],
          right: [Y, N],
          bottom: [Y, N],
          left: [Y, N],
          "font-size": [Y, N],
          "text-indent": [Y, N],
          "word-spacing": [Y, N],
          width: [Y, N],
          "min-width": [Y, N],
          "max-width": [Y, N],
          height: [Y, N],
          "min-height": [Y, N],
          "max-height": [Y, N],
          "line-height": [Y, U],
          "scroll-top": [wt, T, "scrollTop"],
          "scroll-left": [wt, T, "scrollLeft"],
        },
        fe = {};
      D.transform &&
        ((V.transform = [Ht]),
        (fe = {
          x: [N, "translateX"],
          y: [N, "translateY"],
          rotate: [F],
          rotateX: [F],
          rotateY: [F],
          scale: [T],
          scaleX: [T],
          scaleY: [T],
          skew: [F],
          skewX: [F],
          skewY: [F],
        })),
        D.transform &&
          D.backface &&
          ((fe.z = [N, "translateZ"]),
          (fe.rotateZ = [F]),
          (fe.scaleZ = [T]),
          (fe.perspective = [x]));
      var Or = /ms/,
        Nt = /s|\./;
      return (e.tram = t);
    })(window.jQuery);
  });
  var Os = u((AB, ms) => {
    var lI = window.$,
      fI = Fi() && lI.tram;
    ms.exports = (function () {
      var e = {};
      e.VERSION = "1.6.0-Webflow";
      var t = {},
        r = Array.prototype,
        n = Object.prototype,
        o = Function.prototype,
        i = r.push,
        a = r.slice,
        s = r.concat,
        c = n.toString,
        f = n.hasOwnProperty,
        p = r.forEach,
        d = r.map,
        h = r.reduce,
        g = r.reduceRight,
        O = r.filter,
        I = r.every,
        C = r.some,
        A = r.indexOf,
        R = r.lastIndexOf,
        T = Array.isArray,
        q = Object.keys,
        x = o.bind,
        N =
          (e.each =
          e.forEach =
            function (y, P, M) {
              if (y == null) return y;
              if (p && y.forEach === p) y.forEach(P, M);
              else if (y.length === +y.length) {
                for (var D = 0, j = y.length; D < j; D++)
                  if (P.call(M, y[D], D, y) === t) return;
              } else
                for (var z = e.keys(y), D = 0, j = z.length; D < j; D++)
                  if (P.call(M, y[z[D]], z[D], y) === t) return;
              return y;
            });
      (e.map = e.collect =
        function (y, P, M) {
          var D = [];
          return y == null
            ? D
            : d && y.map === d
            ? y.map(P, M)
            : (N(y, function (j, z, ie) {
                D.push(P.call(M, j, z, ie));
              }),
              D);
        }),
        (e.find = e.detect =
          function (y, P, M) {
            var D;
            return (
              F(y, function (j, z, ie) {
                if (P.call(M, j, z, ie)) return (D = j), !0;
              }),
              D
            );
          }),
        (e.filter = e.select =
          function (y, P, M) {
            var D = [];
            return y == null
              ? D
              : O && y.filter === O
              ? y.filter(P, M)
              : (N(y, function (j, z, ie) {
                  P.call(M, j, z, ie) && D.push(j);
                }),
                D);
          });
      var F =
        (e.some =
        e.any =
          function (y, P, M) {
            P || (P = e.identity);
            var D = !1;
            return y == null
              ? D
              : C && y.some === C
              ? y.some(P, M)
              : (N(y, function (j, z, ie) {
                  if (D || (D = P.call(M, j, z, ie))) return t;
                }),
                !!D);
          });
      (e.contains = e.include =
        function (y, P) {
          return y == null
            ? !1
            : A && y.indexOf === A
            ? y.indexOf(P) != -1
            : F(y, function (M) {
                return M === P;
              });
        }),
        (e.delay = function (y, P) {
          var M = a.call(arguments, 2);
          return setTimeout(function () {
            return y.apply(null, M);
          }, P);
        }),
        (e.defer = function (y) {
          return e.delay.apply(e, [y, 1].concat(a.call(arguments, 1)));
        }),
        (e.throttle = function (y) {
          var P, M, D;
          return function () {
            P ||
              ((P = !0),
              (M = arguments),
              (D = this),
              fI.frame(function () {
                (P = !1), y.apply(D, M);
              }));
          };
        }),
        (e.debounce = function (y, P, M) {
          var D,
            j,
            z,
            ie,
            Ne,
            Ve = function () {
              var me = e.now() - ie;
              me < P
                ? (D = setTimeout(Ve, P - me))
                : ((D = null), M || ((Ne = y.apply(z, j)), (z = j = null)));
            };
          return function () {
            (z = this), (j = arguments), (ie = e.now());
            var me = M && !D;
            return (
              D || (D = setTimeout(Ve, P)),
              me && ((Ne = y.apply(z, j)), (z = j = null)),
              Ne
            );
          };
        }),
        (e.defaults = function (y) {
          if (!e.isObject(y)) return y;
          for (var P = 1, M = arguments.length; P < M; P++) {
            var D = arguments[P];
            for (var j in D) y[j] === void 0 && (y[j] = D[j]);
          }
          return y;
        }),
        (e.keys = function (y) {
          if (!e.isObject(y)) return [];
          if (q) return q(y);
          var P = [];
          for (var M in y) e.has(y, M) && P.push(M);
          return P;
        }),
        (e.has = function (y, P) {
          return f.call(y, P);
        }),
        (e.isObject = function (y) {
          return y === Object(y);
        }),
        (e.now =
          Date.now ||
          function () {
            return new Date().getTime();
          }),
        (e.templateSettings = {
          evaluate: /<%([\s\S]+?)%>/g,
          interpolate: /<%=([\s\S]+?)%>/g,
          escape: /<%-([\s\S]+?)%>/g,
        });
      var U = /(.)^/,
        W = {
          "'": "'",
          "\\": "\\",
          "\r": "r",
          "\n": "n",
          "\u2028": "u2028",
          "\u2029": "u2029",
        },
        ee = /\\|'|\r|\n|\u2028|\u2029/g,
        K = function (y) {
          return "\\" + W[y];
        },
        L = /^\s*(\w|\$)+\s*$/;
      return (
        (e.template = function (y, P, M) {
          !P && M && (P = M), (P = e.defaults({}, P, e.templateSettings));
          var D = RegExp(
              [
                (P.escape || U).source,
                (P.interpolate || U).source,
                (P.evaluate || U).source,
              ].join("|") + "|$",
              "g",
            ),
            j = 0,
            z = "__p+='";
          y.replace(D, function (me, Y, Oe, wt, Ht) {
            return (
              (z += y.slice(j, Ht).replace(ee, K)),
              (j = Ht + me.length),
              Y
                ? (z +=
                    `'+
((__t=(` +
                    Y +
                    `))==null?'':_.escape(__t))+
'`)
                : Oe
                ? (z +=
                    `'+
((__t=(` +
                    Oe +
                    `))==null?'':__t)+
'`)
                : wt &&
                  (z +=
                    `';
` +
                    wt +
                    `
__p+='`),
              me
            );
          }),
            (z += `';
`);
          var ie = P.variable;
          if (ie) {
            if (!L.test(ie))
              throw new Error("variable is not a bare identifier: " + ie);
          } else
            (z =
              `with(obj||{}){
` +
              z +
              `}
`),
              (ie = "obj");
          z =
            `var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
` +
            z +
            `return __p;
`;
          var Ne;
          try {
            Ne = new Function(P.variable || "obj", "_", z);
          } catch (me) {
            throw ((me.source = z), me);
          }
          var Ve = function (me) {
            return Ne.call(this, me, e);
          };
          return (
            (Ve.source =
              "function(" +
              ie +
              `){
` +
              z +
              "}"),
            Ve
          );
        }),
        e
      );
    })();
  });
  var lt = u((SB, Ps) => {
    var ae = {},
      jt = {},
      kt = [],
      Xi = window.Webflow || [],
      gt = window.jQuery,
      ke = gt(window),
      dI = gt(document),
      tt = gt.isFunction,
      je = (ae._ = Os()),
      As = (ae.tram = Fi() && gt.tram),
      cn = !1,
      Vi = !1;
    As.config.hideBackface = !1;
    As.config.keepInherited = !0;
    ae.define = function (e, t, r) {
      jt[e] && Rs(jt[e]);
      var n = (jt[e] = t(gt, je, r) || {});
      return Ss(n), n;
    };
    ae.require = function (e) {
      return jt[e];
    };
    function Ss(e) {
      ae.env() &&
        (tt(e.design) && ke.on("__wf_design", e.design),
        tt(e.preview) && ke.on("__wf_preview", e.preview)),
        tt(e.destroy) && ke.on("__wf_destroy", e.destroy),
        e.ready && tt(e.ready) && pI(e);
    }
    function pI(e) {
      if (cn) {
        e.ready();
        return;
      }
      je.contains(kt, e.ready) || kt.push(e.ready);
    }
    function Rs(e) {
      tt(e.design) && ke.off("__wf_design", e.design),
        tt(e.preview) && ke.off("__wf_preview", e.preview),
        tt(e.destroy) && ke.off("__wf_destroy", e.destroy),
        e.ready && tt(e.ready) && vI(e);
    }
    function vI(e) {
      kt = je.filter(kt, function (t) {
        return t !== e.ready;
      });
    }
    ae.push = function (e) {
      if (cn) {
        tt(e) && e();
        return;
      }
      Xi.push(e);
    };
    ae.env = function (e) {
      var t = window.__wf_design,
        r = typeof t < "u";
      if (!e) return r;
      if (e === "design") return r && t;
      if (e === "preview") return r && !t;
      if (e === "slug") return r && window.__wf_slug;
      if (e === "editor") return window.WebflowEditor;
      if (e === "test") return window.__wf_test;
      if (e === "frame") return window !== window.top;
    };
    var un = navigator.userAgent.toLowerCase(),
      ws = (ae.env.touch =
        "ontouchstart" in window ||
        (window.DocumentTouch && document instanceof window.DocumentTouch)),
      EI = (ae.env.chrome =
        /chrome/.test(un) &&
        /Google/.test(navigator.vendor) &&
        parseInt(un.match(/chrome\/(\d+)\./)[1], 10)),
      hI = (ae.env.ios = /(ipod|iphone|ipad)/.test(un));
    ae.env.safari = /safari/.test(un) && !EI && !hI;
    var Gi;
    ws &&
      dI.on("touchstart mousedown", function (e) {
        Gi = e.target;
      });
    ae.validClick = ws
      ? function (e) {
          return e === Gi || gt.contains(e, Gi);
        }
      : function () {
          return !0;
        };
    var Cs = "resize.webflow orientationchange.webflow load.webflow",
      gI = "scroll.webflow " + Cs;
    ae.resize = Ui(ke, Cs);
    ae.scroll = Ui(ke, gI);
    ae.redraw = Ui();
    function Ui(e, t) {
      var r = [],
        n = {};
      return (
        (n.up = je.throttle(function (o) {
          je.each(r, function (i) {
            i(o);
          });
        })),
        e && t && e.on(t, n.up),
        (n.on = function (o) {
          typeof o == "function" && (je.contains(r, o) || r.push(o));
        }),
        (n.off = function (o) {
          if (!arguments.length) {
            r = [];
            return;
          }
          r = je.filter(r, function (i) {
            return i !== o;
          });
        }),
        n
      );
    }
    ae.location = function (e) {
      window.location = e;
    };
    ae.env() && (ae.location = function () {});
    ae.ready = function () {
      (cn = !0), Vi ? _I() : je.each(kt, bs), je.each(Xi, bs), ae.resize.up();
    };
    function bs(e) {
      tt(e) && e();
    }
    function _I() {
      (Vi = !1), je.each(jt, Ss);
    }
    var Pt;
    ae.load = function (e) {
      Pt.then(e);
    };
    function Ns() {
      Pt && (Pt.reject(), ke.off("load", Pt.resolve)),
        (Pt = new gt.Deferred()),
        ke.on("load", Pt.resolve);
    }
    ae.destroy = function (e) {
      (e = e || {}),
        (Vi = !0),
        ke.triggerHandler("__wf_destroy"),
        e.domready != null && (cn = e.domready),
        je.each(jt, Rs),
        ae.resize.off(),
        ae.scroll.off(),
        ae.redraw.off(),
        (kt = []),
        (Xi = []),
        Pt.state() === "pending" && Ns();
    };
    gt(ae.ready);
    Ns();
    Ps.exports = window.Webflow = ae;
  });
  var xs = u((RB, Ls) => {
    var qs = lt();
    qs.define(
      "brand",
      (Ls.exports = function (e) {
        var t = {},
          r = document,
          n = e("html"),
          o = e("body"),
          i = ".w-webflow-badge",
          a = window.location,
          s = /PhantomJS/i.test(navigator.userAgent),
          c =
            "fullscreenchange webkitfullscreenchange mozfullscreenchange msfullscreenchange",
          f;
        t.ready = function () {
          var g = n.attr("data-wf-status"),
            O = n.attr("data-wf-domain") || "";
          /\.webflow\.io$/i.test(O) && a.hostname !== O && (g = !0),
            g &&
              !s &&
              ((f = f || d()),
              h(),
              setTimeout(h, 500),
              e(r).off(c, p).on(c, p));
        };
        function p() {
          var g =
            r.fullScreen ||
            r.mozFullScreen ||
            r.webkitIsFullScreen ||
            r.msFullscreenElement ||
            !!r.webkitFullscreenElement;
          e(f).attr("style", g ? "display: none !important;" : "");
        }
        function d() {
          var g = e('<a class="w-webflow-badge"></a>').attr(
              "href",
              "https://webflow.com?utm_campaign=brandjs",
            ),
            O = e("<img>")
              .attr(
                "src",
                "https://d3e54v103j8qbb.cloudfront.net/img/webflow-badge-icon.f67cd735e3.svg",
              )
              .attr("alt", "")
              .css({ marginRight: "8px", width: "16px" }),
            I = e("<img>")
              .attr(
                "src",
                "https://d1otoma47x30pg.cloudfront.net/img/webflow-badge-text.6faa6a38cd.svg",
              )
              .attr("alt", "Made in Webflow");
          return g.append(O, I), g[0];
        }
        function h() {
          var g = o.children(i),
            O = g.length && g.get(0) === f,
            I = qs.env("editor");
          if (O) {
            I && g.remove();
            return;
          }
          g.length && g.remove(), I || o.append(f);
        }
        return t;
      }),
    );
  });
  var Ds = u((wB, Ms) => {
    var yI = lt();
    yI.define(
      "focus-visible",
      (Ms.exports = function () {
        function e(r) {
          var n = !0,
            o = !1,
            i = null,
            a = {
              text: !0,
              search: !0,
              url: !0,
              tel: !0,
              email: !0,
              password: !0,
              number: !0,
              date: !0,
              month: !0,
              week: !0,
              time: !0,
              datetime: !0,
              "datetime-local": !0,
            };
          function s(T) {
            return !!(
              T &&
              T !== document &&
              T.nodeName !== "HTML" &&
              T.nodeName !== "BODY" &&
              "classList" in T &&
              "contains" in T.classList
            );
          }
          function c(T) {
            var q = T.type,
              x = T.tagName;
            return !!(
              (x === "INPUT" && a[q] && !T.readOnly) ||
              (x === "TEXTAREA" && !T.readOnly) ||
              T.isContentEditable
            );
          }
          function f(T) {
            T.getAttribute("data-wf-focus-visible") ||
              T.setAttribute("data-wf-focus-visible", "true");
          }
          function p(T) {
            T.getAttribute("data-wf-focus-visible") &&
              T.removeAttribute("data-wf-focus-visible");
          }
          function d(T) {
            T.metaKey ||
              T.altKey ||
              T.ctrlKey ||
              (s(r.activeElement) && f(r.activeElement), (n = !0));
          }
          function h() {
            n = !1;
          }
          function g(T) {
            s(T.target) && (n || c(T.target)) && f(T.target);
          }
          function O(T) {
            s(T.target) &&
              T.target.hasAttribute("data-wf-focus-visible") &&
              ((o = !0),
              window.clearTimeout(i),
              (i = window.setTimeout(function () {
                o = !1;
              }, 100)),
              p(T.target));
          }
          function I() {
            document.visibilityState === "hidden" && (o && (n = !0), C());
          }
          function C() {
            document.addEventListener("mousemove", R),
              document.addEventListener("mousedown", R),
              document.addEventListener("mouseup", R),
              document.addEventListener("pointermove", R),
              document.addEventListener("pointerdown", R),
              document.addEventListener("pointerup", R),
              document.addEventListener("touchmove", R),
              document.addEventListener("touchstart", R),
              document.addEventListener("touchend", R);
          }
          function A() {
            document.removeEventListener("mousemove", R),
              document.removeEventListener("mousedown", R),
              document.removeEventListener("mouseup", R),
              document.removeEventListener("pointermove", R),
              document.removeEventListener("pointerdown", R),
              document.removeEventListener("pointerup", R),
              document.removeEventListener("touchmove", R),
              document.removeEventListener("touchstart", R),
              document.removeEventListener("touchend", R);
          }
          function R(T) {
            (T.target.nodeName && T.target.nodeName.toLowerCase() === "html") ||
              ((n = !1), A());
          }
          document.addEventListener("keydown", d, !0),
            document.addEventListener("mousedown", h, !0),
            document.addEventListener("pointerdown", h, !0),
            document.addEventListener("touchstart", h, !0),
            document.addEventListener("visibilitychange", I, !0),
            C(),
            r.addEventListener("focus", g, !0),
            r.addEventListener("blur", O, !0);
        }
        function t() {
          if (typeof document < "u")
            try {
              document.querySelector(":focus-visible");
            } catch {
              e(document);
            }
        }
        return { ready: t };
      }),
    );
  });
  var Xs = u((CB, Gs) => {
    var Fs = lt();
    Fs.define(
      "focus",
      (Gs.exports = function () {
        var e = [],
          t = !1;
        function r(a) {
          t &&
            (a.preventDefault(),
            a.stopPropagation(),
            a.stopImmediatePropagation(),
            e.unshift(a));
        }
        function n(a) {
          var s = a.target,
            c = s.tagName;
          return (
            (/^a$/i.test(c) && s.href != null) ||
            (/^(button|textarea)$/i.test(c) && s.disabled !== !0) ||
            (/^input$/i.test(c) &&
              /^(button|reset|submit|radio|checkbox)$/i.test(s.type) &&
              !s.disabled) ||
            (!/^(button|input|textarea|select|a)$/i.test(c) &&
              !Number.isNaN(Number.parseFloat(s.tabIndex))) ||
            /^audio$/i.test(c) ||
            (/^video$/i.test(c) && s.controls === !0)
          );
        }
        function o(a) {
          n(a) &&
            ((t = !0),
            setTimeout(() => {
              for (t = !1, a.target.focus(); e.length > 0; ) {
                var s = e.pop();
                s.target.dispatchEvent(new MouseEvent(s.type, s));
              }
            }, 0));
        }
        function i() {
          typeof document < "u" &&
            document.body.hasAttribute("data-wf-focus-within") &&
            Fs.env.safari &&
            (document.addEventListener("mousedown", o, !0),
            document.addEventListener("mouseup", r, !0),
            document.addEventListener("click", r, !0));
        }
        return { ready: i };
      }),
    );
  });
  var Bs = u((NB, Us) => {
    "use strict";
    var Bi = window.jQuery,
      rt = {},
      ln = [],
      Vs = ".w-ix",
      fn = {
        reset: function (e, t) {
          t.__wf_intro = null;
        },
        intro: function (e, t) {
          t.__wf_intro ||
            ((t.__wf_intro = !0), Bi(t).triggerHandler(rt.types.INTRO));
        },
        outro: function (e, t) {
          t.__wf_intro &&
            ((t.__wf_intro = null), Bi(t).triggerHandler(rt.types.OUTRO));
        },
      };
    rt.triggers = {};
    rt.types = { INTRO: "w-ix-intro" + Vs, OUTRO: "w-ix-outro" + Vs };
    rt.init = function () {
      for (var e = ln.length, t = 0; t < e; t++) {
        var r = ln[t];
        r[0](0, r[1]);
      }
      (ln = []), Bi.extend(rt.triggers, fn);
    };
    rt.async = function () {
      for (var e in fn) {
        var t = fn[e];
        fn.hasOwnProperty(e) &&
          (rt.triggers[e] = function (r, n) {
            ln.push([t, n]);
          });
      }
    };
    rt.async();
    Us.exports = rt;
  });
  var Hi = u((PB, js) => {
    "use strict";
    var Wi = Bs();
    function Ws(e, t) {
      var r = document.createEvent("CustomEvent");
      r.initCustomEvent(t, !0, !0, null), e.dispatchEvent(r);
    }
    var II = window.jQuery,
      dn = {},
      Hs = ".w-ix",
      TI = {
        reset: function (e, t) {
          Wi.triggers.reset(e, t);
        },
        intro: function (e, t) {
          Wi.triggers.intro(e, t), Ws(t, "COMPONENT_ACTIVE");
        },
        outro: function (e, t) {
          Wi.triggers.outro(e, t), Ws(t, "COMPONENT_INACTIVE");
        },
      };
    dn.triggers = {};
    dn.types = { INTRO: "w-ix-intro" + Hs, OUTRO: "w-ix-outro" + Hs };
    II.extend(dn.triggers, TI);
    js.exports = dn;
  });
  var ks = u((qB, ft) => {
    function ji(e) {
      return (
        (ft.exports = ji =
          typeof Symbol == "function" && typeof Symbol.iterator == "symbol"
            ? function (t) {
                return typeof t;
              }
            : function (t) {
                return t &&
                  typeof Symbol == "function" &&
                  t.constructor === Symbol &&
                  t !== Symbol.prototype
                  ? "symbol"
                  : typeof t;
              }),
        (ft.exports.__esModule = !0),
        (ft.exports.default = ft.exports),
        ji(e)
      );
    }
    (ft.exports = ji),
      (ft.exports.__esModule = !0),
      (ft.exports.default = ft.exports);
  });
  var qt = u((LB, Ar) => {
    var mI = ks().default;
    function Ks(e) {
      if (typeof WeakMap != "function") return null;
      var t = new WeakMap(),
        r = new WeakMap();
      return (Ks = function (o) {
        return o ? r : t;
      })(e);
    }
    function OI(e, t) {
      if (!t && e && e.__esModule) return e;
      if (e === null || (mI(e) !== "object" && typeof e != "function"))
        return { default: e };
      var r = Ks(t);
      if (r && r.has(e)) return r.get(e);
      var n = {},
        o = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var i in e)
        if (i !== "default" && Object.prototype.hasOwnProperty.call(e, i)) {
          var a = o ? Object.getOwnPropertyDescriptor(e, i) : null;
          a && (a.get || a.set)
            ? Object.defineProperty(n, i, a)
            : (n[i] = e[i]);
        }
      return (n.default = e), r && r.set(e, n), n;
    }
    (Ar.exports = OI),
      (Ar.exports.__esModule = !0),
      (Ar.exports.default = Ar.exports);
  });
  var Ke = u((xB, Sr) => {
    function bI(e) {
      return e && e.__esModule ? e : { default: e };
    }
    (Sr.exports = bI),
      (Sr.exports.__esModule = !0),
      (Sr.exports.default = Sr.exports);
  });
  var de = u((MB, zs) => {
    var pn = function (e) {
      return e && e.Math == Math && e;
    };
    zs.exports =
      pn(typeof globalThis == "object" && globalThis) ||
      pn(typeof window == "object" && window) ||
      pn(typeof self == "object" && self) ||
      pn(typeof global == "object" && global) ||
      (function () {
        return this;
      })() ||
      Function("return this")();
  });
  var Kt = u((DB, Ys) => {
    Ys.exports = function (e) {
      try {
        return !!e();
      } catch {
        return !0;
      }
    };
  });
  var Lt = u((FB, $s) => {
    var AI = Kt();
    $s.exports = !AI(function () {
      return (
        Object.defineProperty({}, 1, {
          get: function () {
            return 7;
          },
        })[1] != 7
      );
    });
  });
  var vn = u((GB, Qs) => {
    var Rr = Function.prototype.call;
    Qs.exports = Rr.bind
      ? Rr.bind(Rr)
      : function () {
          return Rr.apply(Rr, arguments);
        };
  });
  var tu = u((eu) => {
    "use strict";
    var Zs = {}.propertyIsEnumerable,
      Js = Object.getOwnPropertyDescriptor,
      SI = Js && !Zs.call({ 1: 2 }, 1);
    eu.f = SI
      ? function (t) {
          var r = Js(this, t);
          return !!r && r.enumerable;
        }
      : Zs;
  });
  var ki = u((VB, ru) => {
    ru.exports = function (e, t) {
      return {
        enumerable: !(e & 1),
        configurable: !(e & 2),
        writable: !(e & 4),
        value: t,
      };
    };
  });
  var ze = u((UB, iu) => {
    var nu = Function.prototype,
      Ki = nu.bind,
      zi = nu.call,
      RI = Ki && Ki.bind(zi);
    iu.exports = Ki
      ? function (e) {
          return e && RI(zi, e);
        }
      : function (e) {
          return (
            e &&
            function () {
              return zi.apply(e, arguments);
            }
          );
        };
  });
  var su = u((BB, au) => {
    var ou = ze(),
      wI = ou({}.toString),
      CI = ou("".slice);
    au.exports = function (e) {
      return CI(wI(e), 8, -1);
    };
  });
  var cu = u((WB, uu) => {
    var NI = de(),
      PI = ze(),
      qI = Kt(),
      LI = su(),
      Yi = NI.Object,
      xI = PI("".split);
    uu.exports = qI(function () {
      return !Yi("z").propertyIsEnumerable(0);
    })
      ? function (e) {
          return LI(e) == "String" ? xI(e, "") : Yi(e);
        }
      : Yi;
  });
  var $i = u((HB, lu) => {
    var MI = de(),
      DI = MI.TypeError;
    lu.exports = function (e) {
      if (e == null) throw DI("Can't call method on " + e);
      return e;
    };
  });
  var wr = u((jB, fu) => {
    var FI = cu(),
      GI = $i();
    fu.exports = function (e) {
      return FI(GI(e));
    };
  });
  var nt = u((kB, du) => {
    du.exports = function (e) {
      return typeof e == "function";
    };
  });
  var zt = u((KB, pu) => {
    var XI = nt();
    pu.exports = function (e) {
      return typeof e == "object" ? e !== null : XI(e);
    };
  });
  var Cr = u((zB, vu) => {
    var Qi = de(),
      VI = nt(),
      UI = function (e) {
        return VI(e) ? e : void 0;
      };
    vu.exports = function (e, t) {
      return arguments.length < 2 ? UI(Qi[e]) : Qi[e] && Qi[e][t];
    };
  });
  var hu = u((YB, Eu) => {
    var BI = ze();
    Eu.exports = BI({}.isPrototypeOf);
  });
  var _u = u(($B, gu) => {
    var WI = Cr();
    gu.exports = WI("navigator", "userAgent") || "";
  });
  var Au = u((QB, bu) => {
    var Ou = de(),
      Zi = _u(),
      yu = Ou.process,
      Iu = Ou.Deno,
      Tu = (yu && yu.versions) || (Iu && Iu.version),
      mu = Tu && Tu.v8,
      Ye,
      En;
    mu &&
      ((Ye = mu.split(".")),
      (En = Ye[0] > 0 && Ye[0] < 4 ? 1 : +(Ye[0] + Ye[1])));
    !En &&
      Zi &&
      ((Ye = Zi.match(/Edge\/(\d+)/)),
      (!Ye || Ye[1] >= 74) &&
        ((Ye = Zi.match(/Chrome\/(\d+)/)), Ye && (En = +Ye[1])));
    bu.exports = En;
  });
  var Ji = u((ZB, Ru) => {
    var Su = Au(),
      HI = Kt();
    Ru.exports =
      !!Object.getOwnPropertySymbols &&
      !HI(function () {
        var e = Symbol();
        return (
          !String(e) ||
          !(Object(e) instanceof Symbol) ||
          (!Symbol.sham && Su && Su < 41)
        );
      });
  });
  var eo = u((JB, wu) => {
    var jI = Ji();
    wu.exports = jI && !Symbol.sham && typeof Symbol.iterator == "symbol";
  });
  var to = u((eW, Cu) => {
    var kI = de(),
      KI = Cr(),
      zI = nt(),
      YI = hu(),
      $I = eo(),
      QI = kI.Object;
    Cu.exports = $I
      ? function (e) {
          return typeof e == "symbol";
        }
      : function (e) {
          var t = KI("Symbol");
          return zI(t) && YI(t.prototype, QI(e));
        };
  });
  var Pu = u((tW, Nu) => {
    var ZI = de(),
      JI = ZI.String;
    Nu.exports = function (e) {
      try {
        return JI(e);
      } catch {
        return "Object";
      }
    };
  });
  var Lu = u((rW, qu) => {
    var eT = de(),
      tT = nt(),
      rT = Pu(),
      nT = eT.TypeError;
    qu.exports = function (e) {
      if (tT(e)) return e;
      throw nT(rT(e) + " is not a function");
    };
  });
  var Mu = u((nW, xu) => {
    var iT = Lu();
    xu.exports = function (e, t) {
      var r = e[t];
      return r == null ? void 0 : iT(r);
    };
  });
  var Fu = u((iW, Du) => {
    var oT = de(),
      ro = vn(),
      no = nt(),
      io = zt(),
      aT = oT.TypeError;
    Du.exports = function (e, t) {
      var r, n;
      if (
        (t === "string" && no((r = e.toString)) && !io((n = ro(r, e)))) ||
        (no((r = e.valueOf)) && !io((n = ro(r, e)))) ||
        (t !== "string" && no((r = e.toString)) && !io((n = ro(r, e))))
      )
        return n;
      throw aT("Can't convert object to primitive value");
    };
  });
  var Xu = u((oW, Gu) => {
    Gu.exports = !1;
  });
  var hn = u((aW, Uu) => {
    var Vu = de(),
      sT = Object.defineProperty;
    Uu.exports = function (e, t) {
      try {
        sT(Vu, e, { value: t, configurable: !0, writable: !0 });
      } catch {
        Vu[e] = t;
      }
      return t;
    };
  });
  var gn = u((sW, Wu) => {
    var uT = de(),
      cT = hn(),
      Bu = "__core-js_shared__",
      lT = uT[Bu] || cT(Bu, {});
    Wu.exports = lT;
  });
  var oo = u((uW, ju) => {
    var fT = Xu(),
      Hu = gn();
    (ju.exports = function (e, t) {
      return Hu[e] || (Hu[e] = t !== void 0 ? t : {});
    })("versions", []).push({
      version: "3.19.0",
      mode: fT ? "pure" : "global",
      copyright: "\xA9 2021 Denis Pushkarev (zloirock.ru)",
    });
  });
  var Ku = u((cW, ku) => {
    var dT = de(),
      pT = $i(),
      vT = dT.Object;
    ku.exports = function (e) {
      return vT(pT(e));
    };
  });
  var _t = u((lW, zu) => {
    var ET = ze(),
      hT = Ku(),
      gT = ET({}.hasOwnProperty);
    zu.exports =
      Object.hasOwn ||
      function (t, r) {
        return gT(hT(t), r);
      };
  });
  var ao = u((fW, Yu) => {
    var _T = ze(),
      yT = 0,
      IT = Math.random(),
      TT = _T((1).toString);
    Yu.exports = function (e) {
      return "Symbol(" + (e === void 0 ? "" : e) + ")_" + TT(++yT + IT, 36);
    };
  });
  var so = u((dW, ec) => {
    var mT = de(),
      OT = oo(),
      $u = _t(),
      bT = ao(),
      Qu = Ji(),
      Ju = eo(),
      Yt = OT("wks"),
      xt = mT.Symbol,
      Zu = xt && xt.for,
      AT = Ju ? xt : (xt && xt.withoutSetter) || bT;
    ec.exports = function (e) {
      if (!$u(Yt, e) || !(Qu || typeof Yt[e] == "string")) {
        var t = "Symbol." + e;
        Qu && $u(xt, e)
          ? (Yt[e] = xt[e])
          : Ju && Zu
          ? (Yt[e] = Zu(t))
          : (Yt[e] = AT(t));
      }
      return Yt[e];
    };
  });
  var ic = u((pW, nc) => {
    var ST = de(),
      RT = vn(),
      tc = zt(),
      rc = to(),
      wT = Mu(),
      CT = Fu(),
      NT = so(),
      PT = ST.TypeError,
      qT = NT("toPrimitive");
    nc.exports = function (e, t) {
      if (!tc(e) || rc(e)) return e;
      var r = wT(e, qT),
        n;
      if (r) {
        if (
          (t === void 0 && (t = "default"), (n = RT(r, e, t)), !tc(n) || rc(n))
        )
          return n;
        throw PT("Can't convert object to primitive value");
      }
      return t === void 0 && (t = "number"), CT(e, t);
    };
  });
  var uo = u((vW, oc) => {
    var LT = ic(),
      xT = to();
    oc.exports = function (e) {
      var t = LT(e, "string");
      return xT(t) ? t : t + "";
    };
  });
  var lo = u((EW, sc) => {
    var MT = de(),
      ac = zt(),
      co = MT.document,
      DT = ac(co) && ac(co.createElement);
    sc.exports = function (e) {
      return DT ? co.createElement(e) : {};
    };
  });
  var fo = u((hW, uc) => {
    var FT = Lt(),
      GT = Kt(),
      XT = lo();
    uc.exports =
      !FT &&
      !GT(function () {
        return (
          Object.defineProperty(XT("div"), "a", {
            get: function () {
              return 7;
            },
          }).a != 7
        );
      });
  });
  var po = u((lc) => {
    var VT = Lt(),
      UT = vn(),
      BT = tu(),
      WT = ki(),
      HT = wr(),
      jT = uo(),
      kT = _t(),
      KT = fo(),
      cc = Object.getOwnPropertyDescriptor;
    lc.f = VT
      ? cc
      : function (t, r) {
          if (((t = HT(t)), (r = jT(r)), KT))
            try {
              return cc(t, r);
            } catch {}
          if (kT(t, r)) return WT(!UT(BT.f, t, r), t[r]);
        };
  });
  var Nr = u((_W, dc) => {
    var fc = de(),
      zT = zt(),
      YT = fc.String,
      $T = fc.TypeError;
    dc.exports = function (e) {
      if (zT(e)) return e;
      throw $T(YT(e) + " is not an object");
    };
  });
  var Pr = u((Ec) => {
    var QT = de(),
      ZT = Lt(),
      JT = fo(),
      pc = Nr(),
      em = uo(),
      tm = QT.TypeError,
      vc = Object.defineProperty;
    Ec.f = ZT
      ? vc
      : function (t, r, n) {
          if ((pc(t), (r = em(r)), pc(n), JT))
            try {
              return vc(t, r, n);
            } catch {}
          if ("get" in n || "set" in n) throw tm("Accessors not supported");
          return "value" in n && (t[r] = n.value), t;
        };
  });
  var _n = u((IW, hc) => {
    var rm = Lt(),
      nm = Pr(),
      im = ki();
    hc.exports = rm
      ? function (e, t, r) {
          return nm.f(e, t, im(1, r));
        }
      : function (e, t, r) {
          return (e[t] = r), e;
        };
  });
  var Eo = u((TW, gc) => {
    var om = ze(),
      am = nt(),
      vo = gn(),
      sm = om(Function.toString);
    am(vo.inspectSource) ||
      (vo.inspectSource = function (e) {
        return sm(e);
      });
    gc.exports = vo.inspectSource;
  });
  var Ic = u((mW, yc) => {
    var um = de(),
      cm = nt(),
      lm = Eo(),
      _c = um.WeakMap;
    yc.exports = cm(_c) && /native code/.test(lm(_c));
  });
  var ho = u((OW, mc) => {
    var fm = oo(),
      dm = ao(),
      Tc = fm("keys");
    mc.exports = function (e) {
      return Tc[e] || (Tc[e] = dm(e));
    };
  });
  var yn = u((bW, Oc) => {
    Oc.exports = {};
  });
  var Cc = u((AW, wc) => {
    var pm = Ic(),
      Rc = de(),
      go = ze(),
      vm = zt(),
      Em = _n(),
      _o = _t(),
      yo = gn(),
      hm = ho(),
      gm = yn(),
      bc = "Object already initialized",
      To = Rc.TypeError,
      _m = Rc.WeakMap,
      In,
      qr,
      Tn,
      ym = function (e) {
        return Tn(e) ? qr(e) : In(e, {});
      },
      Im = function (e) {
        return function (t) {
          var r;
          if (!vm(t) || (r = qr(t)).type !== e)
            throw To("Incompatible receiver, " + e + " required");
          return r;
        };
      };
    pm || yo.state
      ? ((yt = yo.state || (yo.state = new _m())),
        (Ac = go(yt.get)),
        (Io = go(yt.has)),
        (Sc = go(yt.set)),
        (In = function (e, t) {
          if (Io(yt, e)) throw new To(bc);
          return (t.facade = e), Sc(yt, e, t), t;
        }),
        (qr = function (e) {
          return Ac(yt, e) || {};
        }),
        (Tn = function (e) {
          return Io(yt, e);
        }))
      : ((Mt = hm("state")),
        (gm[Mt] = !0),
        (In = function (e, t) {
          if (_o(e, Mt)) throw new To(bc);
          return (t.facade = e), Em(e, Mt, t), t;
        }),
        (qr = function (e) {
          return _o(e, Mt) ? e[Mt] : {};
        }),
        (Tn = function (e) {
          return _o(e, Mt);
        }));
    var yt, Ac, Io, Sc, Mt;
    wc.exports = { set: In, get: qr, has: Tn, enforce: ym, getterFor: Im };
  });
  var qc = u((SW, Pc) => {
    var mo = Lt(),
      Tm = _t(),
      Nc = Function.prototype,
      mm = mo && Object.getOwnPropertyDescriptor,
      Oo = Tm(Nc, "name"),
      Om = Oo && function () {}.name === "something",
      bm = Oo && (!mo || (mo && mm(Nc, "name").configurable));
    Pc.exports = { EXISTS: Oo, PROPER: Om, CONFIGURABLE: bm };
  });
  var Fc = u((RW, Dc) => {
    var Am = de(),
      Lc = nt(),
      Sm = _t(),
      xc = _n(),
      Rm = hn(),
      wm = Eo(),
      Mc = Cc(),
      Cm = qc().CONFIGURABLE,
      Nm = Mc.get,
      Pm = Mc.enforce,
      qm = String(String).split("String");
    (Dc.exports = function (e, t, r, n) {
      var o = n ? !!n.unsafe : !1,
        i = n ? !!n.enumerable : !1,
        a = n ? !!n.noTargetGet : !1,
        s = n && n.name !== void 0 ? n.name : t,
        c;
      if (
        (Lc(r) &&
          (String(s).slice(0, 7) === "Symbol(" &&
            (s = "[" + String(s).replace(/^Symbol\(([^)]*)\)/, "$1") + "]"),
          (!Sm(r, "name") || (Cm && r.name !== s)) && xc(r, "name", s),
          (c = Pm(r)),
          c.source || (c.source = qm.join(typeof s == "string" ? s : ""))),
        e === Am)
      ) {
        i ? (e[t] = r) : Rm(t, r);
        return;
      } else o ? !a && e[t] && (i = !0) : delete e[t];
      i ? (e[t] = r) : xc(e, t, r);
    })(Function.prototype, "toString", function () {
      return (Lc(this) && Nm(this).source) || wm(this);
    });
  });
  var bo = u((wW, Gc) => {
    var Lm = Math.ceil,
      xm = Math.floor;
    Gc.exports = function (e) {
      var t = +e;
      return t !== t || t === 0 ? 0 : (t > 0 ? xm : Lm)(t);
    };
  });
  var Vc = u((CW, Xc) => {
    var Mm = bo(),
      Dm = Math.max,
      Fm = Math.min;
    Xc.exports = function (e, t) {
      var r = Mm(e);
      return r < 0 ? Dm(r + t, 0) : Fm(r, t);
    };
  });
  var Bc = u((NW, Uc) => {
    var Gm = bo(),
      Xm = Math.min;
    Uc.exports = function (e) {
      return e > 0 ? Xm(Gm(e), 9007199254740991) : 0;
    };
  });
  var Hc = u((PW, Wc) => {
    var Vm = Bc();
    Wc.exports = function (e) {
      return Vm(e.length);
    };
  });
  var Ao = u((qW, kc) => {
    var Um = wr(),
      Bm = Vc(),
      Wm = Hc(),
      jc = function (e) {
        return function (t, r, n) {
          var o = Um(t),
            i = Wm(o),
            a = Bm(n, i),
            s;
          if (e && r != r) {
            for (; i > a; ) if (((s = o[a++]), s != s)) return !0;
          } else
            for (; i > a; a++)
              if ((e || a in o) && o[a] === r) return e || a || 0;
          return !e && -1;
        };
      };
    kc.exports = { includes: jc(!0), indexOf: jc(!1) };
  });
  var Ro = u((LW, zc) => {
    var Hm = ze(),
      So = _t(),
      jm = wr(),
      km = Ao().indexOf,
      Km = yn(),
      Kc = Hm([].push);
    zc.exports = function (e, t) {
      var r = jm(e),
        n = 0,
        o = [],
        i;
      for (i in r) !So(Km, i) && So(r, i) && Kc(o, i);
      for (; t.length > n; ) So(r, (i = t[n++])) && (~km(o, i) || Kc(o, i));
      return o;
    };
  });
  var mn = u((xW, Yc) => {
    Yc.exports = [
      "constructor",
      "hasOwnProperty",
      "isPrototypeOf",
      "propertyIsEnumerable",
      "toLocaleString",
      "toString",
      "valueOf",
    ];
  });
  var Qc = u(($c) => {
    var zm = Ro(),
      Ym = mn(),
      $m = Ym.concat("length", "prototype");
    $c.f =
      Object.getOwnPropertyNames ||
      function (t) {
        return zm(t, $m);
      };
  });
  var Jc = u((Zc) => {
    Zc.f = Object.getOwnPropertySymbols;
  });
  var tl = u((FW, el) => {
    var Qm = Cr(),
      Zm = ze(),
      Jm = Qc(),
      eO = Jc(),
      tO = Nr(),
      rO = Zm([].concat);
    el.exports =
      Qm("Reflect", "ownKeys") ||
      function (t) {
        var r = Jm.f(tO(t)),
          n = eO.f;
        return n ? rO(r, n(t)) : r;
      };
  });
  var nl = u((GW, rl) => {
    var nO = _t(),
      iO = tl(),
      oO = po(),
      aO = Pr();
    rl.exports = function (e, t) {
      for (var r = iO(t), n = aO.f, o = oO.f, i = 0; i < r.length; i++) {
        var a = r[i];
        nO(e, a) || n(e, a, o(t, a));
      }
    };
  });
  var ol = u((XW, il) => {
    var sO = Kt(),
      uO = nt(),
      cO = /#|\.prototype\./,
      Lr = function (e, t) {
        var r = fO[lO(e)];
        return r == pO ? !0 : r == dO ? !1 : uO(t) ? sO(t) : !!t;
      },
      lO = (Lr.normalize = function (e) {
        return String(e).replace(cO, ".").toLowerCase();
      }),
      fO = (Lr.data = {}),
      dO = (Lr.NATIVE = "N"),
      pO = (Lr.POLYFILL = "P");
    il.exports = Lr;
  });
  var sl = u((VW, al) => {
    var wo = de(),
      vO = po().f,
      EO = _n(),
      hO = Fc(),
      gO = hn(),
      _O = nl(),
      yO = ol();
    al.exports = function (e, t) {
      var r = e.target,
        n = e.global,
        o = e.stat,
        i,
        a,
        s,
        c,
        f,
        p;
      if (
        (n
          ? (a = wo)
          : o
          ? (a = wo[r] || gO(r, {}))
          : (a = (wo[r] || {}).prototype),
        a)
      )
        for (s in t) {
          if (
            ((f = t[s]),
            e.noTargetGet ? ((p = vO(a, s)), (c = p && p.value)) : (c = a[s]),
            (i = yO(n ? s : r + (o ? "." : "#") + s, e.forced)),
            !i && c !== void 0)
          ) {
            if (typeof f == typeof c) continue;
            _O(f, c);
          }
          (e.sham || (c && c.sham)) && EO(f, "sham", !0), hO(a, s, f, e);
        }
    };
  });
  var cl = u((UW, ul) => {
    var IO = Ro(),
      TO = mn();
    ul.exports =
      Object.keys ||
      function (t) {
        return IO(t, TO);
      };
  });
  var fl = u((BW, ll) => {
    var mO = Lt(),
      OO = Pr(),
      bO = Nr(),
      AO = wr(),
      SO = cl();
    ll.exports = mO
      ? Object.defineProperties
      : function (t, r) {
          bO(t);
          for (var n = AO(r), o = SO(r), i = o.length, a = 0, s; i > a; )
            OO.f(t, (s = o[a++]), n[s]);
          return t;
        };
  });
  var pl = u((WW, dl) => {
    var RO = Cr();
    dl.exports = RO("document", "documentElement");
  });
  var Tl = u((HW, Il) => {
    var wO = Nr(),
      CO = fl(),
      vl = mn(),
      NO = yn(),
      PO = pl(),
      qO = lo(),
      LO = ho(),
      El = ">",
      hl = "<",
      No = "prototype",
      Po = "script",
      _l = LO("IE_PROTO"),
      Co = function () {},
      yl = function (e) {
        return hl + Po + El + e + hl + "/" + Po + El;
      },
      gl = function (e) {
        e.write(yl("")), e.close();
        var t = e.parentWindow.Object;
        return (e = null), t;
      },
      xO = function () {
        var e = qO("iframe"),
          t = "java" + Po + ":",
          r;
        return (
          (e.style.display = "none"),
          PO.appendChild(e),
          (e.src = String(t)),
          (r = e.contentWindow.document),
          r.open(),
          r.write(yl("document.F=Object")),
          r.close(),
          r.F
        );
      },
      On,
      bn = function () {
        try {
          On = new ActiveXObject("htmlfile");
        } catch {}
        bn =
          typeof document < "u"
            ? document.domain && On
              ? gl(On)
              : xO()
            : gl(On);
        for (var e = vl.length; e--; ) delete bn[No][vl[e]];
        return bn();
      };
    NO[_l] = !0;
    Il.exports =
      Object.create ||
      function (t, r) {
        var n;
        return (
          t !== null
            ? ((Co[No] = wO(t)), (n = new Co()), (Co[No] = null), (n[_l] = t))
            : (n = bn()),
          r === void 0 ? n : CO(n, r)
        );
      };
  });
  var Ol = u((jW, ml) => {
    var MO = so(),
      DO = Tl(),
      FO = Pr(),
      qo = MO("unscopables"),
      Lo = Array.prototype;
    Lo[qo] == null && FO.f(Lo, qo, { configurable: !0, value: DO(null) });
    ml.exports = function (e) {
      Lo[qo][e] = !0;
    };
  });
  var bl = u(() => {
    "use strict";
    var GO = sl(),
      XO = Ao().includes,
      VO = Ol();
    GO(
      { target: "Array", proto: !0 },
      {
        includes: function (t) {
          return XO(this, t, arguments.length > 1 ? arguments[1] : void 0);
        },
      },
    );
    VO("includes");
  });
  var Sl = u((zW, Al) => {
    var UO = de(),
      BO = ze();
    Al.exports = function (e, t) {
      return BO(UO[e].prototype[t]);
    };
  });
  var wl = u((YW, Rl) => {
    bl();
    var WO = Sl();
    Rl.exports = WO("Array", "includes");
  });
  var Nl = u(($W, Cl) => {
    var HO = wl();
    Cl.exports = HO;
  });
  var ql = u((QW, Pl) => {
    var jO = Nl();
    Pl.exports = jO;
  });
  var xo = u((ZW, Ll) => {
    var kO =
      typeof global == "object" && global && global.Object === Object && global;
    Ll.exports = kO;
  });
  var $e = u((JW, xl) => {
    var KO = xo(),
      zO = typeof self == "object" && self && self.Object === Object && self,
      YO = KO || zO || Function("return this")();
    xl.exports = YO;
  });
  var $t = u((e5, Ml) => {
    var $O = $e(),
      QO = $O.Symbol;
    Ml.exports = QO;
  });
  var Xl = u((t5, Gl) => {
    var Dl = $t(),
      Fl = Object.prototype,
      ZO = Fl.hasOwnProperty,
      JO = Fl.toString,
      xr = Dl ? Dl.toStringTag : void 0;
    function eb(e) {
      var t = ZO.call(e, xr),
        r = e[xr];
      try {
        e[xr] = void 0;
        var n = !0;
      } catch {}
      var o = JO.call(e);
      return n && (t ? (e[xr] = r) : delete e[xr]), o;
    }
    Gl.exports = eb;
  });
  var Ul = u((r5, Vl) => {
    var tb = Object.prototype,
      rb = tb.toString;
    function nb(e) {
      return rb.call(e);
    }
    Vl.exports = nb;
  });
  var It = u((n5, Hl) => {
    var Bl = $t(),
      ib = Xl(),
      ob = Ul(),
      ab = "[object Null]",
      sb = "[object Undefined]",
      Wl = Bl ? Bl.toStringTag : void 0;
    function ub(e) {
      return e == null
        ? e === void 0
          ? sb
          : ab
        : Wl && Wl in Object(e)
        ? ib(e)
        : ob(e);
    }
    Hl.exports = ub;
  });
  var Mo = u((i5, jl) => {
    function cb(e, t) {
      return function (r) {
        return e(t(r));
      };
    }
    jl.exports = cb;
  });
  var Do = u((o5, kl) => {
    var lb = Mo(),
      fb = lb(Object.getPrototypeOf, Object);
    kl.exports = fb;
  });
  var dt = u((a5, Kl) => {
    function db(e) {
      return e != null && typeof e == "object";
    }
    Kl.exports = db;
  });
  var Fo = u((s5, Yl) => {
    var pb = It(),
      vb = Do(),
      Eb = dt(),
      hb = "[object Object]",
      gb = Function.prototype,
      _b = Object.prototype,
      zl = gb.toString,
      yb = _b.hasOwnProperty,
      Ib = zl.call(Object);
    function Tb(e) {
      if (!Eb(e) || pb(e) != hb) return !1;
      var t = vb(e);
      if (t === null) return !0;
      var r = yb.call(t, "constructor") && t.constructor;
      return typeof r == "function" && r instanceof r && zl.call(r) == Ib;
    }
    Yl.exports = Tb;
  });
  var $l = u((Go) => {
    "use strict";
    Object.defineProperty(Go, "__esModule", { value: !0 });
    Go.default = mb;
    function mb(e) {
      var t,
        r = e.Symbol;
      return (
        typeof r == "function"
          ? r.observable
            ? (t = r.observable)
            : ((t = r("observable")), (r.observable = t))
          : (t = "@@observable"),
        t
      );
    }
  });
  var Ql = u((Vo, Xo) => {
    "use strict";
    Object.defineProperty(Vo, "__esModule", { value: !0 });
    var Ob = $l(),
      bb = Ab(Ob);
    function Ab(e) {
      return e && e.__esModule ? e : { default: e };
    }
    var Qt;
    typeof self < "u"
      ? (Qt = self)
      : typeof window < "u"
      ? (Qt = window)
      : typeof global < "u"
      ? (Qt = global)
      : typeof Xo < "u"
      ? (Qt = Xo)
      : (Qt = Function("return this")());
    var Sb = (0, bb.default)(Qt);
    Vo.default = Sb;
  });
  var Uo = u((Mr) => {
    "use strict";
    Mr.__esModule = !0;
    Mr.ActionTypes = void 0;
    Mr.default = tf;
    var Rb = Fo(),
      wb = ef(Rb),
      Cb = Ql(),
      Zl = ef(Cb);
    function ef(e) {
      return e && e.__esModule ? e : { default: e };
    }
    var Jl = (Mr.ActionTypes = { INIT: "@@redux/INIT" });
    function tf(e, t, r) {
      var n;
      if (
        (typeof t == "function" && typeof r > "u" && ((r = t), (t = void 0)),
        typeof r < "u")
      ) {
        if (typeof r != "function")
          throw new Error("Expected the enhancer to be a function.");
        return r(tf)(e, t);
      }
      if (typeof e != "function")
        throw new Error("Expected the reducer to be a function.");
      var o = e,
        i = t,
        a = [],
        s = a,
        c = !1;
      function f() {
        s === a && (s = a.slice());
      }
      function p() {
        return i;
      }
      function d(I) {
        if (typeof I != "function")
          throw new Error("Expected listener to be a function.");
        var C = !0;
        return (
          f(),
          s.push(I),
          function () {
            if (C) {
              (C = !1), f();
              var R = s.indexOf(I);
              s.splice(R, 1);
            }
          }
        );
      }
      function h(I) {
        if (!(0, wb.default)(I))
          throw new Error(
            "Actions must be plain objects. Use custom middleware for async actions.",
          );
        if (typeof I.type > "u")
          throw new Error(
            'Actions may not have an undefined "type" property. Have you misspelled a constant?',
          );
        if (c) throw new Error("Reducers may not dispatch actions.");
        try {
          (c = !0), (i = o(i, I));
        } finally {
          c = !1;
        }
        for (var C = (a = s), A = 0; A < C.length; A++) C[A]();
        return I;
      }
      function g(I) {
        if (typeof I != "function")
          throw new Error("Expected the nextReducer to be a function.");
        (o = I), h({ type: Jl.INIT });
      }
      function O() {
        var I,
          C = d;
        return (
          (I = {
            subscribe: function (R) {
              if (typeof R != "object")
                throw new TypeError("Expected the observer to be an object.");
              function T() {
                R.next && R.next(p());
              }
              T();
              var q = C(T);
              return { unsubscribe: q };
            },
          }),
          (I[Zl.default] = function () {
            return this;
          }),
          I
        );
      }
      return (
        h({ type: Jl.INIT }),
        (n = { dispatch: h, subscribe: d, getState: p, replaceReducer: g }),
        (n[Zl.default] = O),
        n
      );
    }
  });
  var Wo = u((Bo) => {
    "use strict";
    Bo.__esModule = !0;
    Bo.default = Nb;
    function Nb(e) {
      typeof console < "u" &&
        typeof console.error == "function" &&
        console.error(e);
      try {
        throw new Error(e);
      } catch {}
    }
  });
  var of = u((Ho) => {
    "use strict";
    Ho.__esModule = !0;
    Ho.default = Mb;
    var rf = Uo(),
      Pb = Fo(),
      f5 = nf(Pb),
      qb = Wo(),
      d5 = nf(qb);
    function nf(e) {
      return e && e.__esModule ? e : { default: e };
    }
    function Lb(e, t) {
      var r = t && t.type,
        n = (r && '"' + r.toString() + '"') || "an action";
      return (
        "Given action " +
        n +
        ', reducer "' +
        e +
        '" returned undefined. To ignore an action, you must explicitly return the previous state.'
      );
    }
    function xb(e) {
      Object.keys(e).forEach(function (t) {
        var r = e[t],
          n = r(void 0, { type: rf.ActionTypes.INIT });
        if (typeof n > "u")
          throw new Error(
            'Reducer "' +
              t +
              '" returned undefined during initialization. If the state passed to the reducer is undefined, you must explicitly return the initial state. The initial state may not be undefined.',
          );
        var o =
          "@@redux/PROBE_UNKNOWN_ACTION_" +
          Math.random().toString(36).substring(7).split("").join(".");
        if (typeof r(void 0, { type: o }) > "u")
          throw new Error(
            'Reducer "' +
              t +
              '" returned undefined when probed with a random type. ' +
              ("Don't try to handle " +
                rf.ActionTypes.INIT +
                ' or other actions in "redux/*" ') +
              "namespace. They are considered private. Instead, you must return the current state for any unknown actions, unless it is undefined, in which case you must return the initial state, regardless of the action type. The initial state may not be undefined.",
          );
      });
    }
    function Mb(e) {
      for (var t = Object.keys(e), r = {}, n = 0; n < t.length; n++) {
        var o = t[n];
        typeof e[o] == "function" && (r[o] = e[o]);
      }
      var i = Object.keys(r);
      if (!1) var a;
      var s;
      try {
        xb(r);
      } catch (c) {
        s = c;
      }
      return function () {
        var f =
            arguments.length <= 0 || arguments[0] === void 0
              ? {}
              : arguments[0],
          p = arguments[1];
        if (s) throw s;
        if (!1) var d;
        for (var h = !1, g = {}, O = 0; O < i.length; O++) {
          var I = i[O],
            C = r[I],
            A = f[I],
            R = C(A, p);
          if (typeof R > "u") {
            var T = Lb(I, p);
            throw new Error(T);
          }
          (g[I] = R), (h = h || R !== A);
        }
        return h ? g : f;
      };
    }
  });
  var sf = u((jo) => {
    "use strict";
    jo.__esModule = !0;
    jo.default = Db;
    function af(e, t) {
      return function () {
        return t(e.apply(void 0, arguments));
      };
    }
    function Db(e, t) {
      if (typeof e == "function") return af(e, t);
      if (typeof e != "object" || e === null)
        throw new Error(
          "bindActionCreators expected an object or a function, instead received " +
            (e === null ? "null" : typeof e) +
            '. Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?',
        );
      for (var r = Object.keys(e), n = {}, o = 0; o < r.length; o++) {
        var i = r[o],
          a = e[i];
        typeof a == "function" && (n[i] = af(a, t));
      }
      return n;
    }
  });
  var Ko = u((ko) => {
    "use strict";
    ko.__esModule = !0;
    ko.default = Fb;
    function Fb() {
      for (var e = arguments.length, t = Array(e), r = 0; r < e; r++)
        t[r] = arguments[r];
      if (t.length === 0)
        return function (i) {
          return i;
        };
      if (t.length === 1) return t[0];
      var n = t[t.length - 1],
        o = t.slice(0, -1);
      return function () {
        return o.reduceRight(
          function (i, a) {
            return a(i);
          },
          n.apply(void 0, arguments),
        );
      };
    }
  });
  var uf = u((zo) => {
    "use strict";
    zo.__esModule = !0;
    var Gb =
      Object.assign ||
      function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];
          for (var n in r)
            Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
        }
        return e;
      };
    zo.default = Bb;
    var Xb = Ko(),
      Vb = Ub(Xb);
    function Ub(e) {
      return e && e.__esModule ? e : { default: e };
    }
    function Bb() {
      for (var e = arguments.length, t = Array(e), r = 0; r < e; r++)
        t[r] = arguments[r];
      return function (n) {
        return function (o, i, a) {
          var s = n(o, i, a),
            c = s.dispatch,
            f = [],
            p = {
              getState: s.getState,
              dispatch: function (h) {
                return c(h);
              },
            };
          return (
            (f = t.map(function (d) {
              return d(p);
            })),
            (c = Vb.default.apply(void 0, f)(s.dispatch)),
            Gb({}, s, { dispatch: c })
          );
        };
      };
    }
  });
  var Yo = u((Ue) => {
    "use strict";
    Ue.__esModule = !0;
    Ue.compose =
      Ue.applyMiddleware =
      Ue.bindActionCreators =
      Ue.combineReducers =
      Ue.createStore =
        void 0;
    var Wb = Uo(),
      Hb = Zt(Wb),
      jb = of(),
      kb = Zt(jb),
      Kb = sf(),
      zb = Zt(Kb),
      Yb = uf(),
      $b = Zt(Yb),
      Qb = Ko(),
      Zb = Zt(Qb),
      Jb = Wo(),
      g5 = Zt(Jb);
    function Zt(e) {
      return e && e.__esModule ? e : { default: e };
    }
    Ue.createStore = Hb.default;
    Ue.combineReducers = kb.default;
    Ue.bindActionCreators = zb.default;
    Ue.applyMiddleware = $b.default;
    Ue.compose = Zb.default;
  });
  var cf = u((be) => {
    "use strict";
    Object.defineProperty(be, "__esModule", { value: !0 });
    be.QuickEffectIds =
      be.QuickEffectDirectionConsts =
      be.EventTypeConsts =
      be.EventLimitAffectedElements =
      be.EventContinuousMouseAxes =
      be.EventBasedOn =
      be.EventAppliesTo =
        void 0;
    var eA = {
      NAVBAR_OPEN: "NAVBAR_OPEN",
      NAVBAR_CLOSE: "NAVBAR_CLOSE",
      TAB_ACTIVE: "TAB_ACTIVE",
      TAB_INACTIVE: "TAB_INACTIVE",
      SLIDER_ACTIVE: "SLIDER_ACTIVE",
      SLIDER_INACTIVE: "SLIDER_INACTIVE",
      DROPDOWN_OPEN: "DROPDOWN_OPEN",
      DROPDOWN_CLOSE: "DROPDOWN_CLOSE",
      MOUSE_CLICK: "MOUSE_CLICK",
      MOUSE_SECOND_CLICK: "MOUSE_SECOND_CLICK",
      MOUSE_DOWN: "MOUSE_DOWN",
      MOUSE_UP: "MOUSE_UP",
      MOUSE_OVER: "MOUSE_OVER",
      MOUSE_OUT: "MOUSE_OUT",
      MOUSE_MOVE: "MOUSE_MOVE",
      MOUSE_MOVE_IN_VIEWPORT: "MOUSE_MOVE_IN_VIEWPORT",
      SCROLL_INTO_VIEW: "SCROLL_INTO_VIEW",
      SCROLL_OUT_OF_VIEW: "SCROLL_OUT_OF_VIEW",
      SCROLLING_IN_VIEW: "SCROLLING_IN_VIEW",
      ECOMMERCE_CART_OPEN: "ECOMMERCE_CART_OPEN",
      ECOMMERCE_CART_CLOSE: "ECOMMERCE_CART_CLOSE",
      PAGE_START: "PAGE_START",
      PAGE_FINISH: "PAGE_FINISH",
      PAGE_SCROLL_UP: "PAGE_SCROLL_UP",
      PAGE_SCROLL_DOWN: "PAGE_SCROLL_DOWN",
      PAGE_SCROLL: "PAGE_SCROLL",
    };
    be.EventTypeConsts = eA;
    var tA = { ELEMENT: "ELEMENT", CLASS: "CLASS", PAGE: "PAGE" };
    be.EventAppliesTo = tA;
    var rA = { ELEMENT: "ELEMENT", VIEWPORT: "VIEWPORT" };
    be.EventBasedOn = rA;
    var nA = { X_AXIS: "X_AXIS", Y_AXIS: "Y_AXIS" };
    be.EventContinuousMouseAxes = nA;
    var iA = {
      CHILDREN: "CHILDREN",
      SIBLINGS: "SIBLINGS",
      IMMEDIATE_CHILDREN: "IMMEDIATE_CHILDREN",
    };
    be.EventLimitAffectedElements = iA;
    var oA = {
      FADE_EFFECT: "FADE_EFFECT",
      SLIDE_EFFECT: "SLIDE_EFFECT",
      GROW_EFFECT: "GROW_EFFECT",
      SHRINK_EFFECT: "SHRINK_EFFECT",
      SPIN_EFFECT: "SPIN_EFFECT",
      FLY_EFFECT: "FLY_EFFECT",
      POP_EFFECT: "POP_EFFECT",
      FLIP_EFFECT: "FLIP_EFFECT",
      JIGGLE_EFFECT: "JIGGLE_EFFECT",
      PULSE_EFFECT: "PULSE_EFFECT",
      DROP_EFFECT: "DROP_EFFECT",
      BLINK_EFFECT: "BLINK_EFFECT",
      BOUNCE_EFFECT: "BOUNCE_EFFECT",
      FLIP_LEFT_TO_RIGHT_EFFECT: "FLIP_LEFT_TO_RIGHT_EFFECT",
      FLIP_RIGHT_TO_LEFT_EFFECT: "FLIP_RIGHT_TO_LEFT_EFFECT",
      RUBBER_BAND_EFFECT: "RUBBER_BAND_EFFECT",
      JELLO_EFFECT: "JELLO_EFFECT",
      GROW_BIG_EFFECT: "GROW_BIG_EFFECT",
      SHRINK_BIG_EFFECT: "SHRINK_BIG_EFFECT",
      PLUGIN_LOTTIE_EFFECT: "PLUGIN_LOTTIE_EFFECT",
    };
    be.QuickEffectIds = oA;
    var aA = {
      LEFT: "LEFT",
      RIGHT: "RIGHT",
      BOTTOM: "BOTTOM",
      TOP: "TOP",
      BOTTOM_LEFT: "BOTTOM_LEFT",
      BOTTOM_RIGHT: "BOTTOM_RIGHT",
      TOP_RIGHT: "TOP_RIGHT",
      TOP_LEFT: "TOP_LEFT",
      CLOCKWISE: "CLOCKWISE",
      COUNTER_CLOCKWISE: "COUNTER_CLOCKWISE",
    };
    be.QuickEffectDirectionConsts = aA;
  });
  var $o = u((Jt) => {
    "use strict";
    Object.defineProperty(Jt, "__esModule", { value: !0 });
    Jt.ActionTypeConsts = Jt.ActionAppliesTo = void 0;
    var sA = {
      TRANSFORM_MOVE: "TRANSFORM_MOVE",
      TRANSFORM_SCALE: "TRANSFORM_SCALE",
      TRANSFORM_ROTATE: "TRANSFORM_ROTATE",
      TRANSFORM_SKEW: "TRANSFORM_SKEW",
      STYLE_OPACITY: "STYLE_OPACITY",
      STYLE_SIZE: "STYLE_SIZE",
      STYLE_FILTER: "STYLE_FILTER",
      STYLE_FONT_VARIATION: "STYLE_FONT_VARIATION",
      STYLE_BACKGROUND_COLOR: "STYLE_BACKGROUND_COLOR",
      STYLE_BORDER: "STYLE_BORDER",
      STYLE_TEXT_COLOR: "STYLE_TEXT_COLOR",
      OBJECT_VALUE: "OBJECT_VALUE",
      PLUGIN_LOTTIE: "PLUGIN_LOTTIE",
      PLUGIN_SPLINE: "PLUGIN_SPLINE",
      PLUGIN_VARIABLE: "PLUGIN_VARIABLE",
      GENERAL_DISPLAY: "GENERAL_DISPLAY",
      GENERAL_START_ACTION: "GENERAL_START_ACTION",
      GENERAL_CONTINUOUS_ACTION: "GENERAL_CONTINUOUS_ACTION",
      GENERAL_COMBO_CLASS: "GENERAL_COMBO_CLASS",
      GENERAL_STOP_ACTION: "GENERAL_STOP_ACTION",
      GENERAL_LOOP: "GENERAL_LOOP",
      STYLE_BOX_SHADOW: "STYLE_BOX_SHADOW",
    };
    Jt.ActionTypeConsts = sA;
    var uA = {
      ELEMENT: "ELEMENT",
      ELEMENT_CLASS: "ELEMENT_CLASS",
      TRIGGER_ELEMENT: "TRIGGER_ELEMENT",
    };
    Jt.ActionAppliesTo = uA;
  });
  var lf = u((An) => {
    "use strict";
    Object.defineProperty(An, "__esModule", { value: !0 });
    An.InteractionTypeConsts = void 0;
    var cA = {
      MOUSE_CLICK_INTERACTION: "MOUSE_CLICK_INTERACTION",
      MOUSE_HOVER_INTERACTION: "MOUSE_HOVER_INTERACTION",
      MOUSE_MOVE_INTERACTION: "MOUSE_MOVE_INTERACTION",
      SCROLL_INTO_VIEW_INTERACTION: "SCROLL_INTO_VIEW_INTERACTION",
      SCROLLING_IN_VIEW_INTERACTION: "SCROLLING_IN_VIEW_INTERACTION",
      MOUSE_MOVE_IN_VIEWPORT_INTERACTION: "MOUSE_MOVE_IN_VIEWPORT_INTERACTION",
      PAGE_IS_SCROLLING_INTERACTION: "PAGE_IS_SCROLLING_INTERACTION",
      PAGE_LOAD_INTERACTION: "PAGE_LOAD_INTERACTION",
      PAGE_SCROLLED_INTERACTION: "PAGE_SCROLLED_INTERACTION",
      NAVBAR_INTERACTION: "NAVBAR_INTERACTION",
      DROPDOWN_INTERACTION: "DROPDOWN_INTERACTION",
      ECOMMERCE_CART_INTERACTION: "ECOMMERCE_CART_INTERACTION",
      TAB_INTERACTION: "TAB_INTERACTION",
      SLIDER_INTERACTION: "SLIDER_INTERACTION",
    };
    An.InteractionTypeConsts = cA;
  });
  var ff = u((Sn) => {
    "use strict";
    Object.defineProperty(Sn, "__esModule", { value: !0 });
    Sn.ReducedMotionTypes = void 0;
    var lA = $o(),
      {
        TRANSFORM_MOVE: fA,
        TRANSFORM_SCALE: dA,
        TRANSFORM_ROTATE: pA,
        TRANSFORM_SKEW: vA,
        STYLE_SIZE: EA,
        STYLE_FILTER: hA,
        STYLE_FONT_VARIATION: gA,
      } = lA.ActionTypeConsts,
      _A = {
        [fA]: !0,
        [dA]: !0,
        [pA]: !0,
        [vA]: !0,
        [EA]: !0,
        [hA]: !0,
        [gA]: !0,
      };
    Sn.ReducedMotionTypes = _A;
  });
  var df = u((Z) => {
    "use strict";
    Object.defineProperty(Z, "__esModule", { value: !0 });
    Z.IX2_VIEWPORT_WIDTH_CHANGED =
      Z.IX2_TEST_FRAME_RENDERED =
      Z.IX2_STOP_REQUESTED =
      Z.IX2_SESSION_STOPPED =
      Z.IX2_SESSION_STARTED =
      Z.IX2_SESSION_INITIALIZED =
      Z.IX2_RAW_DATA_IMPORTED =
      Z.IX2_PREVIEW_REQUESTED =
      Z.IX2_PLAYBACK_REQUESTED =
      Z.IX2_PARAMETER_CHANGED =
      Z.IX2_MEDIA_QUERIES_DEFINED =
      Z.IX2_INSTANCE_STARTED =
      Z.IX2_INSTANCE_REMOVED =
      Z.IX2_INSTANCE_ADDED =
      Z.IX2_EVENT_STATE_CHANGED =
      Z.IX2_EVENT_LISTENER_ADDED =
      Z.IX2_ELEMENT_STATE_CHANGED =
      Z.IX2_CLEAR_REQUESTED =
      Z.IX2_ANIMATION_FRAME_CHANGED =
      Z.IX2_ACTION_LIST_PLAYBACK_CHANGED =
        void 0;
    var yA = "IX2_RAW_DATA_IMPORTED";
    Z.IX2_RAW_DATA_IMPORTED = yA;
    var IA = "IX2_SESSION_INITIALIZED";
    Z.IX2_SESSION_INITIALIZED = IA;
    var TA = "IX2_SESSION_STARTED";
    Z.IX2_SESSION_STARTED = TA;
    var mA = "IX2_SESSION_STOPPED";
    Z.IX2_SESSION_STOPPED = mA;
    var OA = "IX2_PREVIEW_REQUESTED";
    Z.IX2_PREVIEW_REQUESTED = OA;
    var bA = "IX2_PLAYBACK_REQUESTED";
    Z.IX2_PLAYBACK_REQUESTED = bA;
    var AA = "IX2_STOP_REQUESTED";
    Z.IX2_STOP_REQUESTED = AA;
    var SA = "IX2_CLEAR_REQUESTED";
    Z.IX2_CLEAR_REQUESTED = SA;
    var RA = "IX2_EVENT_LISTENER_ADDED";
    Z.IX2_EVENT_LISTENER_ADDED = RA;
    var wA = "IX2_EVENT_STATE_CHANGED";
    Z.IX2_EVENT_STATE_CHANGED = wA;
    var CA = "IX2_ANIMATION_FRAME_CHANGED";
    Z.IX2_ANIMATION_FRAME_CHANGED = CA;
    var NA = "IX2_PARAMETER_CHANGED";
    Z.IX2_PARAMETER_CHANGED = NA;
    var PA = "IX2_INSTANCE_ADDED";
    Z.IX2_INSTANCE_ADDED = PA;
    var qA = "IX2_INSTANCE_STARTED";
    Z.IX2_INSTANCE_STARTED = qA;
    var LA = "IX2_INSTANCE_REMOVED";
    Z.IX2_INSTANCE_REMOVED = LA;
    var xA = "IX2_ELEMENT_STATE_CHANGED";
    Z.IX2_ELEMENT_STATE_CHANGED = xA;
    var MA = "IX2_ACTION_LIST_PLAYBACK_CHANGED";
    Z.IX2_ACTION_LIST_PLAYBACK_CHANGED = MA;
    var DA = "IX2_VIEWPORT_WIDTH_CHANGED";
    Z.IX2_VIEWPORT_WIDTH_CHANGED = DA;
    var FA = "IX2_MEDIA_QUERIES_DEFINED";
    Z.IX2_MEDIA_QUERIES_DEFINED = FA;
    var GA = "IX2_TEST_FRAME_RENDERED";
    Z.IX2_TEST_FRAME_RENDERED = GA;
  });
  var pf = u((b) => {
    "use strict";
    Object.defineProperty(b, "__esModule", { value: !0 });
    b.W_MOD_JS =
      b.W_MOD_IX =
      b.WILL_CHANGE =
      b.WIDTH =
      b.WF_PAGE =
      b.TRANSLATE_Z =
      b.TRANSLATE_Y =
      b.TRANSLATE_X =
      b.TRANSLATE_3D =
      b.TRANSFORM =
      b.SKEW_Y =
      b.SKEW_X =
      b.SKEW =
      b.SIBLINGS =
      b.SCALE_Z =
      b.SCALE_Y =
      b.SCALE_X =
      b.SCALE_3D =
      b.ROTATE_Z =
      b.ROTATE_Y =
      b.ROTATE_X =
      b.RENDER_TRANSFORM =
      b.RENDER_STYLE =
      b.RENDER_PLUGIN =
      b.RENDER_GENERAL =
      b.PRESERVE_3D =
      b.PLAIN_OBJECT =
      b.PARENT =
      b.OPACITY =
      b.IX2_ID_DELIMITER =
      b.IMMEDIATE_CHILDREN =
      b.HTML_ELEMENT =
      b.HEIGHT =
      b.FONT_VARIATION_SETTINGS =
      b.FLEX =
      b.FILTER =
      b.DISPLAY =
      b.CONFIG_Z_VALUE =
      b.CONFIG_Z_UNIT =
      b.CONFIG_Y_VALUE =
      b.CONFIG_Y_UNIT =
      b.CONFIG_X_VALUE =
      b.CONFIG_X_UNIT =
      b.CONFIG_VALUE =
      b.CONFIG_UNIT =
      b.COMMA_DELIMITER =
      b.COLOR =
      b.COLON_DELIMITER =
      b.CHILDREN =
      b.BOUNDARY_SELECTOR =
      b.BORDER_COLOR =
      b.BAR_DELIMITER =
      b.BACKGROUND_COLOR =
      b.BACKGROUND =
      b.AUTO =
      b.ABSTRACT_NODE =
        void 0;
    var XA = "|";
    b.IX2_ID_DELIMITER = XA;
    var VA = "data-wf-page";
    b.WF_PAGE = VA;
    var UA = "w-mod-js";
    b.W_MOD_JS = UA;
    var BA = "w-mod-ix";
    b.W_MOD_IX = BA;
    var WA = ".w-dyn-item";
    b.BOUNDARY_SELECTOR = WA;
    var HA = "xValue";
    b.CONFIG_X_VALUE = HA;
    var jA = "yValue";
    b.CONFIG_Y_VALUE = jA;
    var kA = "zValue";
    b.CONFIG_Z_VALUE = kA;
    var KA = "value";
    b.CONFIG_VALUE = KA;
    var zA = "xUnit";
    b.CONFIG_X_UNIT = zA;
    var YA = "yUnit";
    b.CONFIG_Y_UNIT = YA;
    var $A = "zUnit";
    b.CONFIG_Z_UNIT = $A;
    var QA = "unit";
    b.CONFIG_UNIT = QA;
    var ZA = "transform";
    b.TRANSFORM = ZA;
    var JA = "translateX";
    b.TRANSLATE_X = JA;
    var eS = "translateY";
    b.TRANSLATE_Y = eS;
    var tS = "translateZ";
    b.TRANSLATE_Z = tS;
    var rS = "translate3d";
    b.TRANSLATE_3D = rS;
    var nS = "scaleX";
    b.SCALE_X = nS;
    var iS = "scaleY";
    b.SCALE_Y = iS;
    var oS = "scaleZ";
    b.SCALE_Z = oS;
    var aS = "scale3d";
    b.SCALE_3D = aS;
    var sS = "rotateX";
    b.ROTATE_X = sS;
    var uS = "rotateY";
    b.ROTATE_Y = uS;
    var cS = "rotateZ";
    b.ROTATE_Z = cS;
    var lS = "skew";
    b.SKEW = lS;
    var fS = "skewX";
    b.SKEW_X = fS;
    var dS = "skewY";
    b.SKEW_Y = dS;
    var pS = "opacity";
    b.OPACITY = pS;
    var vS = "filter";
    b.FILTER = vS;
    var ES = "font-variation-settings";
    b.FONT_VARIATION_SETTINGS = ES;
    var hS = "width";
    b.WIDTH = hS;
    var gS = "height";
    b.HEIGHT = gS;
    var _S = "backgroundColor";
    b.BACKGROUND_COLOR = _S;
    var yS = "background";
    b.BACKGROUND = yS;
    var IS = "borderColor";
    b.BORDER_COLOR = IS;
    var TS = "color";
    b.COLOR = TS;
    var mS = "display";
    b.DISPLAY = mS;
    var OS = "flex";
    b.FLEX = OS;
    var bS = "willChange";
    b.WILL_CHANGE = bS;
    var AS = "AUTO";
    b.AUTO = AS;
    var SS = ",";
    b.COMMA_DELIMITER = SS;
    var RS = ":";
    b.COLON_DELIMITER = RS;
    var wS = "|";
    b.BAR_DELIMITER = wS;
    var CS = "CHILDREN";
    b.CHILDREN = CS;
    var NS = "IMMEDIATE_CHILDREN";
    b.IMMEDIATE_CHILDREN = NS;
    var PS = "SIBLINGS";
    b.SIBLINGS = PS;
    var qS = "PARENT";
    b.PARENT = qS;
    var LS = "preserve-3d";
    b.PRESERVE_3D = LS;
    var xS = "HTML_ELEMENT";
    b.HTML_ELEMENT = xS;
    var MS = "PLAIN_OBJECT";
    b.PLAIN_OBJECT = MS;
    var DS = "ABSTRACT_NODE";
    b.ABSTRACT_NODE = DS;
    var FS = "RENDER_TRANSFORM";
    b.RENDER_TRANSFORM = FS;
    var GS = "RENDER_GENERAL";
    b.RENDER_GENERAL = GS;
    var XS = "RENDER_STYLE";
    b.RENDER_STYLE = XS;
    var VS = "RENDER_PLUGIN";
    b.RENDER_PLUGIN = VS;
  });
  var Fe = u((_e) => {
    "use strict";
    var vf = qt().default;
    Object.defineProperty(_e, "__esModule", { value: !0 });
    var Rn = { IX2EngineActionTypes: !0, IX2EngineConstants: !0 };
    _e.IX2EngineConstants = _e.IX2EngineActionTypes = void 0;
    var Qo = cf();
    Object.keys(Qo).forEach(function (e) {
      e === "default" ||
        e === "__esModule" ||
        Object.prototype.hasOwnProperty.call(Rn, e) ||
        (e in _e && _e[e] === Qo[e]) ||
        Object.defineProperty(_e, e, {
          enumerable: !0,
          get: function () {
            return Qo[e];
          },
        });
    });
    var Zo = $o();
    Object.keys(Zo).forEach(function (e) {
      e === "default" ||
        e === "__esModule" ||
        Object.prototype.hasOwnProperty.call(Rn, e) ||
        (e in _e && _e[e] === Zo[e]) ||
        Object.defineProperty(_e, e, {
          enumerable: !0,
          get: function () {
            return Zo[e];
          },
        });
    });
    var Jo = lf();
    Object.keys(Jo).forEach(function (e) {
      e === "default" ||
        e === "__esModule" ||
        Object.prototype.hasOwnProperty.call(Rn, e) ||
        (e in _e && _e[e] === Jo[e]) ||
        Object.defineProperty(_e, e, {
          enumerable: !0,
          get: function () {
            return Jo[e];
          },
        });
    });
    var ea = ff();
    Object.keys(ea).forEach(function (e) {
      e === "default" ||
        e === "__esModule" ||
        Object.prototype.hasOwnProperty.call(Rn, e) ||
        (e in _e && _e[e] === ea[e]) ||
        Object.defineProperty(_e, e, {
          enumerable: !0,
          get: function () {
            return ea[e];
          },
        });
    });
    var US = vf(df());
    _e.IX2EngineActionTypes = US;
    var BS = vf(pf());
    _e.IX2EngineConstants = BS;
  });
  var Ef = u((wn) => {
    "use strict";
    Object.defineProperty(wn, "__esModule", { value: !0 });
    wn.ixData = void 0;
    var WS = Fe(),
      { IX2_RAW_DATA_IMPORTED: HS } = WS.IX2EngineActionTypes,
      jS = (e = Object.freeze({}), t) => {
        switch (t.type) {
          case HS:
            return t.payload.ixData || Object.freeze({});
          default:
            return e;
        }
      };
    wn.ixData = jS;
  });
  var er = u((R5, pt) => {
    function ta() {
      return (
        (pt.exports = ta =
          Object.assign
            ? Object.assign.bind()
            : function (e) {
                for (var t = 1; t < arguments.length; t++) {
                  var r = arguments[t];
                  for (var n in r)
                    Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
                }
                return e;
              }),
        (pt.exports.__esModule = !0),
        (pt.exports.default = pt.exports),
        ta.apply(this, arguments)
      );
    }
    (pt.exports = ta),
      (pt.exports.__esModule = !0),
      (pt.exports.default = pt.exports);
  });
  var tr = u((ve) => {
    "use strict";
    Object.defineProperty(ve, "__esModule", { value: !0 });
    var kS =
      typeof Symbol == "function" && typeof Symbol.iterator == "symbol"
        ? function (e) {
            return typeof e;
          }
        : function (e) {
            return e &&
              typeof Symbol == "function" &&
              e.constructor === Symbol &&
              e !== Symbol.prototype
              ? "symbol"
              : typeof e;
          };
    ve.clone = Nn;
    ve.addLast = _f;
    ve.addFirst = yf;
    ve.removeLast = If;
    ve.removeFirst = Tf;
    ve.insert = mf;
    ve.removeAt = Of;
    ve.replaceAt = bf;
    ve.getIn = Pn;
    ve.set = qn;
    ve.setIn = Ln;
    ve.update = Sf;
    ve.updateIn = Rf;
    ve.merge = wf;
    ve.mergeDeep = Cf;
    ve.mergeIn = Nf;
    ve.omit = Pf;
    ve.addDefaults = qf;
    var hf = "INVALID_ARGS";
    function gf(e) {
      throw new Error(e);
    }
    function ra(e) {
      var t = Object.keys(e);
      return Object.getOwnPropertySymbols
        ? t.concat(Object.getOwnPropertySymbols(e))
        : t;
    }
    var KS = {}.hasOwnProperty;
    function Nn(e) {
      if (Array.isArray(e)) return e.slice();
      for (var t = ra(e), r = {}, n = 0; n < t.length; n++) {
        var o = t[n];
        r[o] = e[o];
      }
      return r;
    }
    function Ge(e, t, r) {
      var n = r;
      n == null && gf(hf);
      for (
        var o = !1, i = arguments.length, a = Array(i > 3 ? i - 3 : 0), s = 3;
        s < i;
        s++
      )
        a[s - 3] = arguments[s];
      for (var c = 0; c < a.length; c++) {
        var f = a[c];
        if (f != null) {
          var p = ra(f);
          if (p.length)
            for (var d = 0; d <= p.length; d++) {
              var h = p[d];
              if (!(e && n[h] !== void 0)) {
                var g = f[h];
                t && Cn(n[h]) && Cn(g) && (g = Ge(e, t, n[h], g)),
                  !(g === void 0 || g === n[h]) &&
                    (o || ((o = !0), (n = Nn(n))), (n[h] = g));
              }
            }
        }
      }
      return n;
    }
    function Cn(e) {
      var t = typeof e > "u" ? "undefined" : kS(e);
      return e != null && (t === "object" || t === "function");
    }
    function _f(e, t) {
      return Array.isArray(t) ? e.concat(t) : e.concat([t]);
    }
    function yf(e, t) {
      return Array.isArray(t) ? t.concat(e) : [t].concat(e);
    }
    function If(e) {
      return e.length ? e.slice(0, e.length - 1) : e;
    }
    function Tf(e) {
      return e.length ? e.slice(1) : e;
    }
    function mf(e, t, r) {
      return e
        .slice(0, t)
        .concat(Array.isArray(r) ? r : [r])
        .concat(e.slice(t));
    }
    function Of(e, t) {
      return t >= e.length || t < 0 ? e : e.slice(0, t).concat(e.slice(t + 1));
    }
    function bf(e, t, r) {
      if (e[t] === r) return e;
      for (var n = e.length, o = Array(n), i = 0; i < n; i++) o[i] = e[i];
      return (o[t] = r), o;
    }
    function Pn(e, t) {
      if ((!Array.isArray(t) && gf(hf), e != null)) {
        for (var r = e, n = 0; n < t.length; n++) {
          var o = t[n];
          if (((r = r?.[o]), r === void 0)) return r;
        }
        return r;
      }
    }
    function qn(e, t, r) {
      var n = typeof t == "number" ? [] : {},
        o = e ?? n;
      if (o[t] === r) return o;
      var i = Nn(o);
      return (i[t] = r), i;
    }
    function Af(e, t, r, n) {
      var o = void 0,
        i = t[n];
      if (n === t.length - 1) o = r;
      else {
        var a =
          Cn(e) && Cn(e[i]) ? e[i] : typeof t[n + 1] == "number" ? [] : {};
        o = Af(a, t, r, n + 1);
      }
      return qn(e, i, o);
    }
    function Ln(e, t, r) {
      return t.length ? Af(e, t, r, 0) : r;
    }
    function Sf(e, t, r) {
      var n = e?.[t],
        o = r(n);
      return qn(e, t, o);
    }
    function Rf(e, t, r) {
      var n = Pn(e, t),
        o = r(n);
      return Ln(e, t, o);
    }
    function wf(e, t, r, n, o, i) {
      for (
        var a = arguments.length, s = Array(a > 6 ? a - 6 : 0), c = 6;
        c < a;
        c++
      )
        s[c - 6] = arguments[c];
      return s.length
        ? Ge.call.apply(Ge, [null, !1, !1, e, t, r, n, o, i].concat(s))
        : Ge(!1, !1, e, t, r, n, o, i);
    }
    function Cf(e, t, r, n, o, i) {
      for (
        var a = arguments.length, s = Array(a > 6 ? a - 6 : 0), c = 6;
        c < a;
        c++
      )
        s[c - 6] = arguments[c];
      return s.length
        ? Ge.call.apply(Ge, [null, !1, !0, e, t, r, n, o, i].concat(s))
        : Ge(!1, !0, e, t, r, n, o, i);
    }
    function Nf(e, t, r, n, o, i, a) {
      var s = Pn(e, t);
      s == null && (s = {});
      for (
        var c = void 0,
          f = arguments.length,
          p = Array(f > 7 ? f - 7 : 0),
          d = 7;
        d < f;
        d++
      )
        p[d - 7] = arguments[d];
      return (
        p.length
          ? (c = Ge.call.apply(Ge, [null, !1, !1, s, r, n, o, i, a].concat(p)))
          : (c = Ge(!1, !1, s, r, n, o, i, a)),
        Ln(e, t, c)
      );
    }
    function Pf(e, t) {
      for (var r = Array.isArray(t) ? t : [t], n = !1, o = 0; o < r.length; o++)
        if (KS.call(e, r[o])) {
          n = !0;
          break;
        }
      if (!n) return e;
      for (var i = {}, a = ra(e), s = 0; s < a.length; s++) {
        var c = a[s];
        r.indexOf(c) >= 0 || (i[c] = e[c]);
      }
      return i;
    }
    function qf(e, t, r, n, o, i) {
      for (
        var a = arguments.length, s = Array(a > 6 ? a - 6 : 0), c = 6;
        c < a;
        c++
      )
        s[c - 6] = arguments[c];
      return s.length
        ? Ge.call.apply(Ge, [null, !0, !1, e, t, r, n, o, i].concat(s))
        : Ge(!0, !1, e, t, r, n, o, i);
    }
    var zS = {
      clone: Nn,
      addLast: _f,
      addFirst: yf,
      removeLast: If,
      removeFirst: Tf,
      insert: mf,
      removeAt: Of,
      replaceAt: bf,
      getIn: Pn,
      set: qn,
      setIn: Ln,
      update: Sf,
      updateIn: Rf,
      merge: wf,
      mergeDeep: Cf,
      mergeIn: Nf,
      omit: Pf,
      addDefaults: qf,
    };
    ve.default = zS;
  });
  var xf = u((xn) => {
    "use strict";
    var YS = Ke().default;
    Object.defineProperty(xn, "__esModule", { value: !0 });
    xn.ixRequest = void 0;
    var $S = YS(er()),
      QS = Fe(),
      ZS = tr(),
      {
        IX2_PREVIEW_REQUESTED: JS,
        IX2_PLAYBACK_REQUESTED: e0,
        IX2_STOP_REQUESTED: t0,
        IX2_CLEAR_REQUESTED: r0,
      } = QS.IX2EngineActionTypes,
      n0 = { preview: {}, playback: {}, stop: {}, clear: {} },
      Lf = Object.create(null, {
        [JS]: { value: "preview" },
        [e0]: { value: "playback" },
        [t0]: { value: "stop" },
        [r0]: { value: "clear" },
      }),
      i0 = (e = n0, t) => {
        if (t.type in Lf) {
          let r = [Lf[t.type]];
          return (0, ZS.setIn)(e, [r], (0, $S.default)({}, t.payload));
        }
        return e;
      };
    xn.ixRequest = i0;
  });
  var Df = u((Mn) => {
    "use strict";
    Object.defineProperty(Mn, "__esModule", { value: !0 });
    Mn.ixSession = void 0;
    var o0 = Fe(),
      it = tr(),
      {
        IX2_SESSION_INITIALIZED: a0,
        IX2_SESSION_STARTED: s0,
        IX2_TEST_FRAME_RENDERED: u0,
        IX2_SESSION_STOPPED: c0,
        IX2_EVENT_LISTENER_ADDED: l0,
        IX2_EVENT_STATE_CHANGED: f0,
        IX2_ANIMATION_FRAME_CHANGED: d0,
        IX2_ACTION_LIST_PLAYBACK_CHANGED: p0,
        IX2_VIEWPORT_WIDTH_CHANGED: v0,
        IX2_MEDIA_QUERIES_DEFINED: E0,
      } = o0.IX2EngineActionTypes,
      Mf = {
        active: !1,
        tick: 0,
        eventListeners: [],
        eventState: {},
        playbackState: {},
        viewportWidth: 0,
        mediaQueryKey: null,
        hasBoundaryNodes: !1,
        hasDefinedMediaQueries: !1,
        reducedMotion: !1,
      },
      h0 = 20,
      g0 = (e = Mf, t) => {
        switch (t.type) {
          case a0: {
            let { hasBoundaryNodes: r, reducedMotion: n } = t.payload;
            return (0, it.merge)(e, { hasBoundaryNodes: r, reducedMotion: n });
          }
          case s0:
            return (0, it.set)(e, "active", !0);
          case u0: {
            let {
              payload: { step: r = h0 },
            } = t;
            return (0, it.set)(e, "tick", e.tick + r);
          }
          case c0:
            return Mf;
          case d0: {
            let {
              payload: { now: r },
            } = t;
            return (0, it.set)(e, "tick", r);
          }
          case l0: {
            let r = (0, it.addLast)(e.eventListeners, t.payload);
            return (0, it.set)(e, "eventListeners", r);
          }
          case f0: {
            let { stateKey: r, newState: n } = t.payload;
            return (0, it.setIn)(e, ["eventState", r], n);
          }
          case p0: {
            let { actionListId: r, isPlaying: n } = t.payload;
            return (0, it.setIn)(e, ["playbackState", r], n);
          }
          case v0: {
            let { width: r, mediaQueries: n } = t.payload,
              o = n.length,
              i = null;
            for (let a = 0; a < o; a++) {
              let { key: s, min: c, max: f } = n[a];
              if (r >= c && r <= f) {
                i = s;
                break;
              }
            }
            return (0, it.merge)(e, { viewportWidth: r, mediaQueryKey: i });
          }
          case E0:
            return (0, it.set)(e, "hasDefinedMediaQueries", !0);
          default:
            return e;
        }
      };
    Mn.ixSession = g0;
  });
  var Gf = u((P5, Ff) => {
    function _0() {
      (this.__data__ = []), (this.size = 0);
    }
    Ff.exports = _0;
  });
  var Dn = u((q5, Xf) => {
    function y0(e, t) {
      return e === t || (e !== e && t !== t);
    }
    Xf.exports = y0;
  });
  var Dr = u((L5, Vf) => {
    var I0 = Dn();
    function T0(e, t) {
      for (var r = e.length; r--; ) if (I0(e[r][0], t)) return r;
      return -1;
    }
    Vf.exports = T0;
  });
  var Bf = u((x5, Uf) => {
    var m0 = Dr(),
      O0 = Array.prototype,
      b0 = O0.splice;
    function A0(e) {
      var t = this.__data__,
        r = m0(t, e);
      if (r < 0) return !1;
      var n = t.length - 1;
      return r == n ? t.pop() : b0.call(t, r, 1), --this.size, !0;
    }
    Uf.exports = A0;
  });
  var Hf = u((M5, Wf) => {
    var S0 = Dr();
    function R0(e) {
      var t = this.__data__,
        r = S0(t, e);
      return r < 0 ? void 0 : t[r][1];
    }
    Wf.exports = R0;
  });
  var kf = u((D5, jf) => {
    var w0 = Dr();
    function C0(e) {
      return w0(this.__data__, e) > -1;
    }
    jf.exports = C0;
  });
  var zf = u((F5, Kf) => {
    var N0 = Dr();
    function P0(e, t) {
      var r = this.__data__,
        n = N0(r, e);
      return n < 0 ? (++this.size, r.push([e, t])) : (r[n][1] = t), this;
    }
    Kf.exports = P0;
  });
  var Fr = u((G5, Yf) => {
    var q0 = Gf(),
      L0 = Bf(),
      x0 = Hf(),
      M0 = kf(),
      D0 = zf();
    function rr(e) {
      var t = -1,
        r = e == null ? 0 : e.length;
      for (this.clear(); ++t < r; ) {
        var n = e[t];
        this.set(n[0], n[1]);
      }
    }
    rr.prototype.clear = q0;
    rr.prototype.delete = L0;
    rr.prototype.get = x0;
    rr.prototype.has = M0;
    rr.prototype.set = D0;
    Yf.exports = rr;
  });
  var Qf = u((X5, $f) => {
    var F0 = Fr();
    function G0() {
      (this.__data__ = new F0()), (this.size = 0);
    }
    $f.exports = G0;
  });
  var Jf = u((V5, Zf) => {
    function X0(e) {
      var t = this.__data__,
        r = t.delete(e);
      return (this.size = t.size), r;
    }
    Zf.exports = X0;
  });
  var td = u((U5, ed) => {
    function V0(e) {
      return this.__data__.get(e);
    }
    ed.exports = V0;
  });
  var nd = u((B5, rd) => {
    function U0(e) {
      return this.__data__.has(e);
    }
    rd.exports = U0;
  });
  var ot = u((W5, id) => {
    function B0(e) {
      var t = typeof e;
      return e != null && (t == "object" || t == "function");
    }
    id.exports = B0;
  });
  var na = u((H5, od) => {
    var W0 = It(),
      H0 = ot(),
      j0 = "[object AsyncFunction]",
      k0 = "[object Function]",
      K0 = "[object GeneratorFunction]",
      z0 = "[object Proxy]";
    function Y0(e) {
      if (!H0(e)) return !1;
      var t = W0(e);
      return t == k0 || t == K0 || t == j0 || t == z0;
    }
    od.exports = Y0;
  });
  var sd = u((j5, ad) => {
    var $0 = $e(),
      Q0 = $0["__core-js_shared__"];
    ad.exports = Q0;
  });
  var ld = u((k5, cd) => {
    var ia = sd(),
      ud = (function () {
        var e = /[^.]+$/.exec((ia && ia.keys && ia.keys.IE_PROTO) || "");
        return e ? "Symbol(src)_1." + e : "";
      })();
    function Z0(e) {
      return !!ud && ud in e;
    }
    cd.exports = Z0;
  });
  var oa = u((K5, fd) => {
    var J0 = Function.prototype,
      eR = J0.toString;
    function tR(e) {
      if (e != null) {
        try {
          return eR.call(e);
        } catch {}
        try {
          return e + "";
        } catch {}
      }
      return "";
    }
    fd.exports = tR;
  });
  var pd = u((z5, dd) => {
    var rR = na(),
      nR = ld(),
      iR = ot(),
      oR = oa(),
      aR = /[\\^$.*+?()[\]{}|]/g,
      sR = /^\[object .+?Constructor\]$/,
      uR = Function.prototype,
      cR = Object.prototype,
      lR = uR.toString,
      fR = cR.hasOwnProperty,
      dR = RegExp(
        "^" +
          lR
            .call(fR)
            .replace(aR, "\\$&")
            .replace(
              /hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,
              "$1.*?",
            ) +
          "$",
      );
    function pR(e) {
      if (!iR(e) || nR(e)) return !1;
      var t = rR(e) ? dR : sR;
      return t.test(oR(e));
    }
    dd.exports = pR;
  });
  var Ed = u((Y5, vd) => {
    function vR(e, t) {
      return e?.[t];
    }
    vd.exports = vR;
  });
  var Tt = u(($5, hd) => {
    var ER = pd(),
      hR = Ed();
    function gR(e, t) {
      var r = hR(e, t);
      return ER(r) ? r : void 0;
    }
    hd.exports = gR;
  });
  var Fn = u((Q5, gd) => {
    var _R = Tt(),
      yR = $e(),
      IR = _R(yR, "Map");
    gd.exports = IR;
  });
  var Gr = u((Z5, _d) => {
    var TR = Tt(),
      mR = TR(Object, "create");
    _d.exports = mR;
  });
  var Td = u((J5, Id) => {
    var yd = Gr();
    function OR() {
      (this.__data__ = yd ? yd(null) : {}), (this.size = 0);
    }
    Id.exports = OR;
  });
  var Od = u((eH, md) => {
    function bR(e) {
      var t = this.has(e) && delete this.__data__[e];
      return (this.size -= t ? 1 : 0), t;
    }
    md.exports = bR;
  });
  var Ad = u((tH, bd) => {
    var AR = Gr(),
      SR = "__lodash_hash_undefined__",
      RR = Object.prototype,
      wR = RR.hasOwnProperty;
    function CR(e) {
      var t = this.__data__;
      if (AR) {
        var r = t[e];
        return r === SR ? void 0 : r;
      }
      return wR.call(t, e) ? t[e] : void 0;
    }
    bd.exports = CR;
  });
  var Rd = u((rH, Sd) => {
    var NR = Gr(),
      PR = Object.prototype,
      qR = PR.hasOwnProperty;
    function LR(e) {
      var t = this.__data__;
      return NR ? t[e] !== void 0 : qR.call(t, e);
    }
    Sd.exports = LR;
  });
  var Cd = u((nH, wd) => {
    var xR = Gr(),
      MR = "__lodash_hash_undefined__";
    function DR(e, t) {
      var r = this.__data__;
      return (
        (this.size += this.has(e) ? 0 : 1),
        (r[e] = xR && t === void 0 ? MR : t),
        this
      );
    }
    wd.exports = DR;
  });
  var Pd = u((iH, Nd) => {
    var FR = Td(),
      GR = Od(),
      XR = Ad(),
      VR = Rd(),
      UR = Cd();
    function nr(e) {
      var t = -1,
        r = e == null ? 0 : e.length;
      for (this.clear(); ++t < r; ) {
        var n = e[t];
        this.set(n[0], n[1]);
      }
    }
    nr.prototype.clear = FR;
    nr.prototype.delete = GR;
    nr.prototype.get = XR;
    nr.prototype.has = VR;
    nr.prototype.set = UR;
    Nd.exports = nr;
  });
  var xd = u((oH, Ld) => {
    var qd = Pd(),
      BR = Fr(),
      WR = Fn();
    function HR() {
      (this.size = 0),
        (this.__data__ = {
          hash: new qd(),
          map: new (WR || BR)(),
          string: new qd(),
        });
    }
    Ld.exports = HR;
  });
  var Dd = u((aH, Md) => {
    function jR(e) {
      var t = typeof e;
      return t == "string" || t == "number" || t == "symbol" || t == "boolean"
        ? e !== "__proto__"
        : e === null;
    }
    Md.exports = jR;
  });
  var Xr = u((sH, Fd) => {
    var kR = Dd();
    function KR(e, t) {
      var r = e.__data__;
      return kR(t) ? r[typeof t == "string" ? "string" : "hash"] : r.map;
    }
    Fd.exports = KR;
  });
  var Xd = u((uH, Gd) => {
    var zR = Xr();
    function YR(e) {
      var t = zR(this, e).delete(e);
      return (this.size -= t ? 1 : 0), t;
    }
    Gd.exports = YR;
  });
  var Ud = u((cH, Vd) => {
    var $R = Xr();
    function QR(e) {
      return $R(this, e).get(e);
    }
    Vd.exports = QR;
  });
  var Wd = u((lH, Bd) => {
    var ZR = Xr();
    function JR(e) {
      return ZR(this, e).has(e);
    }
    Bd.exports = JR;
  });
  var jd = u((fH, Hd) => {
    var ew = Xr();
    function tw(e, t) {
      var r = ew(this, e),
        n = r.size;
      return r.set(e, t), (this.size += r.size == n ? 0 : 1), this;
    }
    Hd.exports = tw;
  });
  var Gn = u((dH, kd) => {
    var rw = xd(),
      nw = Xd(),
      iw = Ud(),
      ow = Wd(),
      aw = jd();
    function ir(e) {
      var t = -1,
        r = e == null ? 0 : e.length;
      for (this.clear(); ++t < r; ) {
        var n = e[t];
        this.set(n[0], n[1]);
      }
    }
    ir.prototype.clear = rw;
    ir.prototype.delete = nw;
    ir.prototype.get = iw;
    ir.prototype.has = ow;
    ir.prototype.set = aw;
    kd.exports = ir;
  });
  var zd = u((pH, Kd) => {
    var sw = Fr(),
      uw = Fn(),
      cw = Gn(),
      lw = 200;
    function fw(e, t) {
      var r = this.__data__;
      if (r instanceof sw) {
        var n = r.__data__;
        if (!uw || n.length < lw - 1)
          return n.push([e, t]), (this.size = ++r.size), this;
        r = this.__data__ = new cw(n);
      }
      return r.set(e, t), (this.size = r.size), this;
    }
    Kd.exports = fw;
  });
  var aa = u((vH, Yd) => {
    var dw = Fr(),
      pw = Qf(),
      vw = Jf(),
      Ew = td(),
      hw = nd(),
      gw = zd();
    function or(e) {
      var t = (this.__data__ = new dw(e));
      this.size = t.size;
    }
    or.prototype.clear = pw;
    or.prototype.delete = vw;
    or.prototype.get = Ew;
    or.prototype.has = hw;
    or.prototype.set = gw;
    Yd.exports = or;
  });
  var Qd = u((EH, $d) => {
    var _w = "__lodash_hash_undefined__";
    function yw(e) {
      return this.__data__.set(e, _w), this;
    }
    $d.exports = yw;
  });
  var Jd = u((hH, Zd) => {
    function Iw(e) {
      return this.__data__.has(e);
    }
    Zd.exports = Iw;
  });
  var tp = u((gH, ep) => {
    var Tw = Gn(),
      mw = Qd(),
      Ow = Jd();
    function Xn(e) {
      var t = -1,
        r = e == null ? 0 : e.length;
      for (this.__data__ = new Tw(); ++t < r; ) this.add(e[t]);
    }
    Xn.prototype.add = Xn.prototype.push = mw;
    Xn.prototype.has = Ow;
    ep.exports = Xn;
  });
  var np = u((_H, rp) => {
    function bw(e, t) {
      for (var r = -1, n = e == null ? 0 : e.length; ++r < n; )
        if (t(e[r], r, e)) return !0;
      return !1;
    }
    rp.exports = bw;
  });
  var op = u((yH, ip) => {
    function Aw(e, t) {
      return e.has(t);
    }
    ip.exports = Aw;
  });
  var sa = u((IH, ap) => {
    var Sw = tp(),
      Rw = np(),
      ww = op(),
      Cw = 1,
      Nw = 2;
    function Pw(e, t, r, n, o, i) {
      var a = r & Cw,
        s = e.length,
        c = t.length;
      if (s != c && !(a && c > s)) return !1;
      var f = i.get(e),
        p = i.get(t);
      if (f && p) return f == t && p == e;
      var d = -1,
        h = !0,
        g = r & Nw ? new Sw() : void 0;
      for (i.set(e, t), i.set(t, e); ++d < s; ) {
        var O = e[d],
          I = t[d];
        if (n) var C = a ? n(I, O, d, t, e, i) : n(O, I, d, e, t, i);
        if (C !== void 0) {
          if (C) continue;
          h = !1;
          break;
        }
        if (g) {
          if (
            !Rw(t, function (A, R) {
              if (!ww(g, R) && (O === A || o(O, A, r, n, i))) return g.push(R);
            })
          ) {
            h = !1;
            break;
          }
        } else if (!(O === I || o(O, I, r, n, i))) {
          h = !1;
          break;
        }
      }
      return i.delete(e), i.delete(t), h;
    }
    ap.exports = Pw;
  });
  var up = u((TH, sp) => {
    var qw = $e(),
      Lw = qw.Uint8Array;
    sp.exports = Lw;
  });
  var lp = u((mH, cp) => {
    function xw(e) {
      var t = -1,
        r = Array(e.size);
      return (
        e.forEach(function (n, o) {
          r[++t] = [o, n];
        }),
        r
      );
    }
    cp.exports = xw;
  });
  var dp = u((OH, fp) => {
    function Mw(e) {
      var t = -1,
        r = Array(e.size);
      return (
        e.forEach(function (n) {
          r[++t] = n;
        }),
        r
      );
    }
    fp.exports = Mw;
  });
  var gp = u((bH, hp) => {
    var pp = $t(),
      vp = up(),
      Dw = Dn(),
      Fw = sa(),
      Gw = lp(),
      Xw = dp(),
      Vw = 1,
      Uw = 2,
      Bw = "[object Boolean]",
      Ww = "[object Date]",
      Hw = "[object Error]",
      jw = "[object Map]",
      kw = "[object Number]",
      Kw = "[object RegExp]",
      zw = "[object Set]",
      Yw = "[object String]",
      $w = "[object Symbol]",
      Qw = "[object ArrayBuffer]",
      Zw = "[object DataView]",
      Ep = pp ? pp.prototype : void 0,
      ua = Ep ? Ep.valueOf : void 0;
    function Jw(e, t, r, n, o, i, a) {
      switch (r) {
        case Zw:
          if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
            return !1;
          (e = e.buffer), (t = t.buffer);
        case Qw:
          return !(e.byteLength != t.byteLength || !i(new vp(e), new vp(t)));
        case Bw:
        case Ww:
        case kw:
          return Dw(+e, +t);
        case Hw:
          return e.name == t.name && e.message == t.message;
        case Kw:
        case Yw:
          return e == t + "";
        case jw:
          var s = Gw;
        case zw:
          var c = n & Vw;
          if ((s || (s = Xw), e.size != t.size && !c)) return !1;
          var f = a.get(e);
          if (f) return f == t;
          (n |= Uw), a.set(e, t);
          var p = Fw(s(e), s(t), n, o, i, a);
          return a.delete(e), p;
        case $w:
          if (ua) return ua.call(e) == ua.call(t);
      }
      return !1;
    }
    hp.exports = Jw;
  });
  var Vn = u((AH, _p) => {
    function eC(e, t) {
      for (var r = -1, n = t.length, o = e.length; ++r < n; ) e[o + r] = t[r];
      return e;
    }
    _p.exports = eC;
  });
  var Ae = u((SH, yp) => {
    var tC = Array.isArray;
    yp.exports = tC;
  });
  var ca = u((RH, Ip) => {
    var rC = Vn(),
      nC = Ae();
    function iC(e, t, r) {
      var n = t(e);
      return nC(e) ? n : rC(n, r(e));
    }
    Ip.exports = iC;
  });
  var mp = u((wH, Tp) => {
    function oC(e, t) {
      for (var r = -1, n = e == null ? 0 : e.length, o = 0, i = []; ++r < n; ) {
        var a = e[r];
        t(a, r, e) && (i[o++] = a);
      }
      return i;
    }
    Tp.exports = oC;
  });
  var la = u((CH, Op) => {
    function aC() {
      return [];
    }
    Op.exports = aC;
  });
  var fa = u((NH, Ap) => {
    var sC = mp(),
      uC = la(),
      cC = Object.prototype,
      lC = cC.propertyIsEnumerable,
      bp = Object.getOwnPropertySymbols,
      fC = bp
        ? function (e) {
            return e == null
              ? []
              : ((e = Object(e)),
                sC(bp(e), function (t) {
                  return lC.call(e, t);
                }));
          }
        : uC;
    Ap.exports = fC;
  });
  var Rp = u((PH, Sp) => {
    function dC(e, t) {
      for (var r = -1, n = Array(e); ++r < e; ) n[r] = t(r);
      return n;
    }
    Sp.exports = dC;
  });
  var Cp = u((qH, wp) => {
    var pC = It(),
      vC = dt(),
      EC = "[object Arguments]";
    function hC(e) {
      return vC(e) && pC(e) == EC;
    }
    wp.exports = hC;
  });
  var Vr = u((LH, qp) => {
    var Np = Cp(),
      gC = dt(),
      Pp = Object.prototype,
      _C = Pp.hasOwnProperty,
      yC = Pp.propertyIsEnumerable,
      IC = Np(
        (function () {
          return arguments;
        })(),
      )
        ? Np
        : function (e) {
            return gC(e) && _C.call(e, "callee") && !yC.call(e, "callee");
          };
    qp.exports = IC;
  });
  var xp = u((xH, Lp) => {
    function TC() {
      return !1;
    }
    Lp.exports = TC;
  });
  var Un = u((Ur, ar) => {
    var mC = $e(),
      OC = xp(),
      Fp = typeof Ur == "object" && Ur && !Ur.nodeType && Ur,
      Mp = Fp && typeof ar == "object" && ar && !ar.nodeType && ar,
      bC = Mp && Mp.exports === Fp,
      Dp = bC ? mC.Buffer : void 0,
      AC = Dp ? Dp.isBuffer : void 0,
      SC = AC || OC;
    ar.exports = SC;
  });
  var Bn = u((MH, Gp) => {
    var RC = 9007199254740991,
      wC = /^(?:0|[1-9]\d*)$/;
    function CC(e, t) {
      var r = typeof e;
      return (
        (t = t ?? RC),
        !!t &&
          (r == "number" || (r != "symbol" && wC.test(e))) &&
          e > -1 &&
          e % 1 == 0 &&
          e < t
      );
    }
    Gp.exports = CC;
  });
  var Wn = u((DH, Xp) => {
    var NC = 9007199254740991;
    function PC(e) {
      return typeof e == "number" && e > -1 && e % 1 == 0 && e <= NC;
    }
    Xp.exports = PC;
  });
  var Up = u((FH, Vp) => {
    var qC = It(),
      LC = Wn(),
      xC = dt(),
      MC = "[object Arguments]",
      DC = "[object Array]",
      FC = "[object Boolean]",
      GC = "[object Date]",
      XC = "[object Error]",
      VC = "[object Function]",
      UC = "[object Map]",
      BC = "[object Number]",
      WC = "[object Object]",
      HC = "[object RegExp]",
      jC = "[object Set]",
      kC = "[object String]",
      KC = "[object WeakMap]",
      zC = "[object ArrayBuffer]",
      YC = "[object DataView]",
      $C = "[object Float32Array]",
      QC = "[object Float64Array]",
      ZC = "[object Int8Array]",
      JC = "[object Int16Array]",
      eN = "[object Int32Array]",
      tN = "[object Uint8Array]",
      rN = "[object Uint8ClampedArray]",
      nN = "[object Uint16Array]",
      iN = "[object Uint32Array]",
      ue = {};
    ue[$C] =
      ue[QC] =
      ue[ZC] =
      ue[JC] =
      ue[eN] =
      ue[tN] =
      ue[rN] =
      ue[nN] =
      ue[iN] =
        !0;
    ue[MC] =
      ue[DC] =
      ue[zC] =
      ue[FC] =
      ue[YC] =
      ue[GC] =
      ue[XC] =
      ue[VC] =
      ue[UC] =
      ue[BC] =
      ue[WC] =
      ue[HC] =
      ue[jC] =
      ue[kC] =
      ue[KC] =
        !1;
    function oN(e) {
      return xC(e) && LC(e.length) && !!ue[qC(e)];
    }
    Vp.exports = oN;
  });
  var Wp = u((GH, Bp) => {
    function aN(e) {
      return function (t) {
        return e(t);
      };
    }
    Bp.exports = aN;
  });
  var jp = u((Br, sr) => {
    var sN = xo(),
      Hp = typeof Br == "object" && Br && !Br.nodeType && Br,
      Wr = Hp && typeof sr == "object" && sr && !sr.nodeType && sr,
      uN = Wr && Wr.exports === Hp,
      da = uN && sN.process,
      cN = (function () {
        try {
          var e = Wr && Wr.require && Wr.require("util").types;
          return e || (da && da.binding && da.binding("util"));
        } catch {}
      })();
    sr.exports = cN;
  });
  var Hn = u((XH, zp) => {
    var lN = Up(),
      fN = Wp(),
      kp = jp(),
      Kp = kp && kp.isTypedArray,
      dN = Kp ? fN(Kp) : lN;
    zp.exports = dN;
  });
  var pa = u((VH, Yp) => {
    var pN = Rp(),
      vN = Vr(),
      EN = Ae(),
      hN = Un(),
      gN = Bn(),
      _N = Hn(),
      yN = Object.prototype,
      IN = yN.hasOwnProperty;
    function TN(e, t) {
      var r = EN(e),
        n = !r && vN(e),
        o = !r && !n && hN(e),
        i = !r && !n && !o && _N(e),
        a = r || n || o || i,
        s = a ? pN(e.length, String) : [],
        c = s.length;
      for (var f in e)
        (t || IN.call(e, f)) &&
          !(
            a &&
            (f == "length" ||
              (o && (f == "offset" || f == "parent")) ||
              (i &&
                (f == "buffer" || f == "byteLength" || f == "byteOffset")) ||
              gN(f, c))
          ) &&
          s.push(f);
      return s;
    }
    Yp.exports = TN;
  });
  var jn = u((UH, $p) => {
    var mN = Object.prototype;
    function ON(e) {
      var t = e && e.constructor,
        r = (typeof t == "function" && t.prototype) || mN;
      return e === r;
    }
    $p.exports = ON;
  });
  var Zp = u((BH, Qp) => {
    var bN = Mo(),
      AN = bN(Object.keys, Object);
    Qp.exports = AN;
  });
  var kn = u((WH, Jp) => {
    var SN = jn(),
      RN = Zp(),
      wN = Object.prototype,
      CN = wN.hasOwnProperty;
    function NN(e) {
      if (!SN(e)) return RN(e);
      var t = [];
      for (var r in Object(e)) CN.call(e, r) && r != "constructor" && t.push(r);
      return t;
    }
    Jp.exports = NN;
  });
  var Dt = u((HH, ev) => {
    var PN = na(),
      qN = Wn();
    function LN(e) {
      return e != null && qN(e.length) && !PN(e);
    }
    ev.exports = LN;
  });
  var Hr = u((jH, tv) => {
    var xN = pa(),
      MN = kn(),
      DN = Dt();
    function FN(e) {
      return DN(e) ? xN(e) : MN(e);
    }
    tv.exports = FN;
  });
  var nv = u((kH, rv) => {
    var GN = ca(),
      XN = fa(),
      VN = Hr();
    function UN(e) {
      return GN(e, VN, XN);
    }
    rv.exports = UN;
  });
  var av = u((KH, ov) => {
    var iv = nv(),
      BN = 1,
      WN = Object.prototype,
      HN = WN.hasOwnProperty;
    function jN(e, t, r, n, o, i) {
      var a = r & BN,
        s = iv(e),
        c = s.length,
        f = iv(t),
        p = f.length;
      if (c != p && !a) return !1;
      for (var d = c; d--; ) {
        var h = s[d];
        if (!(a ? h in t : HN.call(t, h))) return !1;
      }
      var g = i.get(e),
        O = i.get(t);
      if (g && O) return g == t && O == e;
      var I = !0;
      i.set(e, t), i.set(t, e);
      for (var C = a; ++d < c; ) {
        h = s[d];
        var A = e[h],
          R = t[h];
        if (n) var T = a ? n(R, A, h, t, e, i) : n(A, R, h, e, t, i);
        if (!(T === void 0 ? A === R || o(A, R, r, n, i) : T)) {
          I = !1;
          break;
        }
        C || (C = h == "constructor");
      }
      if (I && !C) {
        var q = e.constructor,
          x = t.constructor;
        q != x &&
          "constructor" in e &&
          "constructor" in t &&
          !(
            typeof q == "function" &&
            q instanceof q &&
            typeof x == "function" &&
            x instanceof x
          ) &&
          (I = !1);
      }
      return i.delete(e), i.delete(t), I;
    }
    ov.exports = jN;
  });
  var uv = u((zH, sv) => {
    var kN = Tt(),
      KN = $e(),
      zN = kN(KN, "DataView");
    sv.exports = zN;
  });
  var lv = u((YH, cv) => {
    var YN = Tt(),
      $N = $e(),
      QN = YN($N, "Promise");
    cv.exports = QN;
  });
  var dv = u(($H, fv) => {
    var ZN = Tt(),
      JN = $e(),
      eP = ZN(JN, "Set");
    fv.exports = eP;
  });
  var va = u((QH, pv) => {
    var tP = Tt(),
      rP = $e(),
      nP = tP(rP, "WeakMap");
    pv.exports = nP;
  });
  var Kn = u((ZH, Iv) => {
    var Ea = uv(),
      ha = Fn(),
      ga = lv(),
      _a = dv(),
      ya = va(),
      yv = It(),
      ur = oa(),
      vv = "[object Map]",
      iP = "[object Object]",
      Ev = "[object Promise]",
      hv = "[object Set]",
      gv = "[object WeakMap]",
      _v = "[object DataView]",
      oP = ur(Ea),
      aP = ur(ha),
      sP = ur(ga),
      uP = ur(_a),
      cP = ur(ya),
      Ft = yv;
    ((Ea && Ft(new Ea(new ArrayBuffer(1))) != _v) ||
      (ha && Ft(new ha()) != vv) ||
      (ga && Ft(ga.resolve()) != Ev) ||
      (_a && Ft(new _a()) != hv) ||
      (ya && Ft(new ya()) != gv)) &&
      (Ft = function (e) {
        var t = yv(e),
          r = t == iP ? e.constructor : void 0,
          n = r ? ur(r) : "";
        if (n)
          switch (n) {
            case oP:
              return _v;
            case aP:
              return vv;
            case sP:
              return Ev;
            case uP:
              return hv;
            case cP:
              return gv;
          }
        return t;
      });
    Iv.exports = Ft;
  });
  var wv = u((JH, Rv) => {
    var Ia = aa(),
      lP = sa(),
      fP = gp(),
      dP = av(),
      Tv = Kn(),
      mv = Ae(),
      Ov = Un(),
      pP = Hn(),
      vP = 1,
      bv = "[object Arguments]",
      Av = "[object Array]",
      zn = "[object Object]",
      EP = Object.prototype,
      Sv = EP.hasOwnProperty;
    function hP(e, t, r, n, o, i) {
      var a = mv(e),
        s = mv(t),
        c = a ? Av : Tv(e),
        f = s ? Av : Tv(t);
      (c = c == bv ? zn : c), (f = f == bv ? zn : f);
      var p = c == zn,
        d = f == zn,
        h = c == f;
      if (h && Ov(e)) {
        if (!Ov(t)) return !1;
        (a = !0), (p = !1);
      }
      if (h && !p)
        return (
          i || (i = new Ia()),
          a || pP(e) ? lP(e, t, r, n, o, i) : fP(e, t, c, r, n, o, i)
        );
      if (!(r & vP)) {
        var g = p && Sv.call(e, "__wrapped__"),
          O = d && Sv.call(t, "__wrapped__");
        if (g || O) {
          var I = g ? e.value() : e,
            C = O ? t.value() : t;
          return i || (i = new Ia()), o(I, C, r, n, i);
        }
      }
      return h ? (i || (i = new Ia()), dP(e, t, r, n, o, i)) : !1;
    }
    Rv.exports = hP;
  });
  var Ta = u((ej, Pv) => {
    var gP = wv(),
      Cv = dt();
    function Nv(e, t, r, n, o) {
      return e === t
        ? !0
        : e == null || t == null || (!Cv(e) && !Cv(t))
        ? e !== e && t !== t
        : gP(e, t, r, n, Nv, o);
    }
    Pv.exports = Nv;
  });
  var Lv = u((tj, qv) => {
    var _P = aa(),
      yP = Ta(),
      IP = 1,
      TP = 2;
    function mP(e, t, r, n) {
      var o = r.length,
        i = o,
        a = !n;
      if (e == null) return !i;
      for (e = Object(e); o--; ) {
        var s = r[o];
        if (a && s[2] ? s[1] !== e[s[0]] : !(s[0] in e)) return !1;
      }
      for (; ++o < i; ) {
        s = r[o];
        var c = s[0],
          f = e[c],
          p = s[1];
        if (a && s[2]) {
          if (f === void 0 && !(c in e)) return !1;
        } else {
          var d = new _P();
          if (n) var h = n(f, p, c, e, t, d);
          if (!(h === void 0 ? yP(p, f, IP | TP, n, d) : h)) return !1;
        }
      }
      return !0;
    }
    qv.exports = mP;
  });
  var ma = u((rj, xv) => {
    var OP = ot();
    function bP(e) {
      return e === e && !OP(e);
    }
    xv.exports = bP;
  });
  var Dv = u((nj, Mv) => {
    var AP = ma(),
      SP = Hr();
    function RP(e) {
      for (var t = SP(e), r = t.length; r--; ) {
        var n = t[r],
          o = e[n];
        t[r] = [n, o, AP(o)];
      }
      return t;
    }
    Mv.exports = RP;
  });
  var Oa = u((ij, Fv) => {
    function wP(e, t) {
      return function (r) {
        return r == null ? !1 : r[e] === t && (t !== void 0 || e in Object(r));
      };
    }
    Fv.exports = wP;
  });
  var Xv = u((oj, Gv) => {
    var CP = Lv(),
      NP = Dv(),
      PP = Oa();
    function qP(e) {
      var t = NP(e);
      return t.length == 1 && t[0][2]
        ? PP(t[0][0], t[0][1])
        : function (r) {
            return r === e || CP(r, e, t);
          };
    }
    Gv.exports = qP;
  });
  var jr = u((aj, Vv) => {
    var LP = It(),
      xP = dt(),
      MP = "[object Symbol]";
    function DP(e) {
      return typeof e == "symbol" || (xP(e) && LP(e) == MP);
    }
    Vv.exports = DP;
  });
  var Yn = u((sj, Uv) => {
    var FP = Ae(),
      GP = jr(),
      XP = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      VP = /^\w*$/;
    function UP(e, t) {
      if (FP(e)) return !1;
      var r = typeof e;
      return r == "number" ||
        r == "symbol" ||
        r == "boolean" ||
        e == null ||
        GP(e)
        ? !0
        : VP.test(e) || !XP.test(e) || (t != null && e in Object(t));
    }
    Uv.exports = UP;
  });
  var Hv = u((uj, Wv) => {
    var Bv = Gn(),
      BP = "Expected a function";
    function ba(e, t) {
      if (typeof e != "function" || (t != null && typeof t != "function"))
        throw new TypeError(BP);
      var r = function () {
        var n = arguments,
          o = t ? t.apply(this, n) : n[0],
          i = r.cache;
        if (i.has(o)) return i.get(o);
        var a = e.apply(this, n);
        return (r.cache = i.set(o, a) || i), a;
      };
      return (r.cache = new (ba.Cache || Bv)()), r;
    }
    ba.Cache = Bv;
    Wv.exports = ba;
  });
  var kv = u((cj, jv) => {
    var WP = Hv(),
      HP = 500;
    function jP(e) {
      var t = WP(e, function (n) {
          return r.size === HP && r.clear(), n;
        }),
        r = t.cache;
      return t;
    }
    jv.exports = jP;
  });
  var zv = u((lj, Kv) => {
    var kP = kv(),
      KP =
        /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,
      zP = /\\(\\)?/g,
      YP = kP(function (e) {
        var t = [];
        return (
          e.charCodeAt(0) === 46 && t.push(""),
          e.replace(KP, function (r, n, o, i) {
            t.push(o ? i.replace(zP, "$1") : n || r);
          }),
          t
        );
      });
    Kv.exports = YP;
  });
  var Aa = u((fj, Yv) => {
    function $P(e, t) {
      for (var r = -1, n = e == null ? 0 : e.length, o = Array(n); ++r < n; )
        o[r] = t(e[r], r, e);
      return o;
    }
    Yv.exports = $P;
  });
  var tE = u((dj, eE) => {
    var $v = $t(),
      QP = Aa(),
      ZP = Ae(),
      JP = jr(),
      eq = 1 / 0,
      Qv = $v ? $v.prototype : void 0,
      Zv = Qv ? Qv.toString : void 0;
    function Jv(e) {
      if (typeof e == "string") return e;
      if (ZP(e)) return QP(e, Jv) + "";
      if (JP(e)) return Zv ? Zv.call(e) : "";
      var t = e + "";
      return t == "0" && 1 / e == -eq ? "-0" : t;
    }
    eE.exports = Jv;
  });
  var nE = u((pj, rE) => {
    var tq = tE();
    function rq(e) {
      return e == null ? "" : tq(e);
    }
    rE.exports = rq;
  });
  var kr = u((vj, iE) => {
    var nq = Ae(),
      iq = Yn(),
      oq = zv(),
      aq = nE();
    function sq(e, t) {
      return nq(e) ? e : iq(e, t) ? [e] : oq(aq(e));
    }
    iE.exports = sq;
  });
  var cr = u((Ej, oE) => {
    var uq = jr(),
      cq = 1 / 0;
    function lq(e) {
      if (typeof e == "string" || uq(e)) return e;
      var t = e + "";
      return t == "0" && 1 / e == -cq ? "-0" : t;
    }
    oE.exports = lq;
  });
  var $n = u((hj, aE) => {
    var fq = kr(),
      dq = cr();
    function pq(e, t) {
      t = fq(t, e);
      for (var r = 0, n = t.length; e != null && r < n; ) e = e[dq(t[r++])];
      return r && r == n ? e : void 0;
    }
    aE.exports = pq;
  });
  var Qn = u((gj, sE) => {
    var vq = $n();
    function Eq(e, t, r) {
      var n = e == null ? void 0 : vq(e, t);
      return n === void 0 ? r : n;
    }
    sE.exports = Eq;
  });
  var cE = u((_j, uE) => {
    function hq(e, t) {
      return e != null && t in Object(e);
    }
    uE.exports = hq;
  });
  var fE = u((yj, lE) => {
    var gq = kr(),
      _q = Vr(),
      yq = Ae(),
      Iq = Bn(),
      Tq = Wn(),
      mq = cr();
    function Oq(e, t, r) {
      t = gq(t, e);
      for (var n = -1, o = t.length, i = !1; ++n < o; ) {
        var a = mq(t[n]);
        if (!(i = e != null && r(e, a))) break;
        e = e[a];
      }
      return i || ++n != o
        ? i
        : ((o = e == null ? 0 : e.length),
          !!o && Tq(o) && Iq(a, o) && (yq(e) || _q(e)));
    }
    lE.exports = Oq;
  });
  var pE = u((Ij, dE) => {
    var bq = cE(),
      Aq = fE();
    function Sq(e, t) {
      return e != null && Aq(e, t, bq);
    }
    dE.exports = Sq;
  });
  var EE = u((Tj, vE) => {
    var Rq = Ta(),
      wq = Qn(),
      Cq = pE(),
      Nq = Yn(),
      Pq = ma(),
      qq = Oa(),
      Lq = cr(),
      xq = 1,
      Mq = 2;
    function Dq(e, t) {
      return Nq(e) && Pq(t)
        ? qq(Lq(e), t)
        : function (r) {
            var n = wq(r, e);
            return n === void 0 && n === t ? Cq(r, e) : Rq(t, n, xq | Mq);
          };
    }
    vE.exports = Dq;
  });
  var Zn = u((mj, hE) => {
    function Fq(e) {
      return e;
    }
    hE.exports = Fq;
  });
  var Sa = u((Oj, gE) => {
    function Gq(e) {
      return function (t) {
        return t?.[e];
      };
    }
    gE.exports = Gq;
  });
  var yE = u((bj, _E) => {
    var Xq = $n();
    function Vq(e) {
      return function (t) {
        return Xq(t, e);
      };
    }
    _E.exports = Vq;
  });
  var TE = u((Aj, IE) => {
    var Uq = Sa(),
      Bq = yE(),
      Wq = Yn(),
      Hq = cr();
    function jq(e) {
      return Wq(e) ? Uq(Hq(e)) : Bq(e);
    }
    IE.exports = jq;
  });
  var mt = u((Sj, mE) => {
    var kq = Xv(),
      Kq = EE(),
      zq = Zn(),
      Yq = Ae(),
      $q = TE();
    function Qq(e) {
      return typeof e == "function"
        ? e
        : e == null
        ? zq
        : typeof e == "object"
        ? Yq(e)
          ? Kq(e[0], e[1])
          : kq(e)
        : $q(e);
    }
    mE.exports = Qq;
  });
  var Ra = u((Rj, OE) => {
    var Zq = mt(),
      Jq = Dt(),
      eL = Hr();
    function tL(e) {
      return function (t, r, n) {
        var o = Object(t);
        if (!Jq(t)) {
          var i = Zq(r, 3);
          (t = eL(t)),
            (r = function (s) {
              return i(o[s], s, o);
            });
        }
        var a = e(t, r, n);
        return a > -1 ? o[i ? t[a] : a] : void 0;
      };
    }
    OE.exports = tL;
  });
  var wa = u((wj, bE) => {
    function rL(e, t, r, n) {
      for (var o = e.length, i = r + (n ? 1 : -1); n ? i-- : ++i < o; )
        if (t(e[i], i, e)) return i;
      return -1;
    }
    bE.exports = rL;
  });
  var SE = u((Cj, AE) => {
    var nL = /\s/;
    function iL(e) {
      for (var t = e.length; t-- && nL.test(e.charAt(t)); );
      return t;
    }
    AE.exports = iL;
  });
  var wE = u((Nj, RE) => {
    var oL = SE(),
      aL = /^\s+/;
    function sL(e) {
      return e && e.slice(0, oL(e) + 1).replace(aL, "");
    }
    RE.exports = sL;
  });
  var Jn = u((Pj, PE) => {
    var uL = wE(),
      CE = ot(),
      cL = jr(),
      NE = 0 / 0,
      lL = /^[-+]0x[0-9a-f]+$/i,
      fL = /^0b[01]+$/i,
      dL = /^0o[0-7]+$/i,
      pL = parseInt;
    function vL(e) {
      if (typeof e == "number") return e;
      if (cL(e)) return NE;
      if (CE(e)) {
        var t = typeof e.valueOf == "function" ? e.valueOf() : e;
        e = CE(t) ? t + "" : t;
      }
      if (typeof e != "string") return e === 0 ? e : +e;
      e = uL(e);
      var r = fL.test(e);
      return r || dL.test(e) ? pL(e.slice(2), r ? 2 : 8) : lL.test(e) ? NE : +e;
    }
    PE.exports = vL;
  });
  var xE = u((qj, LE) => {
    var EL = Jn(),
      qE = 1 / 0,
      hL = 17976931348623157e292;
    function gL(e) {
      if (!e) return e === 0 ? e : 0;
      if (((e = EL(e)), e === qE || e === -qE)) {
        var t = e < 0 ? -1 : 1;
        return t * hL;
      }
      return e === e ? e : 0;
    }
    LE.exports = gL;
  });
  var Ca = u((Lj, ME) => {
    var _L = xE();
    function yL(e) {
      var t = _L(e),
        r = t % 1;
      return t === t ? (r ? t - r : t) : 0;
    }
    ME.exports = yL;
  });
  var FE = u((xj, DE) => {
    var IL = wa(),
      TL = mt(),
      mL = Ca(),
      OL = Math.max;
    function bL(e, t, r) {
      var n = e == null ? 0 : e.length;
      if (!n) return -1;
      var o = r == null ? 0 : mL(r);
      return o < 0 && (o = OL(n + o, 0)), IL(e, TL(t, 3), o);
    }
    DE.exports = bL;
  });
  var Na = u((Mj, GE) => {
    var AL = Ra(),
      SL = FE(),
      RL = AL(SL);
    GE.exports = RL;
  });
  var ti = u((Le) => {
    "use strict";
    var wL = Ke().default;
    Object.defineProperty(Le, "__esModule", { value: !0 });
    Le.withBrowser =
      Le.TRANSFORM_STYLE_PREFIXED =
      Le.TRANSFORM_PREFIXED =
      Le.IS_BROWSER_ENV =
      Le.FLEX_PREFIXED =
      Le.ELEMENT_MATCHES =
        void 0;
    var CL = wL(Na()),
      VE = typeof window < "u";
    Le.IS_BROWSER_ENV = VE;
    var ei = (e, t) => (VE ? e() : t);
    Le.withBrowser = ei;
    var NL = ei(() =>
      (0, CL.default)(
        [
          "matches",
          "matchesSelector",
          "mozMatchesSelector",
          "msMatchesSelector",
          "oMatchesSelector",
          "webkitMatchesSelector",
        ],
        (e) => e in Element.prototype,
      ),
    );
    Le.ELEMENT_MATCHES = NL;
    var PL = ei(() => {
      let e = document.createElement("i"),
        t = ["flex", "-webkit-flex", "-ms-flexbox", "-moz-box", "-webkit-box"],
        r = "";
      try {
        let { length: n } = t;
        for (let o = 0; o < n; o++) {
          let i = t[o];
          if (((e.style.display = i), e.style.display === i)) return i;
        }
        return r;
      } catch {
        return r;
      }
    }, "flex");
    Le.FLEX_PREFIXED = PL;
    var UE = ei(() => {
      let e = document.createElement("i");
      if (e.style.transform == null) {
        let t = ["Webkit", "Moz", "ms"],
          r = "Transform",
          { length: n } = t;
        for (let o = 0; o < n; o++) {
          let i = t[o] + r;
          if (e.style[i] !== void 0) return i;
        }
      }
      return "transform";
    }, "transform");
    Le.TRANSFORM_PREFIXED = UE;
    var XE = UE.split("transform")[0],
      qL = XE ? XE + "TransformStyle" : "transformStyle";
    Le.TRANSFORM_STYLE_PREFIXED = qL;
  });
  var Pa = u((Fj, kE) => {
    var LL = 4,
      xL = 0.001,
      ML = 1e-7,
      DL = 10,
      Kr = 11,
      ri = 1 / (Kr - 1),
      FL = typeof Float32Array == "function";
    function BE(e, t) {
      return 1 - 3 * t + 3 * e;
    }
    function WE(e, t) {
      return 3 * t - 6 * e;
    }
    function HE(e) {
      return 3 * e;
    }
    function ni(e, t, r) {
      return ((BE(t, r) * e + WE(t, r)) * e + HE(t)) * e;
    }
    function jE(e, t, r) {
      return 3 * BE(t, r) * e * e + 2 * WE(t, r) * e + HE(t);
    }
    function GL(e, t, r, n, o) {
      var i,
        a,
        s = 0;
      do
        (a = t + (r - t) / 2), (i = ni(a, n, o) - e), i > 0 ? (r = a) : (t = a);
      while (Math.abs(i) > ML && ++s < DL);
      return a;
    }
    function XL(e, t, r, n) {
      for (var o = 0; o < LL; ++o) {
        var i = jE(t, r, n);
        if (i === 0) return t;
        var a = ni(t, r, n) - e;
        t -= a / i;
      }
      return t;
    }
    kE.exports = function (t, r, n, o) {
      if (!(0 <= t && t <= 1 && 0 <= n && n <= 1))
        throw new Error("bezier x values must be in [0, 1] range");
      var i = FL ? new Float32Array(Kr) : new Array(Kr);
      if (t !== r || n !== o)
        for (var a = 0; a < Kr; ++a) i[a] = ni(a * ri, t, n);
      function s(c) {
        for (var f = 0, p = 1, d = Kr - 1; p !== d && i[p] <= c; ++p) f += ri;
        --p;
        var h = (c - i[p]) / (i[p + 1] - i[p]),
          g = f + h * ri,
          O = jE(g, t, n);
        return O >= xL ? XL(c, g, t, n) : O === 0 ? g : GL(c, f, f + ri, t, n);
      }
      return function (f) {
        return t === r && n === o
          ? f
          : f === 0
          ? 0
          : f === 1
          ? 1
          : ni(s(f), r, o);
      };
    };
  });
  var qa = u((Q) => {
    "use strict";
    var VL = Ke().default;
    Object.defineProperty(Q, "__esModule", { value: !0 });
    Q.bounce = mx;
    Q.bouncePast = Ox;
    Q.easeOut = Q.easeInOut = Q.easeIn = Q.ease = void 0;
    Q.inBack = px;
    Q.inCirc = cx;
    Q.inCubic = zL;
    Q.inElastic = hx;
    Q.inExpo = ax;
    Q.inOutBack = Ex;
    Q.inOutCirc = fx;
    Q.inOutCubic = $L;
    Q.inOutElastic = _x;
    Q.inOutExpo = ux;
    Q.inOutQuad = KL;
    Q.inOutQuart = JL;
    Q.inOutQuint = rx;
    Q.inOutSine = ox;
    Q.inQuad = jL;
    Q.inQuart = QL;
    Q.inQuint = ex;
    Q.inSine = nx;
    Q.outBack = vx;
    Q.outBounce = dx;
    Q.outCirc = lx;
    Q.outCubic = YL;
    Q.outElastic = gx;
    Q.outExpo = sx;
    Q.outQuad = kL;
    Q.outQuart = ZL;
    Q.outQuint = tx;
    Q.outSine = ix;
    Q.swingFrom = Ix;
    Q.swingFromTo = yx;
    Q.swingTo = Tx;
    var ii = VL(Pa()),
      vt = 1.70158,
      UL = (0, ii.default)(0.25, 0.1, 0.25, 1);
    Q.ease = UL;
    var BL = (0, ii.default)(0.42, 0, 1, 1);
    Q.easeIn = BL;
    var WL = (0, ii.default)(0, 0, 0.58, 1);
    Q.easeOut = WL;
    var HL = (0, ii.default)(0.42, 0, 0.58, 1);
    Q.easeInOut = HL;
    function jL(e) {
      return Math.pow(e, 2);
    }
    function kL(e) {
      return -(Math.pow(e - 1, 2) - 1);
    }
    function KL(e) {
      return (e /= 0.5) < 1 ? 0.5 * Math.pow(e, 2) : -0.5 * ((e -= 2) * e - 2);
    }
    function zL(e) {
      return Math.pow(e, 3);
    }
    function YL(e) {
      return Math.pow(e - 1, 3) + 1;
    }
    function $L(e) {
      return (e /= 0.5) < 1
        ? 0.5 * Math.pow(e, 3)
        : 0.5 * (Math.pow(e - 2, 3) + 2);
    }
    function QL(e) {
      return Math.pow(e, 4);
    }
    function ZL(e) {
      return -(Math.pow(e - 1, 4) - 1);
    }
    function JL(e) {
      return (e /= 0.5) < 1
        ? 0.5 * Math.pow(e, 4)
        : -0.5 * ((e -= 2) * Math.pow(e, 3) - 2);
    }
    function ex(e) {
      return Math.pow(e, 5);
    }
    function tx(e) {
      return Math.pow(e - 1, 5) + 1;
    }
    function rx(e) {
      return (e /= 0.5) < 1
        ? 0.5 * Math.pow(e, 5)
        : 0.5 * (Math.pow(e - 2, 5) + 2);
    }
    function nx(e) {
      return -Math.cos(e * (Math.PI / 2)) + 1;
    }
    function ix(e) {
      return Math.sin(e * (Math.PI / 2));
    }
    function ox(e) {
      return -0.5 * (Math.cos(Math.PI * e) - 1);
    }
    function ax(e) {
      return e === 0 ? 0 : Math.pow(2, 10 * (e - 1));
    }
    function sx(e) {
      return e === 1 ? 1 : -Math.pow(2, -10 * e) + 1;
    }
    function ux(e) {
      return e === 0
        ? 0
        : e === 1
        ? 1
        : (e /= 0.5) < 1
        ? 0.5 * Math.pow(2, 10 * (e - 1))
        : 0.5 * (-Math.pow(2, -10 * --e) + 2);
    }
    function cx(e) {
      return -(Math.sqrt(1 - e * e) - 1);
    }
    function lx(e) {
      return Math.sqrt(1 - Math.pow(e - 1, 2));
    }
    function fx(e) {
      return (e /= 0.5) < 1
        ? -0.5 * (Math.sqrt(1 - e * e) - 1)
        : 0.5 * (Math.sqrt(1 - (e -= 2) * e) + 1);
    }
    function dx(e) {
      return e < 1 / 2.75
        ? 7.5625 * e * e
        : e < 2 / 2.75
        ? 7.5625 * (e -= 1.5 / 2.75) * e + 0.75
        : e < 2.5 / 2.75
        ? 7.5625 * (e -= 2.25 / 2.75) * e + 0.9375
        : 7.5625 * (e -= 2.625 / 2.75) * e + 0.984375;
    }
    function px(e) {
      let t = vt;
      return e * e * ((t + 1) * e - t);
    }
    function vx(e) {
      let t = vt;
      return (e -= 1) * e * ((t + 1) * e + t) + 1;
    }
    function Ex(e) {
      let t = vt;
      return (e /= 0.5) < 1
        ? 0.5 * (e * e * (((t *= 1.525) + 1) * e - t))
        : 0.5 * ((e -= 2) * e * (((t *= 1.525) + 1) * e + t) + 2);
    }
    function hx(e) {
      let t = vt,
        r = 0,
        n = 1;
      return e === 0
        ? 0
        : e === 1
        ? 1
        : (r || (r = 0.3),
          n < 1
            ? ((n = 1), (t = r / 4))
            : (t = (r / (2 * Math.PI)) * Math.asin(1 / n)),
          -(
            n *
            Math.pow(2, 10 * (e -= 1)) *
            Math.sin(((e - t) * (2 * Math.PI)) / r)
          ));
    }
    function gx(e) {
      let t = vt,
        r = 0,
        n = 1;
      return e === 0
        ? 0
        : e === 1
        ? 1
        : (r || (r = 0.3),
          n < 1
            ? ((n = 1), (t = r / 4))
            : (t = (r / (2 * Math.PI)) * Math.asin(1 / n)),
          n * Math.pow(2, -10 * e) * Math.sin(((e - t) * (2 * Math.PI)) / r) +
            1);
    }
    function _x(e) {
      let t = vt,
        r = 0,
        n = 1;
      return e === 0
        ? 0
        : (e /= 1 / 2) === 2
        ? 1
        : (r || (r = 0.3 * 1.5),
          n < 1
            ? ((n = 1), (t = r / 4))
            : (t = (r / (2 * Math.PI)) * Math.asin(1 / n)),
          e < 1
            ? -0.5 *
              (n *
                Math.pow(2, 10 * (e -= 1)) *
                Math.sin(((e - t) * (2 * Math.PI)) / r))
            : n *
                Math.pow(2, -10 * (e -= 1)) *
                Math.sin(((e - t) * (2 * Math.PI)) / r) *
                0.5 +
              1);
    }
    function yx(e) {
      let t = vt;
      return (e /= 0.5) < 1
        ? 0.5 * (e * e * (((t *= 1.525) + 1) * e - t))
        : 0.5 * ((e -= 2) * e * (((t *= 1.525) + 1) * e + t) + 2);
    }
    function Ix(e) {
      let t = vt;
      return e * e * ((t + 1) * e - t);
    }
    function Tx(e) {
      let t = vt;
      return (e -= 1) * e * ((t + 1) * e + t) + 1;
    }
    function mx(e) {
      return e < 1 / 2.75
        ? 7.5625 * e * e
        : e < 2 / 2.75
        ? 7.5625 * (e -= 1.5 / 2.75) * e + 0.75
        : e < 2.5 / 2.75
        ? 7.5625 * (e -= 2.25 / 2.75) * e + 0.9375
        : 7.5625 * (e -= 2.625 / 2.75) * e + 0.984375;
    }
    function Ox(e) {
      return e < 1 / 2.75
        ? 7.5625 * e * e
        : e < 2 / 2.75
        ? 2 - (7.5625 * (e -= 1.5 / 2.75) * e + 0.75)
        : e < 2.5 / 2.75
        ? 2 - (7.5625 * (e -= 2.25 / 2.75) * e + 0.9375)
        : 2 - (7.5625 * (e -= 2.625 / 2.75) * e + 0.984375);
    }
  });
  var xa = u((zr) => {
    "use strict";
    var bx = Ke().default,
      Ax = qt().default;
    Object.defineProperty(zr, "__esModule", { value: !0 });
    zr.applyEasing = wx;
    zr.createBezierEasing = Rx;
    zr.optimizeFloat = La;
    var KE = Ax(qa()),
      Sx = bx(Pa());
    function La(e, t = 5, r = 10) {
      let n = Math.pow(r, t),
        o = Number(Math.round(e * n) / n);
      return Math.abs(o) > 1e-4 ? o : 0;
    }
    function Rx(e) {
      return (0, Sx.default)(...e);
    }
    function wx(e, t, r) {
      return t === 0
        ? 0
        : t === 1
        ? 1
        : La(r ? (t > 0 ? r(t) : t) : t > 0 && e && KE[e] ? KE[e](t) : t);
    }
  });
  var QE = u((lr) => {
    "use strict";
    Object.defineProperty(lr, "__esModule", { value: !0 });
    lr.createElementState = $E;
    lr.ixElements = void 0;
    lr.mergeActionState = Ma;
    var oi = tr(),
      YE = Fe(),
      {
        HTML_ELEMENT: Vj,
        PLAIN_OBJECT: Cx,
        ABSTRACT_NODE: Uj,
        CONFIG_X_VALUE: Nx,
        CONFIG_Y_VALUE: Px,
        CONFIG_Z_VALUE: qx,
        CONFIG_VALUE: Lx,
        CONFIG_X_UNIT: xx,
        CONFIG_Y_UNIT: Mx,
        CONFIG_Z_UNIT: Dx,
        CONFIG_UNIT: Fx,
      } = YE.IX2EngineConstants,
      {
        IX2_SESSION_STOPPED: Gx,
        IX2_INSTANCE_ADDED: Xx,
        IX2_ELEMENT_STATE_CHANGED: Vx,
      } = YE.IX2EngineActionTypes,
      zE = {},
      Ux = "refState",
      Bx = (e = zE, t = {}) => {
        switch (t.type) {
          case Gx:
            return zE;
          case Xx: {
            let {
                elementId: r,
                element: n,
                origin: o,
                actionItem: i,
                refType: a,
              } = t.payload,
              { actionTypeId: s } = i,
              c = e;
            return (
              (0, oi.getIn)(c, [r, n]) !== n && (c = $E(c, n, a, r, i)),
              Ma(c, r, s, o, i)
            );
          }
          case Vx: {
            let {
              elementId: r,
              actionTypeId: n,
              current: o,
              actionItem: i,
            } = t.payload;
            return Ma(e, r, n, o, i);
          }
          default:
            return e;
        }
      };
    lr.ixElements = Bx;
    function $E(e, t, r, n, o) {
      let i =
        r === Cx ? (0, oi.getIn)(o, ["config", "target", "objectId"]) : null;
      return (0, oi.mergeIn)(e, [n], { id: n, ref: t, refId: i, refType: r });
    }
    function Ma(e, t, r, n, o) {
      let i = Hx(o),
        a = [t, Ux, r];
      return (0, oi.mergeIn)(e, a, n, i);
    }
    var Wx = [
      [Nx, xx],
      [Px, Mx],
      [qx, Dx],
      [Lx, Fx],
    ];
    function Hx(e) {
      let { config: t } = e;
      return Wx.reduce((r, n) => {
        let o = n[0],
          i = n[1],
          a = t[o],
          s = t[i];
        return a != null && s != null && (r[i] = s), r;
      }, {});
    }
  });
  var ZE = u((Se) => {
    "use strict";
    Object.defineProperty(Se, "__esModule", { value: !0 });
    Se.renderPlugin =
      Se.getPluginOrigin =
      Se.getPluginDuration =
      Se.getPluginDestination =
      Se.getPluginConfig =
      Se.createPluginInstance =
      Se.clearPlugin =
        void 0;
    var jx = (e) => e.value;
    Se.getPluginConfig = jx;
    var kx = (e, t) => {
      if (t.config.duration !== "auto") return null;
      let r = parseFloat(e.getAttribute("data-duration"));
      return r > 0
        ? r * 1e3
        : parseFloat(e.getAttribute("data-default-duration")) * 1e3;
    };
    Se.getPluginDuration = kx;
    var Kx = (e) => e || { value: 0 };
    Se.getPluginOrigin = Kx;
    var zx = (e) => ({ value: e.value });
    Se.getPluginDestination = zx;
    var Yx = (e) => {
      let t = window.Webflow.require("lottie").createInstance(e);
      return t.stop(), t.setSubframe(!0), t;
    };
    Se.createPluginInstance = Yx;
    var $x = (e, t, r) => {
      if (!e) return;
      let n = t[r.actionTypeId].value / 100;
      e.goToFrame(e.frames * n);
    };
    Se.renderPlugin = $x;
    var Qx = (e) => {
      window.Webflow.require("lottie").createInstance(e).stop();
    };
    Se.clearPlugin = Qx;
  });
  var eh = u((Re) => {
    "use strict";
    Object.defineProperty(Re, "__esModule", { value: !0 });
    Re.renderPlugin =
      Re.getPluginOrigin =
      Re.getPluginDuration =
      Re.getPluginDestination =
      Re.getPluginConfig =
      Re.createPluginInstance =
      Re.clearPlugin =
        void 0;
    var Zx = (e) => document.querySelector(`[data-w-id="${e}"]`),
      Jx = () => window.Webflow.require("spline"),
      eM = (e, t) => e.filter((r) => !t.includes(r)),
      tM = (e, t) => e.value[t];
    Re.getPluginConfig = tM;
    var rM = () => null;
    Re.getPluginDuration = rM;
    var JE = Object.freeze({
        positionX: 0,
        positionY: 0,
        positionZ: 0,
        rotationX: 0,
        rotationY: 0,
        rotationZ: 0,
        scaleX: 1,
        scaleY: 1,
        scaleZ: 1,
      }),
      nM = (e, t) => {
        let r = t.config.value,
          n = Object.keys(r);
        if (e) {
          let i = Object.keys(e),
            a = eM(n, i);
          return a.length ? a.reduce((c, f) => ((c[f] = JE[f]), c), e) : e;
        }
        return n.reduce((i, a) => ((i[a] = JE[a]), i), {});
      };
    Re.getPluginOrigin = nM;
    var iM = (e) => e.value;
    Re.getPluginDestination = iM;
    var oM = (e, t) => {
      var r, n;
      let o =
        t == null ||
        (r = t.config) === null ||
        r === void 0 ||
        (n = r.target) === null ||
        n === void 0
          ? void 0
          : n.pluginElement;
      return o ? Zx(o) : null;
    };
    Re.createPluginInstance = oM;
    var aM = (e, t, r) => {
      let n = Jx().getInstance(e),
        o = r.config.target.objectId;
      if (!n || !o) return;
      let i = n.spline.findObjectById(o);
      if (!i) return;
      let { PLUGIN_SPLINE: a } = t;
      a.positionX != null && (i.position.x = a.positionX),
        a.positionY != null && (i.position.y = a.positionY),
        a.positionZ != null && (i.position.z = a.positionZ),
        a.rotationX != null && (i.rotation.x = a.rotationX),
        a.rotationY != null && (i.rotation.y = a.rotationY),
        a.rotationZ != null && (i.rotation.z = a.rotationZ),
        a.scaleX != null && (i.scale.x = a.scaleX),
        a.scaleY != null && (i.scale.y = a.scaleY),
        a.scaleZ != null && (i.scale.z = a.scaleZ);
    };
    Re.renderPlugin = aM;
    var sM = () => null;
    Re.clearPlugin = sM;
  });
  var rh = u((Ie) => {
    "use strict";
    Object.defineProperty(Ie, "__esModule", { value: !0 });
    Ie.getPluginOrigin =
      Ie.getPluginDuration =
      Ie.getPluginDestination =
      Ie.getPluginConfig =
      Ie.createPluginInstance =
      Ie.clearPlugin =
        void 0;
    Ie.normalizeColor = th;
    Ie.renderPlugin = void 0;
    function th(e) {
      let t,
        r,
        n,
        o = 1,
        i = e.replace(/\s/g, "").toLowerCase();
      if (i.startsWith("#")) {
        let a = i.substring(1);
        a.length === 3
          ? ((t = parseInt(a[0] + a[0], 16)),
            (r = parseInt(a[1] + a[1], 16)),
            (n = parseInt(a[2] + a[2], 16)))
          : a.length === 6 &&
            ((t = parseInt(a.substring(0, 2), 16)),
            (r = parseInt(a.substring(2, 4), 16)),
            (n = parseInt(a.substring(4, 6), 16)));
      } else if (i.startsWith("rgba")) {
        let a = i.match(/rgba\(([^)]+)\)/)[1].split(",");
        (t = parseInt(a[0], 10)),
          (r = parseInt(a[1], 10)),
          (n = parseInt(a[2], 10)),
          (o = parseFloat(a[3]));
      } else if (i.startsWith("rgb")) {
        let a = i.match(/rgb\(([^)]+)\)/)[1].split(",");
        (t = parseInt(a[0], 10)),
          (r = parseInt(a[1], 10)),
          (n = parseInt(a[2], 10));
      } else if (i.startsWith("hsla")) {
        let a = i.match(/hsla\(([^)]+)\)/)[1].split(","),
          s = parseFloat(a[0]),
          c = parseFloat(a[1].replace("%", "")) / 100,
          f = parseFloat(a[2].replace("%", "")) / 100;
        o = parseFloat(a[3]);
        let p = (1 - Math.abs(2 * f - 1)) * c,
          d = p * (1 - Math.abs(((s / 60) % 2) - 1)),
          h = f - p / 2,
          g,
          O,
          I;
        s >= 0 && s < 60
          ? ((g = p), (O = d), (I = 0))
          : s >= 60 && s < 120
          ? ((g = d), (O = p), (I = 0))
          : s >= 120 && s < 180
          ? ((g = 0), (O = p), (I = d))
          : s >= 180 && s < 240
          ? ((g = 0), (O = d), (I = p))
          : s >= 240 && s < 300
          ? ((g = d), (O = 0), (I = p))
          : ((g = p), (O = 0), (I = d)),
          (t = Math.round((g + h) * 255)),
          (r = Math.round((O + h) * 255)),
          (n = Math.round((I + h) * 255));
      } else if (i.startsWith("hsl")) {
        let a = i.match(/hsl\(([^)]+)\)/)[1].split(","),
          s = parseFloat(a[0]),
          c = parseFloat(a[1].replace("%", "")) / 100,
          f = parseFloat(a[2].replace("%", "")) / 100,
          p = (1 - Math.abs(2 * f - 1)) * c,
          d = p * (1 - Math.abs(((s / 60) % 2) - 1)),
          h = f - p / 2,
          g,
          O,
          I;
        s >= 0 && s < 60
          ? ((g = p), (O = d), (I = 0))
          : s >= 60 && s < 120
          ? ((g = d), (O = p), (I = 0))
          : s >= 120 && s < 180
          ? ((g = 0), (O = p), (I = d))
          : s >= 180 && s < 240
          ? ((g = 0), (O = d), (I = p))
          : s >= 240 && s < 300
          ? ((g = d), (O = 0), (I = p))
          : ((g = p), (O = 0), (I = d)),
          (t = Math.round((g + h) * 255)),
          (r = Math.round((O + h) * 255)),
          (n = Math.round((I + h) * 255));
      }
      return (
        (Number.isNaN(t) || Number.isNaN(r) || Number.isNaN(n)) && `${e}`,
        { red: t, green: r, blue: n, alpha: o }
      );
    }
    var uM = (e, t) => e.value[t];
    Ie.getPluginConfig = uM;
    var cM = () => null;
    Ie.getPluginDuration = cM;
    var lM = (e, t) => {
      if (e) return e;
      let r = t.config.value,
        n = t.config.target.objectId,
        o = getComputedStyle(document.documentElement).getPropertyValue(n);
      if (r.size != null) return { size: parseInt(o, 10) };
      if (r.red != null && r.green != null && r.blue != null) return th(o);
    };
    Ie.getPluginOrigin = lM;
    var fM = (e) => e.value;
    Ie.getPluginDestination = fM;
    var dM = () => null;
    Ie.createPluginInstance = dM;
    var pM = (e, t, r) => {
      let n = r.config.target.objectId,
        o = r.config.value.unit,
        { PLUGIN_VARIABLE: i } = t,
        { size: a, red: s, green: c, blue: f, alpha: p } = i,
        d;
      a != null && (d = a + o),
        s != null &&
          f != null &&
          c != null &&
          p != null &&
          (d = `rgba(${s}, ${c}, ${f}, ${p})`),
        d != null && document.documentElement.style.setProperty(n, d);
    };
    Ie.renderPlugin = pM;
    var vM = (e, t) => {
      let r = t.config.target.objectId;
      document.documentElement.style.removeProperty(r);
    };
    Ie.clearPlugin = vM;
  });
  var nh = u((ai) => {
    "use strict";
    var Ga = qt().default,
      EM = Ke().default;
    Object.defineProperty(ai, "__esModule", { value: !0 });
    ai.pluginMethodMap = void 0;
    var Da = EM(er()),
      Fa = Fe(),
      hM = Ga(ZE()),
      gM = Ga(eh()),
      _M = Ga(rh()),
      yM = new Map([
        [Fa.ActionTypeConsts.PLUGIN_LOTTIE, (0, Da.default)({}, hM)],
        [Fa.ActionTypeConsts.PLUGIN_SPLINE, (0, Da.default)({}, gM)],
        [Fa.ActionTypeConsts.PLUGIN_VARIABLE, (0, Da.default)({}, _M)],
      ]);
    ai.pluginMethodMap = yM;
  });
  var Xa = u((Te) => {
    "use strict";
    Object.defineProperty(Te, "__esModule", { value: !0 });
    Te.getPluginOrigin =
      Te.getPluginDuration =
      Te.getPluginDestination =
      Te.getPluginConfig =
      Te.createPluginInstance =
      Te.clearPlugin =
        void 0;
    Te.isPluginType = TM;
    Te.renderPlugin = void 0;
    var IM = ti(),
      ih = nh();
    function TM(e) {
      return ih.pluginMethodMap.has(e);
    }
    var Gt = (e) => (t) => {
        if (!IM.IS_BROWSER_ENV) return () => null;
        let r = ih.pluginMethodMap.get(t);
        if (!r) throw new Error(`IX2 no plugin configured for: ${t}`);
        let n = r[e];
        if (!n) throw new Error(`IX2 invalid plugin method: ${e}`);
        return n;
      },
      mM = Gt("getPluginConfig");
    Te.getPluginConfig = mM;
    var OM = Gt("getPluginOrigin");
    Te.getPluginOrigin = OM;
    var bM = Gt("getPluginDuration");
    Te.getPluginDuration = bM;
    var AM = Gt("getPluginDestination");
    Te.getPluginDestination = AM;
    var SM = Gt("createPluginInstance");
    Te.createPluginInstance = SM;
    var RM = Gt("renderPlugin");
    Te.renderPlugin = RM;
    var wM = Gt("clearPlugin");
    Te.clearPlugin = wM;
  });
  var ah = u((zj, oh) => {
    function CM(e, t) {
      return e == null || e !== e ? t : e;
    }
    oh.exports = CM;
  });
  var uh = u((Yj, sh) => {
    function NM(e, t, r, n) {
      var o = -1,
        i = e == null ? 0 : e.length;
      for (n && i && (r = e[++o]); ++o < i; ) r = t(r, e[o], o, e);
      return r;
    }
    sh.exports = NM;
  });
  var lh = u(($j, ch) => {
    function PM(e) {
      return function (t, r, n) {
        for (var o = -1, i = Object(t), a = n(t), s = a.length; s--; ) {
          var c = a[e ? s : ++o];
          if (r(i[c], c, i) === !1) break;
        }
        return t;
      };
    }
    ch.exports = PM;
  });
  var dh = u((Qj, fh) => {
    var qM = lh(),
      LM = qM();
    fh.exports = LM;
  });
  var Va = u((Zj, ph) => {
    var xM = dh(),
      MM = Hr();
    function DM(e, t) {
      return e && xM(e, t, MM);
    }
    ph.exports = DM;
  });
  var Eh = u((Jj, vh) => {
    var FM = Dt();
    function GM(e, t) {
      return function (r, n) {
        if (r == null) return r;
        if (!FM(r)) return e(r, n);
        for (
          var o = r.length, i = t ? o : -1, a = Object(r);
          (t ? i-- : ++i < o) && n(a[i], i, a) !== !1;

        );
        return r;
      };
    }
    vh.exports = GM;
  });
  var Ua = u((ek, hh) => {
    var XM = Va(),
      VM = Eh(),
      UM = VM(XM);
    hh.exports = UM;
  });
  var _h = u((tk, gh) => {
    function BM(e, t, r, n, o) {
      return (
        o(e, function (i, a, s) {
          r = n ? ((n = !1), i) : t(r, i, a, s);
        }),
        r
      );
    }
    gh.exports = BM;
  });
  var Ih = u((rk, yh) => {
    var WM = uh(),
      HM = Ua(),
      jM = mt(),
      kM = _h(),
      KM = Ae();
    function zM(e, t, r) {
      var n = KM(e) ? WM : kM,
        o = arguments.length < 3;
      return n(e, jM(t, 4), r, o, HM);
    }
    yh.exports = zM;
  });
  var mh = u((nk, Th) => {
    var YM = wa(),
      $M = mt(),
      QM = Ca(),
      ZM = Math.max,
      JM = Math.min;
    function eD(e, t, r) {
      var n = e == null ? 0 : e.length;
      if (!n) return -1;
      var o = n - 1;
      return (
        r !== void 0 &&
          ((o = QM(r)), (o = r < 0 ? ZM(n + o, 0) : JM(o, n - 1))),
        YM(e, $M(t, 3), o, !0)
      );
    }
    Th.exports = eD;
  });
  var bh = u((ik, Oh) => {
    var tD = Ra(),
      rD = mh(),
      nD = tD(rD);
    Oh.exports = nD;
  });
  var Sh = u((si) => {
    "use strict";
    Object.defineProperty(si, "__esModule", { value: !0 });
    si.default = void 0;
    var iD = Object.prototype.hasOwnProperty;
    function Ah(e, t) {
      return e === t
        ? e !== 0 || t !== 0 || 1 / e === 1 / t
        : e !== e && t !== t;
    }
    function oD(e, t) {
      if (Ah(e, t)) return !0;
      if (
        typeof e != "object" ||
        e === null ||
        typeof t != "object" ||
        t === null
      )
        return !1;
      let r = Object.keys(e),
        n = Object.keys(t);
      if (r.length !== n.length) return !1;
      for (let o = 0; o < r.length; o++)
        if (!iD.call(t, r[o]) || !Ah(e[r[o]], t[r[o]])) return !1;
      return !0;
    }
    var aD = oD;
    si.default = aD;
  });
  var jh = u((se) => {
    "use strict";
    var fi = Ke().default;
    Object.defineProperty(se, "__esModule", { value: !0 });
    se.cleanupHTMLElement = i1;
    se.clearAllStyles = n1;
    se.clearObjectCache = bD;
    se.getActionListProgress = a1;
    se.getAffectedElements = za;
    se.getComputedStyle = qD;
    se.getDestinationValues = XD;
    se.getElementId = wD;
    se.getInstanceId = SD;
    se.getInstanceOrigin = MD;
    se.getItemConfigByKey = void 0;
    se.getMaxDurationItemIndex = Hh;
    se.getNamespacedParameterId = c1;
    se.getRenderType = Uh;
    se.getStyleProp = VD;
    se.mediaQueriesEqual = f1;
    se.observeStore = PD;
    se.reduceListToGroup = s1;
    se.reifyState = CD;
    se.renderHTMLElement = UD;
    Object.defineProperty(se, "shallowEqual", {
      enumerable: !0,
      get: function () {
        return xh.default;
      },
    });
    se.shouldAllowMediaQuery = l1;
    se.shouldNamespaceEventParameter = u1;
    se.stringifyTarget = d1;
    var Ot = fi(ah()),
      Ha = fi(Ih()),
      Wa = fi(bh()),
      Rh = tr(),
      Xt = Fe(),
      xh = fi(Sh()),
      sD = xa(),
      ut = Xa(),
      xe = ti(),
      {
        BACKGROUND: uD,
        TRANSFORM: cD,
        TRANSLATE_3D: lD,
        SCALE_3D: fD,
        ROTATE_X: dD,
        ROTATE_Y: pD,
        ROTATE_Z: vD,
        SKEW: ED,
        PRESERVE_3D: hD,
        FLEX: gD,
        OPACITY: ci,
        FILTER: Yr,
        FONT_VARIATION_SETTINGS: $r,
        WIDTH: at,
        HEIGHT: st,
        BACKGROUND_COLOR: Mh,
        BORDER_COLOR: _D,
        COLOR: yD,
        CHILDREN: wh,
        IMMEDIATE_CHILDREN: ID,
        SIBLINGS: Ch,
        PARENT: TD,
        DISPLAY: li,
        WILL_CHANGE: fr,
        AUTO: bt,
        COMMA_DELIMITER: Qr,
        COLON_DELIMITER: mD,
        BAR_DELIMITER: Ba,
        RENDER_TRANSFORM: Dh,
        RENDER_GENERAL: ja,
        RENDER_STYLE: ka,
        RENDER_PLUGIN: Fh,
      } = Xt.IX2EngineConstants,
      {
        TRANSFORM_MOVE: dr,
        TRANSFORM_SCALE: pr,
        TRANSFORM_ROTATE: vr,
        TRANSFORM_SKEW: Zr,
        STYLE_OPACITY: Gh,
        STYLE_FILTER: Jr,
        STYLE_FONT_VARIATION: en,
        STYLE_SIZE: Er,
        STYLE_BACKGROUND_COLOR: hr,
        STYLE_BORDER: gr,
        STYLE_TEXT_COLOR: _r,
        GENERAL_DISPLAY: di,
        OBJECT_VALUE: OD,
      } = Xt.ActionTypeConsts,
      Xh = (e) => e.trim(),
      Ka = Object.freeze({ [hr]: Mh, [gr]: _D, [_r]: yD }),
      Vh = Object.freeze({
        [xe.TRANSFORM_PREFIXED]: cD,
        [Mh]: uD,
        [ci]: ci,
        [Yr]: Yr,
        [at]: at,
        [st]: st,
        [$r]: $r,
      }),
      ui = new Map();
    function bD() {
      ui.clear();
    }
    var AD = 1;
    function SD() {
      return "i" + AD++;
    }
    var RD = 1;
    function wD(e, t) {
      for (let r in e) {
        let n = e[r];
        if (n && n.ref === t) return n.id;
      }
      return "e" + RD++;
    }
    function CD({ events: e, actionLists: t, site: r } = {}) {
      let n = (0, Ha.default)(
          e,
          (a, s) => {
            let { eventTypeId: c } = s;
            return a[c] || (a[c] = {}), (a[c][s.id] = s), a;
          },
          {},
        ),
        o = r && r.mediaQueries,
        i = [];
      return (
        o
          ? (i = o.map((a) => a.key))
          : ((o = []), console.warn("IX2 missing mediaQueries in site data")),
        {
          ixData: {
            events: e,
            actionLists: t,
            eventTypeMap: n,
            mediaQueries: o,
            mediaQueryKeys: i,
          },
        }
      );
    }
    var ND = (e, t) => e === t;
    function PD({ store: e, select: t, onChange: r, comparator: n = ND }) {
      let { getState: o, subscribe: i } = e,
        a = i(c),
        s = t(o());
      function c() {
        let f = t(o());
        if (f == null) {
          a();
          return;
        }
        n(f, s) || ((s = f), r(s, e));
      }
      return a;
    }
    function Nh(e) {
      let t = typeof e;
      if (t === "string") return { id: e };
      if (e != null && t === "object") {
        let {
          id: r,
          objectId: n,
          selector: o,
          selectorGuids: i,
          appliesTo: a,
          useEventTarget: s,
        } = e;
        return {
          id: r,
          objectId: n,
          selector: o,
          selectorGuids: i,
          appliesTo: a,
          useEventTarget: s,
        };
      }
      return {};
    }
    function za({
      config: e,
      event: t,
      eventTarget: r,
      elementRoot: n,
      elementApi: o,
    }) {
      var i, a, s;
      if (!o) throw new Error("IX2 missing elementApi");
      let { targets: c } = e;
      if (Array.isArray(c) && c.length > 0)
        return c.reduce(
          (M, D) =>
            M.concat(
              za({
                config: { target: D },
                event: t,
                eventTarget: r,
                elementRoot: n,
                elementApi: o,
              }),
            ),
          [],
        );
      let {
          getValidDocument: f,
          getQuerySelector: p,
          queryDocument: d,
          getChildElements: h,
          getSiblingElements: g,
          matchSelector: O,
          elementContains: I,
          isSiblingNode: C,
        } = o,
        { target: A } = e;
      if (!A) return [];
      let {
        id: R,
        objectId: T,
        selector: q,
        selectorGuids: x,
        appliesTo: N,
        useEventTarget: F,
      } = Nh(A);
      if (T) return [ui.has(T) ? ui.get(T) : ui.set(T, {}).get(T)];
      if (N === Xt.EventAppliesTo.PAGE) {
        let M = f(R);
        return M ? [M] : [];
      }
      let W =
          ((i =
            t == null ||
            (a = t.action) === null ||
            a === void 0 ||
            (s = a.config) === null ||
            s === void 0
              ? void 0
              : s.affectedElements) !== null && i !== void 0
            ? i
            : {})[R || q] || {},
        ee = !!(W.id || W.selector),
        K,
        L,
        y,
        P = t && p(Nh(t.target));
      if (
        (ee
          ? ((K = W.limitAffectedElements), (L = P), (y = p(W)))
          : (L = y = p({ id: R, selector: q, selectorGuids: x })),
        t && F)
      ) {
        let M = r && (y || F === !0) ? [r] : d(P);
        if (y) {
          if (F === TD) return d(y).filter((D) => M.some((j) => I(D, j)));
          if (F === wh) return d(y).filter((D) => M.some((j) => I(j, D)));
          if (F === Ch) return d(y).filter((D) => M.some((j) => C(j, D)));
        }
        return M;
      }
      return L == null || y == null
        ? []
        : xe.IS_BROWSER_ENV && n
        ? d(y).filter((M) => n.contains(M))
        : K === wh
        ? d(L, y)
        : K === ID
        ? h(d(L)).filter(O(y))
        : K === Ch
        ? g(d(L)).filter(O(y))
        : d(y);
    }
    function qD({ element: e, actionItem: t }) {
      if (!xe.IS_BROWSER_ENV) return {};
      let { actionTypeId: r } = t;
      switch (r) {
        case Er:
        case hr:
        case gr:
        case _r:
        case di:
          return window.getComputedStyle(e);
        default:
          return {};
      }
    }
    var Ph = /px/,
      LD = (e, t) =>
        t.reduce(
          (r, n) => (r[n.type] == null && (r[n.type] = BD[n.type]), r),
          e || {},
        ),
      xD = (e, t) =>
        t.reduce(
          (r, n) => (
            r[n.type] == null &&
              (r[n.type] = WD[n.type] || n.defaultValue || 0),
            r
          ),
          e || {},
        );
    function MD(e, t = {}, r = {}, n, o) {
      let { getStyle: i } = o,
        { actionTypeId: a } = n;
      if ((0, ut.isPluginType)(a)) return (0, ut.getPluginOrigin)(a)(t[a], n);
      switch (n.actionTypeId) {
        case dr:
        case pr:
        case vr:
        case Zr:
          return t[n.actionTypeId] || Ya[n.actionTypeId];
        case Jr:
          return LD(t[n.actionTypeId], n.config.filters);
        case en:
          return xD(t[n.actionTypeId], n.config.fontVariations);
        case Gh:
          return { value: (0, Ot.default)(parseFloat(i(e, ci)), 1) };
        case Er: {
          let s = i(e, at),
            c = i(e, st),
            f,
            p;
          return (
            n.config.widthUnit === bt
              ? (f = Ph.test(s) ? parseFloat(s) : parseFloat(r.width))
              : (f = (0, Ot.default)(parseFloat(s), parseFloat(r.width))),
            n.config.heightUnit === bt
              ? (p = Ph.test(c) ? parseFloat(c) : parseFloat(r.height))
              : (p = (0, Ot.default)(parseFloat(c), parseFloat(r.height))),
            { widthValue: f, heightValue: p }
          );
        }
        case hr:
        case gr:
        case _r:
          return e1({
            element: e,
            actionTypeId: n.actionTypeId,
            computedStyle: r,
            getStyle: i,
          });
        case di:
          return { value: (0, Ot.default)(i(e, li), r.display) };
        case OD:
          return t[n.actionTypeId] || { value: 0 };
        default:
          return;
      }
    }
    var DD = (e, t) => (t && (e[t.type] = t.value || 0), e),
      FD = (e, t) => (t && (e[t.type] = t.value || 0), e),
      GD = (e, t, r) => {
        if ((0, ut.isPluginType)(e)) return (0, ut.getPluginConfig)(e)(r, t);
        switch (e) {
          case Jr: {
            let n = (0, Wa.default)(r.filters, ({ type: o }) => o === t);
            return n ? n.value : 0;
          }
          case en: {
            let n = (0, Wa.default)(r.fontVariations, ({ type: o }) => o === t);
            return n ? n.value : 0;
          }
          default:
            return r[t];
        }
      };
    se.getItemConfigByKey = GD;
    function XD({ element: e, actionItem: t, elementApi: r }) {
      if ((0, ut.isPluginType)(t.actionTypeId))
        return (0, ut.getPluginDestination)(t.actionTypeId)(t.config);
      switch (t.actionTypeId) {
        case dr:
        case pr:
        case vr:
        case Zr: {
          let { xValue: n, yValue: o, zValue: i } = t.config;
          return { xValue: n, yValue: o, zValue: i };
        }
        case Er: {
          let { getStyle: n, setStyle: o, getProperty: i } = r,
            { widthUnit: a, heightUnit: s } = t.config,
            { widthValue: c, heightValue: f } = t.config;
          if (!xe.IS_BROWSER_ENV) return { widthValue: c, heightValue: f };
          if (a === bt) {
            let p = n(e, at);
            o(e, at, ""), (c = i(e, "offsetWidth")), o(e, at, p);
          }
          if (s === bt) {
            let p = n(e, st);
            o(e, st, ""), (f = i(e, "offsetHeight")), o(e, st, p);
          }
          return { widthValue: c, heightValue: f };
        }
        case hr:
        case gr:
        case _r: {
          let { rValue: n, gValue: o, bValue: i, aValue: a } = t.config;
          return { rValue: n, gValue: o, bValue: i, aValue: a };
        }
        case Jr:
          return t.config.filters.reduce(DD, {});
        case en:
          return t.config.fontVariations.reduce(FD, {});
        default: {
          let { value: n } = t.config;
          return { value: n };
        }
      }
    }
    function Uh(e) {
      if (/^TRANSFORM_/.test(e)) return Dh;
      if (/^STYLE_/.test(e)) return ka;
      if (/^GENERAL_/.test(e)) return ja;
      if (/^PLUGIN_/.test(e)) return Fh;
    }
    function VD(e, t) {
      return e === ka ? t.replace("STYLE_", "").toLowerCase() : null;
    }
    function UD(e, t, r, n, o, i, a, s, c) {
      switch (s) {
        case Dh:
          return kD(e, t, r, o, a);
        case ka:
          return t1(e, t, r, o, i, a);
        case ja:
          return r1(e, o, a);
        case Fh: {
          let { actionTypeId: f } = o;
          if ((0, ut.isPluginType)(f)) return (0, ut.renderPlugin)(f)(c, t, o);
        }
      }
    }
    var Ya = {
        [dr]: Object.freeze({ xValue: 0, yValue: 0, zValue: 0 }),
        [pr]: Object.freeze({ xValue: 1, yValue: 1, zValue: 1 }),
        [vr]: Object.freeze({ xValue: 0, yValue: 0, zValue: 0 }),
        [Zr]: Object.freeze({ xValue: 0, yValue: 0 }),
      },
      BD = Object.freeze({
        blur: 0,
        "hue-rotate": 0,
        invert: 0,
        grayscale: 0,
        saturate: 100,
        sepia: 0,
        contrast: 100,
        brightness: 100,
      }),
      WD = Object.freeze({ wght: 0, opsz: 0, wdth: 0, slnt: 0 }),
      HD = (e, t) => {
        let r = (0, Wa.default)(t.filters, ({ type: n }) => n === e);
        if (r && r.unit) return r.unit;
        switch (e) {
          case "blur":
            return "px";
          case "hue-rotate":
            return "deg";
          default:
            return "%";
        }
      },
      jD = Object.keys(Ya);
    function kD(e, t, r, n, o) {
      let i = jD
          .map((s) => {
            let c = Ya[s],
              {
                xValue: f = c.xValue,
                yValue: p = c.yValue,
                zValue: d = c.zValue,
                xUnit: h = "",
                yUnit: g = "",
                zUnit: O = "",
              } = t[s] || {};
            switch (s) {
              case dr:
                return `${lD}(${f}${h}, ${p}${g}, ${d}${O})`;
              case pr:
                return `${fD}(${f}${h}, ${p}${g}, ${d}${O})`;
              case vr:
                return `${dD}(${f}${h}) ${pD}(${p}${g}) ${vD}(${d}${O})`;
              case Zr:
                return `${ED}(${f}${h}, ${p}${g})`;
              default:
                return "";
            }
          })
          .join(" "),
        { setStyle: a } = o;
      Vt(e, xe.TRANSFORM_PREFIXED, o),
        a(e, xe.TRANSFORM_PREFIXED, i),
        YD(n, r) && a(e, xe.TRANSFORM_STYLE_PREFIXED, hD);
    }
    function KD(e, t, r, n) {
      let o = (0, Ha.default)(t, (a, s, c) => `${a} ${c}(${s}${HD(c, r)})`, ""),
        { setStyle: i } = n;
      Vt(e, Yr, n), i(e, Yr, o);
    }
    function zD(e, t, r, n) {
      let o = (0, Ha.default)(
          t,
          (a, s, c) => (a.push(`"${c}" ${s}`), a),
          [],
        ).join(", "),
        { setStyle: i } = n;
      Vt(e, $r, n), i(e, $r, o);
    }
    function YD({ actionTypeId: e }, { xValue: t, yValue: r, zValue: n }) {
      return (
        (e === dr && n !== void 0) ||
        (e === pr && n !== void 0) ||
        (e === vr && (t !== void 0 || r !== void 0))
      );
    }
    var $D = "\\(([^)]+)\\)",
      QD = /^rgb/,
      ZD = RegExp(`rgba?${$D}`);
    function JD(e, t) {
      let r = e.exec(t);
      return r ? r[1] : "";
    }
    function e1({
      element: e,
      actionTypeId: t,
      computedStyle: r,
      getStyle: n,
    }) {
      let o = Ka[t],
        i = n(e, o),
        a = QD.test(i) ? i : r[o],
        s = JD(ZD, a).split(Qr);
      return {
        rValue: (0, Ot.default)(parseInt(s[0], 10), 255),
        gValue: (0, Ot.default)(parseInt(s[1], 10), 255),
        bValue: (0, Ot.default)(parseInt(s[2], 10), 255),
        aValue: (0, Ot.default)(parseFloat(s[3]), 1),
      };
    }
    function t1(e, t, r, n, o, i) {
      let { setStyle: a } = i;
      switch (n.actionTypeId) {
        case Er: {
          let { widthUnit: s = "", heightUnit: c = "" } = n.config,
            { widthValue: f, heightValue: p } = r;
          f !== void 0 &&
            (s === bt && (s = "px"), Vt(e, at, i), a(e, at, f + s)),
            p !== void 0 &&
              (c === bt && (c = "px"), Vt(e, st, i), a(e, st, p + c));
          break;
        }
        case Jr: {
          KD(e, r, n.config, i);
          break;
        }
        case en: {
          zD(e, r, n.config, i);
          break;
        }
        case hr:
        case gr:
        case _r: {
          let s = Ka[n.actionTypeId],
            c = Math.round(r.rValue),
            f = Math.round(r.gValue),
            p = Math.round(r.bValue),
            d = r.aValue;
          Vt(e, s, i),
            a(
              e,
              s,
              d >= 1 ? `rgb(${c},${f},${p})` : `rgba(${c},${f},${p},${d})`,
            );
          break;
        }
        default: {
          let { unit: s = "" } = n.config;
          Vt(e, o, i), a(e, o, r.value + s);
          break;
        }
      }
    }
    function r1(e, t, r) {
      let { setStyle: n } = r;
      switch (t.actionTypeId) {
        case di: {
          let { value: o } = t.config;
          o === gD && xe.IS_BROWSER_ENV
            ? n(e, li, xe.FLEX_PREFIXED)
            : n(e, li, o);
          return;
        }
      }
    }
    function Vt(e, t, r) {
      if (!xe.IS_BROWSER_ENV) return;
      let n = Vh[t];
      if (!n) return;
      let { getStyle: o, setStyle: i } = r,
        a = o(e, fr);
      if (!a) {
        i(e, fr, n);
        return;
      }
      let s = a.split(Qr).map(Xh);
      s.indexOf(n) === -1 && i(e, fr, s.concat(n).join(Qr));
    }
    function Bh(e, t, r) {
      if (!xe.IS_BROWSER_ENV) return;
      let n = Vh[t];
      if (!n) return;
      let { getStyle: o, setStyle: i } = r,
        a = o(e, fr);
      !a ||
        a.indexOf(n) === -1 ||
        i(
          e,
          fr,
          a
            .split(Qr)
            .map(Xh)
            .filter((s) => s !== n)
            .join(Qr),
        );
    }
    function n1({ store: e, elementApi: t }) {
      let { ixData: r } = e.getState(),
        { events: n = {}, actionLists: o = {} } = r;
      Object.keys(n).forEach((i) => {
        let a = n[i],
          { config: s } = a.action,
          { actionListId: c } = s,
          f = o[c];
        f && qh({ actionList: f, event: a, elementApi: t });
      }),
        Object.keys(o).forEach((i) => {
          qh({ actionList: o[i], elementApi: t });
        });
    }
    function qh({ actionList: e = {}, event: t, elementApi: r }) {
      let { actionItemGroups: n, continuousParameterGroups: o } = e;
      n &&
        n.forEach((i) => {
          Lh({ actionGroup: i, event: t, elementApi: r });
        }),
        o &&
          o.forEach((i) => {
            let { continuousActionGroups: a } = i;
            a.forEach((s) => {
              Lh({ actionGroup: s, event: t, elementApi: r });
            });
          });
    }
    function Lh({ actionGroup: e, event: t, elementApi: r }) {
      let { actionItems: n } = e;
      n.forEach((o) => {
        let { actionTypeId: i, config: a } = o,
          s;
        (0, ut.isPluginType)(i)
          ? (s = (c) => (0, ut.clearPlugin)(i)(c, o))
          : (s = Wh({ effect: o1, actionTypeId: i, elementApi: r })),
          za({ config: a, event: t, elementApi: r }).forEach(s);
      });
    }
    function i1(e, t, r) {
      let { setStyle: n, getStyle: o } = r,
        { actionTypeId: i } = t;
      if (i === Er) {
        let { config: a } = t;
        a.widthUnit === bt && n(e, at, ""), a.heightUnit === bt && n(e, st, "");
      }
      o(e, fr) && Wh({ effect: Bh, actionTypeId: i, elementApi: r })(e);
    }
    var Wh =
      ({ effect: e, actionTypeId: t, elementApi: r }) =>
      (n) => {
        switch (t) {
          case dr:
          case pr:
          case vr:
          case Zr:
            e(n, xe.TRANSFORM_PREFIXED, r);
            break;
          case Jr:
            e(n, Yr, r);
            break;
          case en:
            e(n, $r, r);
            break;
          case Gh:
            e(n, ci, r);
            break;
          case Er:
            e(n, at, r), e(n, st, r);
            break;
          case hr:
          case gr:
          case _r:
            e(n, Ka[t], r);
            break;
          case di:
            e(n, li, r);
            break;
        }
      };
    function o1(e, t, r) {
      let { setStyle: n } = r;
      Bh(e, t, r),
        n(e, t, ""),
        t === xe.TRANSFORM_PREFIXED && n(e, xe.TRANSFORM_STYLE_PREFIXED, "");
    }
    function Hh(e) {
      let t = 0,
        r = 0;
      return (
        e.forEach((n, o) => {
          let { config: i } = n,
            a = i.delay + i.duration;
          a >= t && ((t = a), (r = o));
        }),
        r
      );
    }
    function a1(e, t) {
      let { actionItemGroups: r, useFirstGroupAsInitialState: n } = e,
        { actionItem: o, verboseTimeElapsed: i = 0 } = t,
        a = 0,
        s = 0;
      return (
        r.forEach((c, f) => {
          if (n && f === 0) return;
          let { actionItems: p } = c,
            d = p[Hh(p)],
            { config: h, actionTypeId: g } = d;
          o.id === d.id && (s = a + i);
          let O = Uh(g) === ja ? 0 : h.duration;
          a += h.delay + O;
        }),
        a > 0 ? (0, sD.optimizeFloat)(s / a) : 0
      );
    }
    function s1({ actionList: e, actionItemId: t, rawData: r }) {
      let { actionItemGroups: n, continuousParameterGroups: o } = e,
        i = [],
        a = (s) => (
          i.push((0, Rh.mergeIn)(s, ["config"], { delay: 0, duration: 0 })),
          s.id === t
        );
      return (
        n && n.some(({ actionItems: s }) => s.some(a)),
        o &&
          o.some((s) => {
            let { continuousActionGroups: c } = s;
            return c.some(({ actionItems: f }) => f.some(a));
          }),
        (0, Rh.setIn)(r, ["actionLists"], {
          [e.id]: { id: e.id, actionItemGroups: [{ actionItems: i }] },
        })
      );
    }
    function u1(e, { basedOn: t }) {
      return (
        (e === Xt.EventTypeConsts.SCROLLING_IN_VIEW &&
          (t === Xt.EventBasedOn.ELEMENT || t == null)) ||
        (e === Xt.EventTypeConsts.MOUSE_MOVE && t === Xt.EventBasedOn.ELEMENT)
      );
    }
    function c1(e, t) {
      return e + mD + t;
    }
    function l1(e, t) {
      return t == null ? !0 : e.indexOf(t) !== -1;
    }
    function f1(e, t) {
      return (0, xh.default)(e && e.sort(), t && t.sort());
    }
    function d1(e) {
      if (typeof e == "string") return e;
      if (e.pluginElement && e.objectId)
        return e.pluginElement + Ba + e.objectId;
      if (e.objectId) return e.objectId;
      let { id: t = "", selector: r = "", useEventTarget: n = "" } = e;
      return t + Ba + r + Ba + n;
    }
  });
  var Ut = u((Me) => {
    "use strict";
    var yr = qt().default;
    Object.defineProperty(Me, "__esModule", { value: !0 });
    Me.IX2VanillaUtils =
      Me.IX2VanillaPlugins =
      Me.IX2ElementsReducer =
      Me.IX2Easings =
      Me.IX2EasingUtils =
      Me.IX2BrowserSupport =
        void 0;
    var p1 = yr(ti());
    Me.IX2BrowserSupport = p1;
    var v1 = yr(qa());
    Me.IX2Easings = v1;
    var E1 = yr(xa());
    Me.IX2EasingUtils = E1;
    var h1 = yr(QE());
    Me.IX2ElementsReducer = h1;
    var g1 = yr(Xa());
    Me.IX2VanillaPlugins = g1;
    var _1 = yr(jh());
    Me.IX2VanillaUtils = _1;
  });
  var Yh = u((vi) => {
    "use strict";
    Object.defineProperty(vi, "__esModule", { value: !0 });
    vi.ixInstances = void 0;
    var kh = Fe(),
      Kh = Ut(),
      Ir = tr(),
      {
        IX2_RAW_DATA_IMPORTED: y1,
        IX2_SESSION_STOPPED: I1,
        IX2_INSTANCE_ADDED: T1,
        IX2_INSTANCE_STARTED: m1,
        IX2_INSTANCE_REMOVED: O1,
        IX2_ANIMATION_FRAME_CHANGED: b1,
      } = kh.IX2EngineActionTypes,
      {
        optimizeFloat: pi,
        applyEasing: zh,
        createBezierEasing: A1,
      } = Kh.IX2EasingUtils,
      { RENDER_GENERAL: S1 } = kh.IX2EngineConstants,
      {
        getItemConfigByKey: $a,
        getRenderType: R1,
        getStyleProp: w1,
      } = Kh.IX2VanillaUtils,
      C1 = (e, t) => {
        let {
            position: r,
            parameterId: n,
            actionGroups: o,
            destinationKeys: i,
            smoothing: a,
            restingValue: s,
            actionTypeId: c,
            customEasingFn: f,
            skipMotion: p,
            skipToValue: d,
          } = e,
          { parameters: h } = t.payload,
          g = Math.max(1 - a, 0.01),
          O = h[n];
        O == null && ((g = 1), (O = s));
        let I = Math.max(O, 0) || 0,
          C = pi(I - r),
          A = p ? d : pi(r + C * g),
          R = A * 100;
        if (A === r && e.current) return e;
        let T, q, x, N;
        for (let U = 0, { length: W } = o; U < W; U++) {
          let { keyframe: ee, actionItems: K } = o[U];
          if ((U === 0 && (T = K[0]), R >= ee)) {
            T = K[0];
            let L = o[U + 1],
              y = L && R !== ee;
            (q = y ? L.actionItems[0] : null),
              y && ((x = ee / 100), (N = (L.keyframe - ee) / 100));
          }
        }
        let F = {};
        if (T && !q)
          for (let U = 0, { length: W } = i; U < W; U++) {
            let ee = i[U];
            F[ee] = $a(c, ee, T.config);
          }
        else if (T && q && x !== void 0 && N !== void 0) {
          let U = (A - x) / N,
            W = T.config.easing,
            ee = zh(W, U, f);
          for (let K = 0, { length: L } = i; K < L; K++) {
            let y = i[K],
              P = $a(c, y, T.config),
              j = ($a(c, y, q.config) - P) * ee + P;
            F[y] = j;
          }
        }
        return (0, Ir.merge)(e, { position: A, current: F });
      },
      N1 = (e, t) => {
        let {
            active: r,
            origin: n,
            start: o,
            immediate: i,
            renderType: a,
            verbose: s,
            actionItem: c,
            destination: f,
            destinationKeys: p,
            pluginDuration: d,
            instanceDelay: h,
            customEasingFn: g,
            skipMotion: O,
          } = e,
          I = c.config.easing,
          { duration: C, delay: A } = c.config;
        d != null && (C = d),
          (A = h ?? A),
          a === S1 ? (C = 0) : (i || O) && (C = A = 0);
        let { now: R } = t.payload;
        if (r && n) {
          let T = R - (o + A);
          if (s) {
            let U = R - o,
              W = C + A,
              ee = pi(Math.min(Math.max(0, U / W), 1));
            e = (0, Ir.set)(e, "verboseTimeElapsed", W * ee);
          }
          if (T < 0) return e;
          let q = pi(Math.min(Math.max(0, T / C), 1)),
            x = zh(I, q, g),
            N = {},
            F = null;
          return (
            p.length &&
              (F = p.reduce((U, W) => {
                let ee = f[W],
                  K = parseFloat(n[W]) || 0,
                  y = (parseFloat(ee) - K) * x + K;
                return (U[W] = y), U;
              }, {})),
            (N.current = F),
            (N.position = q),
            q === 1 && ((N.active = !1), (N.complete = !0)),
            (0, Ir.merge)(e, N)
          );
        }
        return e;
      },
      P1 = (e = Object.freeze({}), t) => {
        switch (t.type) {
          case y1:
            return t.payload.ixInstances || Object.freeze({});
          case I1:
            return Object.freeze({});
          case T1: {
            let {
                instanceId: r,
                elementId: n,
                actionItem: o,
                eventId: i,
                eventTarget: a,
                eventStateKey: s,
                actionListId: c,
                groupIndex: f,
                isCarrier: p,
                origin: d,
                destination: h,
                immediate: g,
                verbose: O,
                continuous: I,
                parameterId: C,
                actionGroups: A,
                smoothing: R,
                restingValue: T,
                pluginInstance: q,
                pluginDuration: x,
                instanceDelay: N,
                skipMotion: F,
                skipToValue: U,
              } = t.payload,
              { actionTypeId: W } = o,
              ee = R1(W),
              K = w1(ee, W),
              L = Object.keys(h).filter(
                (P) => h[P] != null && typeof h[P] != "string",
              ),
              { easing: y } = o.config;
            return (0, Ir.set)(e, r, {
              id: r,
              elementId: n,
              active: !1,
              position: 0,
              start: 0,
              origin: d,
              destination: h,
              destinationKeys: L,
              immediate: g,
              verbose: O,
              current: null,
              actionItem: o,
              actionTypeId: W,
              eventId: i,
              eventTarget: a,
              eventStateKey: s,
              actionListId: c,
              groupIndex: f,
              renderType: ee,
              isCarrier: p,
              styleProp: K,
              continuous: I,
              parameterId: C,
              actionGroups: A,
              smoothing: R,
              restingValue: T,
              pluginInstance: q,
              pluginDuration: x,
              instanceDelay: N,
              skipMotion: F,
              skipToValue: U,
              customEasingFn:
                Array.isArray(y) && y.length === 4 ? A1(y) : void 0,
            });
          }
          case m1: {
            let { instanceId: r, time: n } = t.payload;
            return (0, Ir.mergeIn)(e, [r], {
              active: !0,
              complete: !1,
              start: n,
            });
          }
          case O1: {
            let { instanceId: r } = t.payload;
            if (!e[r]) return e;
            let n = {},
              o = Object.keys(e),
              { length: i } = o;
            for (let a = 0; a < i; a++) {
              let s = o[a];
              s !== r && (n[s] = e[s]);
            }
            return n;
          }
          case b1: {
            let r = e,
              n = Object.keys(e),
              { length: o } = n;
            for (let i = 0; i < o; i++) {
              let a = n[i],
                s = e[a],
                c = s.continuous ? C1 : N1;
              r = (0, Ir.set)(r, a, c(s, t));
            }
            return r;
          }
          default:
            return e;
        }
      };
    vi.ixInstances = P1;
  });
  var $h = u((Ei) => {
    "use strict";
    Object.defineProperty(Ei, "__esModule", { value: !0 });
    Ei.ixParameters = void 0;
    var q1 = Fe(),
      {
        IX2_RAW_DATA_IMPORTED: L1,
        IX2_SESSION_STOPPED: x1,
        IX2_PARAMETER_CHANGED: M1,
      } = q1.IX2EngineActionTypes,
      D1 = (e = {}, t) => {
        switch (t.type) {
          case L1:
            return t.payload.ixParameters || {};
          case x1:
            return {};
          case M1: {
            let { key: r, value: n } = t.payload;
            return (e[r] = n), e;
          }
          default:
            return e;
        }
      };
    Ei.ixParameters = D1;
  });
  var Qh = u((hi) => {
    "use strict";
    Object.defineProperty(hi, "__esModule", { value: !0 });
    hi.default = void 0;
    var F1 = Yo(),
      G1 = Ef(),
      X1 = xf(),
      V1 = Df(),
      U1 = Ut(),
      B1 = Yh(),
      W1 = $h(),
      { ixElements: H1 } = U1.IX2ElementsReducer,
      j1 = (0, F1.combineReducers)({
        ixData: G1.ixData,
        ixRequest: X1.ixRequest,
        ixSession: V1.ixSession,
        ixElements: H1,
        ixInstances: B1.ixInstances,
        ixParameters: W1.ixParameters,
      });
    hi.default = j1;
  });
  var Zh = u((fk, tn) => {
    function k1(e, t) {
      if (e == null) return {};
      var r = {},
        n = Object.keys(e),
        o,
        i;
      for (i = 0; i < n.length; i++)
        (o = n[i]), !(t.indexOf(o) >= 0) && (r[o] = e[o]);
      return r;
    }
    (tn.exports = k1),
      (tn.exports.__esModule = !0),
      (tn.exports.default = tn.exports);
  });
  var eg = u((dk, Jh) => {
    var K1 = It(),
      z1 = Ae(),
      Y1 = dt(),
      $1 = "[object String]";
    function Q1(e) {
      return typeof e == "string" || (!z1(e) && Y1(e) && K1(e) == $1);
    }
    Jh.exports = Q1;
  });
  var rg = u((pk, tg) => {
    var Z1 = Sa(),
      J1 = Z1("length");
    tg.exports = J1;
  });
  var ig = u((vk, ng) => {
    var e2 = "\\ud800-\\udfff",
      t2 = "\\u0300-\\u036f",
      r2 = "\\ufe20-\\ufe2f",
      n2 = "\\u20d0-\\u20ff",
      i2 = t2 + r2 + n2,
      o2 = "\\ufe0e\\ufe0f",
      a2 = "\\u200d",
      s2 = RegExp("[" + a2 + e2 + i2 + o2 + "]");
    function u2(e) {
      return s2.test(e);
    }
    ng.exports = u2;
  });
  var pg = u((Ek, dg) => {
    var ag = "\\ud800-\\udfff",
      c2 = "\\u0300-\\u036f",
      l2 = "\\ufe20-\\ufe2f",
      f2 = "\\u20d0-\\u20ff",
      d2 = c2 + l2 + f2,
      p2 = "\\ufe0e\\ufe0f",
      v2 = "[" + ag + "]",
      Qa = "[" + d2 + "]",
      Za = "\\ud83c[\\udffb-\\udfff]",
      E2 = "(?:" + Qa + "|" + Za + ")",
      sg = "[^" + ag + "]",
      ug = "(?:\\ud83c[\\udde6-\\uddff]){2}",
      cg = "[\\ud800-\\udbff][\\udc00-\\udfff]",
      h2 = "\\u200d",
      lg = E2 + "?",
      fg = "[" + p2 + "]?",
      g2 = "(?:" + h2 + "(?:" + [sg, ug, cg].join("|") + ")" + fg + lg + ")*",
      _2 = fg + lg + g2,
      y2 = "(?:" + [sg + Qa + "?", Qa, ug, cg, v2].join("|") + ")",
      og = RegExp(Za + "(?=" + Za + ")|" + y2 + _2, "g");
    function I2(e) {
      for (var t = (og.lastIndex = 0); og.test(e); ) ++t;
      return t;
    }
    dg.exports = I2;
  });
  var Eg = u((hk, vg) => {
    var T2 = rg(),
      m2 = ig(),
      O2 = pg();
    function b2(e) {
      return m2(e) ? O2(e) : T2(e);
    }
    vg.exports = b2;
  });
  var gg = u((gk, hg) => {
    var A2 = kn(),
      S2 = Kn(),
      R2 = Dt(),
      w2 = eg(),
      C2 = Eg(),
      N2 = "[object Map]",
      P2 = "[object Set]";
    function q2(e) {
      if (e == null) return 0;
      if (R2(e)) return w2(e) ? C2(e) : e.length;
      var t = S2(e);
      return t == N2 || t == P2 ? e.size : A2(e).length;
    }
    hg.exports = q2;
  });
  var yg = u((_k, _g) => {
    var L2 = "Expected a function";
    function x2(e) {
      if (typeof e != "function") throw new TypeError(L2);
      return function () {
        var t = arguments;
        switch (t.length) {
          case 0:
            return !e.call(this);
          case 1:
            return !e.call(this, t[0]);
          case 2:
            return !e.call(this, t[0], t[1]);
          case 3:
            return !e.call(this, t[0], t[1], t[2]);
        }
        return !e.apply(this, t);
      };
    }
    _g.exports = x2;
  });
  var Ja = u((yk, Ig) => {
    var M2 = Tt(),
      D2 = (function () {
        try {
          var e = M2(Object, "defineProperty");
          return e({}, "", {}), e;
        } catch {}
      })();
    Ig.exports = D2;
  });
  var es = u((Ik, mg) => {
    var Tg = Ja();
    function F2(e, t, r) {
      t == "__proto__" && Tg
        ? Tg(e, t, { configurable: !0, enumerable: !0, value: r, writable: !0 })
        : (e[t] = r);
    }
    mg.exports = F2;
  });
  var bg = u((Tk, Og) => {
    var G2 = es(),
      X2 = Dn(),
      V2 = Object.prototype,
      U2 = V2.hasOwnProperty;
    function B2(e, t, r) {
      var n = e[t];
      (!(U2.call(e, t) && X2(n, r)) || (r === void 0 && !(t in e))) &&
        G2(e, t, r);
    }
    Og.exports = B2;
  });
  var Rg = u((mk, Sg) => {
    var W2 = bg(),
      H2 = kr(),
      j2 = Bn(),
      Ag = ot(),
      k2 = cr();
    function K2(e, t, r, n) {
      if (!Ag(e)) return e;
      t = H2(t, e);
      for (var o = -1, i = t.length, a = i - 1, s = e; s != null && ++o < i; ) {
        var c = k2(t[o]),
          f = r;
        if (c === "__proto__" || c === "constructor" || c === "prototype")
          return e;
        if (o != a) {
          var p = s[c];
          (f = n ? n(p, c, s) : void 0),
            f === void 0 && (f = Ag(p) ? p : j2(t[o + 1]) ? [] : {});
        }
        W2(s, c, f), (s = s[c]);
      }
      return e;
    }
    Sg.exports = K2;
  });
  var Cg = u((Ok, wg) => {
    var z2 = $n(),
      Y2 = Rg(),
      $2 = kr();
    function Q2(e, t, r) {
      for (var n = -1, o = t.length, i = {}; ++n < o; ) {
        var a = t[n],
          s = z2(e, a);
        r(s, a) && Y2(i, $2(a, e), s);
      }
      return i;
    }
    wg.exports = Q2;
  });
  var Pg = u((bk, Ng) => {
    var Z2 = Vn(),
      J2 = Do(),
      eF = fa(),
      tF = la(),
      rF = Object.getOwnPropertySymbols,
      nF = rF
        ? function (e) {
            for (var t = []; e; ) Z2(t, eF(e)), (e = J2(e));
            return t;
          }
        : tF;
    Ng.exports = nF;
  });
  var Lg = u((Ak, qg) => {
    function iF(e) {
      var t = [];
      if (e != null) for (var r in Object(e)) t.push(r);
      return t;
    }
    qg.exports = iF;
  });
  var Mg = u((Sk, xg) => {
    var oF = ot(),
      aF = jn(),
      sF = Lg(),
      uF = Object.prototype,
      cF = uF.hasOwnProperty;
    function lF(e) {
      if (!oF(e)) return sF(e);
      var t = aF(e),
        r = [];
      for (var n in e)
        (n == "constructor" && (t || !cF.call(e, n))) || r.push(n);
      return r;
    }
    xg.exports = lF;
  });
  var Fg = u((Rk, Dg) => {
    var fF = pa(),
      dF = Mg(),
      pF = Dt();
    function vF(e) {
      return pF(e) ? fF(e, !0) : dF(e);
    }
    Dg.exports = vF;
  });
  var Xg = u((wk, Gg) => {
    var EF = ca(),
      hF = Pg(),
      gF = Fg();
    function _F(e) {
      return EF(e, gF, hF);
    }
    Gg.exports = _F;
  });
  var Ug = u((Ck, Vg) => {
    var yF = Aa(),
      IF = mt(),
      TF = Cg(),
      mF = Xg();
    function OF(e, t) {
      if (e == null) return {};
      var r = yF(mF(e), function (n) {
        return [n];
      });
      return (
        (t = IF(t)),
        TF(e, r, function (n, o) {
          return t(n, o[0]);
        })
      );
    }
    Vg.exports = OF;
  });
  var Wg = u((Nk, Bg) => {
    var bF = mt(),
      AF = yg(),
      SF = Ug();
    function RF(e, t) {
      return SF(e, AF(bF(t)));
    }
    Bg.exports = RF;
  });
  var jg = u((Pk, Hg) => {
    var wF = kn(),
      CF = Kn(),
      NF = Vr(),
      PF = Ae(),
      qF = Dt(),
      LF = Un(),
      xF = jn(),
      MF = Hn(),
      DF = "[object Map]",
      FF = "[object Set]",
      GF = Object.prototype,
      XF = GF.hasOwnProperty;
    function VF(e) {
      if (e == null) return !0;
      if (
        qF(e) &&
        (PF(e) ||
          typeof e == "string" ||
          typeof e.splice == "function" ||
          LF(e) ||
          MF(e) ||
          NF(e))
      )
        return !e.length;
      var t = CF(e);
      if (t == DF || t == FF) return !e.size;
      if (xF(e)) return !wF(e).length;
      for (var r in e) if (XF.call(e, r)) return !1;
      return !0;
    }
    Hg.exports = VF;
  });
  var Kg = u((qk, kg) => {
    var UF = es(),
      BF = Va(),
      WF = mt();
    function HF(e, t) {
      var r = {};
      return (
        (t = WF(t, 3)),
        BF(e, function (n, o, i) {
          UF(r, o, t(n, o, i));
        }),
        r
      );
    }
    kg.exports = HF;
  });
  var Yg = u((Lk, zg) => {
    function jF(e, t) {
      for (
        var r = -1, n = e == null ? 0 : e.length;
        ++r < n && t(e[r], r, e) !== !1;

      );
      return e;
    }
    zg.exports = jF;
  });
  var Qg = u((xk, $g) => {
    var kF = Zn();
    function KF(e) {
      return typeof e == "function" ? e : kF;
    }
    $g.exports = KF;
  });
  var Jg = u((Mk, Zg) => {
    var zF = Yg(),
      YF = Ua(),
      $F = Qg(),
      QF = Ae();
    function ZF(e, t) {
      var r = QF(e) ? zF : YF;
      return r(e, $F(t));
    }
    Zg.exports = ZF;
  });
  var t_ = u((Dk, e_) => {
    var JF = $e(),
      eG = function () {
        return JF.Date.now();
      };
    e_.exports = eG;
  });
  var i_ = u((Fk, n_) => {
    var tG = ot(),
      ts = t_(),
      r_ = Jn(),
      rG = "Expected a function",
      nG = Math.max,
      iG = Math.min;
    function oG(e, t, r) {
      var n,
        o,
        i,
        a,
        s,
        c,
        f = 0,
        p = !1,
        d = !1,
        h = !0;
      if (typeof e != "function") throw new TypeError(rG);
      (t = r_(t) || 0),
        tG(r) &&
          ((p = !!r.leading),
          (d = "maxWait" in r),
          (i = d ? nG(r_(r.maxWait) || 0, t) : i),
          (h = "trailing" in r ? !!r.trailing : h));
      function g(N) {
        var F = n,
          U = o;
        return (n = o = void 0), (f = N), (a = e.apply(U, F)), a;
      }
      function O(N) {
        return (f = N), (s = setTimeout(A, t)), p ? g(N) : a;
      }
      function I(N) {
        var F = N - c,
          U = N - f,
          W = t - F;
        return d ? iG(W, i - U) : W;
      }
      function C(N) {
        var F = N - c,
          U = N - f;
        return c === void 0 || F >= t || F < 0 || (d && U >= i);
      }
      function A() {
        var N = ts();
        if (C(N)) return R(N);
        s = setTimeout(A, I(N));
      }
      function R(N) {
        return (s = void 0), h && n ? g(N) : ((n = o = void 0), a);
      }
      function T() {
        s !== void 0 && clearTimeout(s), (f = 0), (n = c = o = s = void 0);
      }
      function q() {
        return s === void 0 ? a : R(ts());
      }
      function x() {
        var N = ts(),
          F = C(N);
        if (((n = arguments), (o = this), (c = N), F)) {
          if (s === void 0) return O(c);
          if (d) return clearTimeout(s), (s = setTimeout(A, t)), g(c);
        }
        return s === void 0 && (s = setTimeout(A, t)), a;
      }
      return (x.cancel = T), (x.flush = q), x;
    }
    n_.exports = oG;
  });
  var a_ = u((Gk, o_) => {
    var aG = i_(),
      sG = ot(),
      uG = "Expected a function";
    function cG(e, t, r) {
      var n = !0,
        o = !0;
      if (typeof e != "function") throw new TypeError(uG);
      return (
        sG(r) &&
          ((n = "leading" in r ? !!r.leading : n),
          (o = "trailing" in r ? !!r.trailing : o)),
        aG(e, t, { leading: n, maxWait: t, trailing: o })
      );
    }
    o_.exports = cG;
  });
  var gi = u((J) => {
    "use strict";
    var lG = Ke().default;
    Object.defineProperty(J, "__esModule", { value: !0 });
    J.viewportWidthChanged =
      J.testFrameRendered =
      J.stopRequested =
      J.sessionStopped =
      J.sessionStarted =
      J.sessionInitialized =
      J.rawDataImported =
      J.previewRequested =
      J.playbackRequested =
      J.parameterChanged =
      J.mediaQueriesDefined =
      J.instanceStarted =
      J.instanceRemoved =
      J.instanceAdded =
      J.eventStateChanged =
      J.eventListenerAdded =
      J.elementStateChanged =
      J.clearRequested =
      J.animationFrameChanged =
      J.actionListPlaybackChanged =
        void 0;
    var s_ = lG(er()),
      u_ = Fe(),
      fG = Ut(),
      {
        IX2_RAW_DATA_IMPORTED: dG,
        IX2_SESSION_INITIALIZED: pG,
        IX2_SESSION_STARTED: vG,
        IX2_SESSION_STOPPED: EG,
        IX2_PREVIEW_REQUESTED: hG,
        IX2_PLAYBACK_REQUESTED: gG,
        IX2_STOP_REQUESTED: _G,
        IX2_CLEAR_REQUESTED: yG,
        IX2_EVENT_LISTENER_ADDED: IG,
        IX2_TEST_FRAME_RENDERED: TG,
        IX2_EVENT_STATE_CHANGED: mG,
        IX2_ANIMATION_FRAME_CHANGED: OG,
        IX2_PARAMETER_CHANGED: bG,
        IX2_INSTANCE_ADDED: AG,
        IX2_INSTANCE_STARTED: SG,
        IX2_INSTANCE_REMOVED: RG,
        IX2_ELEMENT_STATE_CHANGED: wG,
        IX2_ACTION_LIST_PLAYBACK_CHANGED: CG,
        IX2_VIEWPORT_WIDTH_CHANGED: NG,
        IX2_MEDIA_QUERIES_DEFINED: PG,
      } = u_.IX2EngineActionTypes,
      { reifyState: qG } = fG.IX2VanillaUtils,
      LG = (e) => ({ type: dG, payload: (0, s_.default)({}, qG(e)) });
    J.rawDataImported = LG;
    var xG = ({ hasBoundaryNodes: e, reducedMotion: t }) => ({
      type: pG,
      payload: { hasBoundaryNodes: e, reducedMotion: t },
    });
    J.sessionInitialized = xG;
    var MG = () => ({ type: vG });
    J.sessionStarted = MG;
    var DG = () => ({ type: EG });
    J.sessionStopped = DG;
    var FG = ({ rawData: e, defer: t }) => ({
      type: hG,
      payload: { defer: t, rawData: e },
    });
    J.previewRequested = FG;
    var GG = ({
      actionTypeId: e = u_.ActionTypeConsts.GENERAL_START_ACTION,
      actionListId: t,
      actionItemId: r,
      eventId: n,
      allowEvents: o,
      immediate: i,
      testManual: a,
      verbose: s,
      rawData: c,
    }) => ({
      type: gG,
      payload: {
        actionTypeId: e,
        actionListId: t,
        actionItemId: r,
        testManual: a,
        eventId: n,
        allowEvents: o,
        immediate: i,
        verbose: s,
        rawData: c,
      },
    });
    J.playbackRequested = GG;
    var XG = (e) => ({ type: _G, payload: { actionListId: e } });
    J.stopRequested = XG;
    var VG = () => ({ type: yG });
    J.clearRequested = VG;
    var UG = (e, t) => ({
      type: IG,
      payload: { target: e, listenerParams: t },
    });
    J.eventListenerAdded = UG;
    var BG = (e = 1) => ({ type: TG, payload: { step: e } });
    J.testFrameRendered = BG;
    var WG = (e, t) => ({ type: mG, payload: { stateKey: e, newState: t } });
    J.eventStateChanged = WG;
    var HG = (e, t) => ({ type: OG, payload: { now: e, parameters: t } });
    J.animationFrameChanged = HG;
    var jG = (e, t) => ({ type: bG, payload: { key: e, value: t } });
    J.parameterChanged = jG;
    var kG = (e) => ({ type: AG, payload: (0, s_.default)({}, e) });
    J.instanceAdded = kG;
    var KG = (e, t) => ({ type: SG, payload: { instanceId: e, time: t } });
    J.instanceStarted = KG;
    var zG = (e) => ({ type: RG, payload: { instanceId: e } });
    J.instanceRemoved = zG;
    var YG = (e, t, r, n) => ({
      type: wG,
      payload: { elementId: e, actionTypeId: t, current: r, actionItem: n },
    });
    J.elementStateChanged = YG;
    var $G = ({ actionListId: e, isPlaying: t }) => ({
      type: CG,
      payload: { actionListId: e, isPlaying: t },
    });
    J.actionListPlaybackChanged = $G;
    var QG = ({ width: e, mediaQueries: t }) => ({
      type: NG,
      payload: { width: e, mediaQueries: t },
    });
    J.viewportWidthChanged = QG;
    var ZG = () => ({ type: PG });
    J.mediaQueriesDefined = ZG;
  });
  var f_ = u((we) => {
    "use strict";
    Object.defineProperty(we, "__esModule", { value: !0 });
    we.elementContains = lX;
    we.getChildElements = dX;
    we.getClosestElement = void 0;
    we.getProperty = oX;
    we.getQuerySelector = sX;
    we.getRefType = EX;
    we.getSiblingElements = pX;
    we.getStyle = iX;
    we.getValidDocument = uX;
    we.isSiblingNode = fX;
    we.matchSelector = aX;
    we.queryDocument = cX;
    we.setStyle = nX;
    var JG = Ut(),
      eX = Fe(),
      { ELEMENT_MATCHES: rs } = JG.IX2BrowserSupport,
      {
        IX2_ID_DELIMITER: c_,
        HTML_ELEMENT: tX,
        PLAIN_OBJECT: rX,
        WF_PAGE: l_,
      } = eX.IX2EngineConstants;
    function nX(e, t, r) {
      e.style[t] = r;
    }
    function iX(e, t) {
      return e.style[t];
    }
    function oX(e, t) {
      return e[t];
    }
    function aX(e) {
      return (t) => t[rs](e);
    }
    function sX({ id: e, selector: t }) {
      if (e) {
        let r = e;
        if (e.indexOf(c_) !== -1) {
          let n = e.split(c_),
            o = n[0];
          if (((r = n[1]), o !== document.documentElement.getAttribute(l_)))
            return null;
        }
        return `[data-w-id="${r}"], [data-w-id^="${r}_instance"]`;
      }
      return t;
    }
    function uX(e) {
      return e == null || e === document.documentElement.getAttribute(l_)
        ? document
        : null;
    }
    function cX(e, t) {
      return Array.prototype.slice.call(
        document.querySelectorAll(t ? e + " " + t : e),
      );
    }
    function lX(e, t) {
      return e.contains(t);
    }
    function fX(e, t) {
      return e !== t && e.parentNode === t.parentNode;
    }
    function dX(e) {
      let t = [];
      for (let r = 0, { length: n } = e || []; r < n; r++) {
        let { children: o } = e[r],
          { length: i } = o;
        if (i) for (let a = 0; a < i; a++) t.push(o[a]);
      }
      return t;
    }
    function pX(e = []) {
      let t = [],
        r = [];
      for (let n = 0, { length: o } = e; n < o; n++) {
        let { parentNode: i } = e[n];
        if (!i || !i.children || !i.children.length || r.indexOf(i) !== -1)
          continue;
        r.push(i);
        let a = i.firstElementChild;
        for (; a != null; )
          e.indexOf(a) === -1 && t.push(a), (a = a.nextElementSibling);
      }
      return t;
    }
    var vX = Element.prototype.closest
      ? (e, t) => (document.documentElement.contains(e) ? e.closest(t) : null)
      : (e, t) => {
          if (!document.documentElement.contains(e)) return null;
          let r = e;
          do {
            if (r[rs] && r[rs](t)) return r;
            r = r.parentNode;
          } while (r != null);
          return null;
        };
    we.getClosestElement = vX;
    function EX(e) {
      return e != null && typeof e == "object"
        ? e instanceof Element
          ? tX
          : rX
        : null;
    }
  });
  var ns = u((Uk, p_) => {
    var hX = ot(),
      d_ = Object.create,
      gX = (function () {
        function e() {}
        return function (t) {
          if (!hX(t)) return {};
          if (d_) return d_(t);
          e.prototype = t;
          var r = new e();
          return (e.prototype = void 0), r;
        };
      })();
    p_.exports = gX;
  });
  var _i = u((Bk, v_) => {
    function _X() {}
    v_.exports = _X;
  });
  var Ii = u((Wk, E_) => {
    var yX = ns(),
      IX = _i();
    function yi(e, t) {
      (this.__wrapped__ = e),
        (this.__actions__ = []),
        (this.__chain__ = !!t),
        (this.__index__ = 0),
        (this.__values__ = void 0);
    }
    yi.prototype = yX(IX.prototype);
    yi.prototype.constructor = yi;
    E_.exports = yi;
  });
  var y_ = u((Hk, __) => {
    var h_ = $t(),
      TX = Vr(),
      mX = Ae(),
      g_ = h_ ? h_.isConcatSpreadable : void 0;
    function OX(e) {
      return mX(e) || TX(e) || !!(g_ && e && e[g_]);
    }
    __.exports = OX;
  });
  var m_ = u((jk, T_) => {
    var bX = Vn(),
      AX = y_();
    function I_(e, t, r, n, o) {
      var i = -1,
        a = e.length;
      for (r || (r = AX), o || (o = []); ++i < a; ) {
        var s = e[i];
        t > 0 && r(s)
          ? t > 1
            ? I_(s, t - 1, r, n, o)
            : bX(o, s)
          : n || (o[o.length] = s);
      }
      return o;
    }
    T_.exports = I_;
  });
  var b_ = u((kk, O_) => {
    var SX = m_();
    function RX(e) {
      var t = e == null ? 0 : e.length;
      return t ? SX(e, 1) : [];
    }
    O_.exports = RX;
  });
  var S_ = u((Kk, A_) => {
    function wX(e, t, r) {
      switch (r.length) {
        case 0:
          return e.call(t);
        case 1:
          return e.call(t, r[0]);
        case 2:
          return e.call(t, r[0], r[1]);
        case 3:
          return e.call(t, r[0], r[1], r[2]);
      }
      return e.apply(t, r);
    }
    A_.exports = wX;
  });
  var C_ = u((zk, w_) => {
    var CX = S_(),
      R_ = Math.max;
    function NX(e, t, r) {
      return (
        (t = R_(t === void 0 ? e.length - 1 : t, 0)),
        function () {
          for (
            var n = arguments, o = -1, i = R_(n.length - t, 0), a = Array(i);
            ++o < i;

          )
            a[o] = n[t + o];
          o = -1;
          for (var s = Array(t + 1); ++o < t; ) s[o] = n[o];
          return (s[t] = r(a)), CX(e, this, s);
        }
      );
    }
    w_.exports = NX;
  });
  var P_ = u((Yk, N_) => {
    function PX(e) {
      return function () {
        return e;
      };
    }
    N_.exports = PX;
  });
  var x_ = u(($k, L_) => {
    var qX = P_(),
      q_ = Ja(),
      LX = Zn(),
      xX = q_
        ? function (e, t) {
            return q_(e, "toString", {
              configurable: !0,
              enumerable: !1,
              value: qX(t),
              writable: !0,
            });
          }
        : LX;
    L_.exports = xX;
  });
  var D_ = u((Qk, M_) => {
    var MX = 800,
      DX = 16,
      FX = Date.now;
    function GX(e) {
      var t = 0,
        r = 0;
      return function () {
        var n = FX(),
          o = DX - (n - r);
        if (((r = n), o > 0)) {
          if (++t >= MX) return arguments[0];
        } else t = 0;
        return e.apply(void 0, arguments);
      };
    }
    M_.exports = GX;
  });
  var G_ = u((Zk, F_) => {
    var XX = x_(),
      VX = D_(),
      UX = VX(XX);
    F_.exports = UX;
  });
  var V_ = u((Jk, X_) => {
    var BX = b_(),
      WX = C_(),
      HX = G_();
    function jX(e) {
      return HX(WX(e, void 0, BX), e + "");
    }
    X_.exports = jX;
  });
  var W_ = u((eK, B_) => {
    var U_ = va(),
      kX = U_ && new U_();
    B_.exports = kX;
  });
  var j_ = u((tK, H_) => {
    function KX() {}
    H_.exports = KX;
  });
  var is = u((rK, K_) => {
    var k_ = W_(),
      zX = j_(),
      YX = k_
        ? function (e) {
            return k_.get(e);
          }
        : zX;
    K_.exports = YX;
  });
  var Y_ = u((nK, z_) => {
    var $X = {};
    z_.exports = $X;
  });
  var os = u((iK, Q_) => {
    var $_ = Y_(),
      QX = Object.prototype,
      ZX = QX.hasOwnProperty;
    function JX(e) {
      for (
        var t = e.name + "", r = $_[t], n = ZX.call($_, t) ? r.length : 0;
        n--;

      ) {
        var o = r[n],
          i = o.func;
        if (i == null || i == e) return o.name;
      }
      return t;
    }
    Q_.exports = JX;
  });
  var mi = u((oK, Z_) => {
    var eV = ns(),
      tV = _i(),
      rV = 4294967295;
    function Ti(e) {
      (this.__wrapped__ = e),
        (this.__actions__ = []),
        (this.__dir__ = 1),
        (this.__filtered__ = !1),
        (this.__iteratees__ = []),
        (this.__takeCount__ = rV),
        (this.__views__ = []);
    }
    Ti.prototype = eV(tV.prototype);
    Ti.prototype.constructor = Ti;
    Z_.exports = Ti;
  });
  var ey = u((aK, J_) => {
    function nV(e, t) {
      var r = -1,
        n = e.length;
      for (t || (t = Array(n)); ++r < n; ) t[r] = e[r];
      return t;
    }
    J_.exports = nV;
  });
  var ry = u((sK, ty) => {
    var iV = mi(),
      oV = Ii(),
      aV = ey();
    function sV(e) {
      if (e instanceof iV) return e.clone();
      var t = new oV(e.__wrapped__, e.__chain__);
      return (
        (t.__actions__ = aV(e.__actions__)),
        (t.__index__ = e.__index__),
        (t.__values__ = e.__values__),
        t
      );
    }
    ty.exports = sV;
  });
  var oy = u((uK, iy) => {
    var uV = mi(),
      ny = Ii(),
      cV = _i(),
      lV = Ae(),
      fV = dt(),
      dV = ry(),
      pV = Object.prototype,
      vV = pV.hasOwnProperty;
    function Oi(e) {
      if (fV(e) && !lV(e) && !(e instanceof uV)) {
        if (e instanceof ny) return e;
        if (vV.call(e, "__wrapped__")) return dV(e);
      }
      return new ny(e);
    }
    Oi.prototype = cV.prototype;
    Oi.prototype.constructor = Oi;
    iy.exports = Oi;
  });
  var sy = u((cK, ay) => {
    var EV = mi(),
      hV = is(),
      gV = os(),
      _V = oy();
    function yV(e) {
      var t = gV(e),
        r = _V[t];
      if (typeof r != "function" || !(t in EV.prototype)) return !1;
      if (e === r) return !0;
      var n = hV(r);
      return !!n && e === n[0];
    }
    ay.exports = yV;
  });
  var fy = u((lK, ly) => {
    var uy = Ii(),
      IV = V_(),
      TV = is(),
      as = os(),
      mV = Ae(),
      cy = sy(),
      OV = "Expected a function",
      bV = 8,
      AV = 32,
      SV = 128,
      RV = 256;
    function wV(e) {
      return IV(function (t) {
        var r = t.length,
          n = r,
          o = uy.prototype.thru;
        for (e && t.reverse(); n--; ) {
          var i = t[n];
          if (typeof i != "function") throw new TypeError(OV);
          if (o && !a && as(i) == "wrapper") var a = new uy([], !0);
        }
        for (n = a ? n : r; ++n < r; ) {
          i = t[n];
          var s = as(i),
            c = s == "wrapper" ? TV(i) : void 0;
          c &&
          cy(c[0]) &&
          c[1] == (SV | bV | AV | RV) &&
          !c[4].length &&
          c[9] == 1
            ? (a = a[as(c[0])].apply(a, c[3]))
            : (a = i.length == 1 && cy(i) ? a[s]() : a.thru(i));
        }
        return function () {
          var f = arguments,
            p = f[0];
          if (a && f.length == 1 && mV(p)) return a.plant(p).value();
          for (var d = 0, h = r ? t[d].apply(this, f) : p; ++d < r; )
            h = t[d].call(this, h);
          return h;
        };
      });
    }
    ly.exports = wV;
  });
  var py = u((fK, dy) => {
    var CV = fy(),
      NV = CV();
    dy.exports = NV;
  });
  var Ey = u((dK, vy) => {
    function PV(e, t, r) {
      return (
        e === e &&
          (r !== void 0 && (e = e <= r ? e : r),
          t !== void 0 && (e = e >= t ? e : t)),
        e
      );
    }
    vy.exports = PV;
  });
  var gy = u((pK, hy) => {
    var qV = Ey(),
      ss = Jn();
    function LV(e, t, r) {
      return (
        r === void 0 && ((r = t), (t = void 0)),
        r !== void 0 && ((r = ss(r)), (r = r === r ? r : 0)),
        t !== void 0 && ((t = ss(t)), (t = t === t ? t : 0)),
        qV(ss(e), t, r)
      );
    }
    hy.exports = LV;
  });
  var My = u((wi) => {
    "use strict";
    var Ri = Ke().default;
    Object.defineProperty(wi, "__esModule", { value: !0 });
    wi.default = void 0;
    var Be = Ri(er()),
      xV = Ri(py()),
      MV = Ri(Qn()),
      DV = Ri(gy()),
      Bt = Fe(),
      us = ds(),
      bi = gi(),
      FV = Ut(),
      {
        MOUSE_CLICK: GV,
        MOUSE_SECOND_CLICK: XV,
        MOUSE_DOWN: VV,
        MOUSE_UP: UV,
        MOUSE_OVER: BV,
        MOUSE_OUT: WV,
        DROPDOWN_CLOSE: HV,
        DROPDOWN_OPEN: jV,
        SLIDER_ACTIVE: kV,
        SLIDER_INACTIVE: KV,
        TAB_ACTIVE: zV,
        TAB_INACTIVE: YV,
        NAVBAR_CLOSE: $V,
        NAVBAR_OPEN: QV,
        MOUSE_MOVE: ZV,
        PAGE_SCROLL_DOWN: Sy,
        SCROLL_INTO_VIEW: Ry,
        SCROLL_OUT_OF_VIEW: JV,
        PAGE_SCROLL_UP: eU,
        SCROLLING_IN_VIEW: tU,
        PAGE_FINISH: wy,
        ECOMMERCE_CART_CLOSE: rU,
        ECOMMERCE_CART_OPEN: nU,
        PAGE_START: Cy,
        PAGE_SCROLL: iU,
      } = Bt.EventTypeConsts,
      cs = "COMPONENT_ACTIVE",
      Ny = "COMPONENT_INACTIVE",
      { COLON_DELIMITER: _y } = Bt.IX2EngineConstants,
      { getNamespacedParameterId: yy } = FV.IX2VanillaUtils,
      Py = (e) => (t) => (typeof t == "object" && e(t) ? !0 : t),
      nn = Py(({ element: e, nativeEvent: t }) => e === t.target),
      oU = Py(({ element: e, nativeEvent: t }) => e.contains(t.target)),
      ct = (0, xV.default)([nn, oU]),
      qy = (e, t) => {
        if (t) {
          let { ixData: r } = e.getState(),
            { events: n } = r,
            o = n[t];
          if (o && !sU[o.eventTypeId]) return o;
        }
        return null;
      },
      aU = ({ store: e, event: t }) => {
        let { action: r } = t,
          { autoStopEventId: n } = r.config;
        return !!qy(e, n);
      },
      Xe = ({ store: e, event: t, element: r, eventStateKey: n }, o) => {
        let { action: i, id: a } = t,
          { actionListId: s, autoStopEventId: c } = i.config,
          f = qy(e, c);
        return (
          f &&
            (0, us.stopActionGroup)({
              store: e,
              eventId: c,
              eventTarget: r,
              eventStateKey: c + _y + n.split(_y)[1],
              actionListId: (0, MV.default)(f, "action.config.actionListId"),
            }),
          (0, us.stopActionGroup)({
            store: e,
            eventId: a,
            eventTarget: r,
            eventStateKey: n,
            actionListId: s,
          }),
          (0, us.startActionGroup)({
            store: e,
            eventId: a,
            eventTarget: r,
            eventStateKey: n,
            actionListId: s,
          }),
          o
        );
      },
      Qe = (e, t) => (r, n) => (e(r, n) === !0 ? t(r, n) : n),
      on = { handler: Qe(ct, Xe) },
      Ly = (0, Be.default)({}, on, { types: [cs, Ny].join(" ") }),
      ls = [
        { target: window, types: "resize orientationchange", throttle: !0 },
        {
          target: document,
          types: "scroll wheel readystatechange IX2_PAGE_UPDATE",
          throttle: !0,
        },
      ],
      Iy = "mouseover mouseout",
      fs = { types: ls },
      sU = { PAGE_START: Cy, PAGE_FINISH: wy },
      rn = (() => {
        let e = window.pageXOffset !== void 0,
          r =
            document.compatMode === "CSS1Compat"
              ? document.documentElement
              : document.body;
        return () => ({
          scrollLeft: e ? window.pageXOffset : r.scrollLeft,
          scrollTop: e ? window.pageYOffset : r.scrollTop,
          stiffScrollTop: (0, DV.default)(
            e ? window.pageYOffset : r.scrollTop,
            0,
            r.scrollHeight - window.innerHeight,
          ),
          scrollWidth: r.scrollWidth,
          scrollHeight: r.scrollHeight,
          clientWidth: r.clientWidth,
          clientHeight: r.clientHeight,
          innerWidth: window.innerWidth,
          innerHeight: window.innerHeight,
        });
      })(),
      uU = (e, t) =>
        !(
          e.left > t.right ||
          e.right < t.left ||
          e.top > t.bottom ||
          e.bottom < t.top
        ),
      cU = ({ element: e, nativeEvent: t }) => {
        let { type: r, target: n, relatedTarget: o } = t,
          i = e.contains(n);
        if (r === "mouseover" && i) return !0;
        let a = e.contains(o);
        return !!(r === "mouseout" && i && a);
      },
      lU = (e) => {
        let {
            element: t,
            event: { config: r },
          } = e,
          { clientWidth: n, clientHeight: o } = rn(),
          i = r.scrollOffsetValue,
          c = r.scrollOffsetUnit === "PX" ? i : (o * (i || 0)) / 10000;
        return uU(t.getBoundingClientRect(), {
          left: 0,
          top: c,
          right: n,
          bottom: o - c,
        });
      },
      xy = (e) => (t, r) => {
        let { type: n } = t.nativeEvent,
          o = [cs, Ny].indexOf(n) !== -1 ? n === cs : r.isActive,
          i = (0, Be.default)({}, r, { isActive: o });
        return ((!r || i.isActive !== r.isActive) && e(t, i)) || i;
      },
      Ty = (e) => (t, r) => {
        let n = { elementHovered: cU(t) };
        return (
          ((r ? n.elementHovered !== r.elementHovered : n.elementHovered) &&
            e(t, n)) ||
          n
        );
      },
      fU = (e) => (t, r) => {
        let n = (0, Be.default)({}, r, { elementVisible: lU(t) });
        return (
          ((r ? n.elementVisible !== r.elementVisible : n.elementVisible) &&
            e(t, n)) ||
          n
        );
      },
      my =
        (e) =>
        (t, r = {}) => {
          let { stiffScrollTop: n, scrollHeight: o, innerHeight: i } = rn(),
            {
              event: { config: a, eventTypeId: s },
            } = t,
            { scrollOffsetValue: c, scrollOffsetUnit: f } = a,
            p = f === "PX",
            d = o - i,
            h = Number((n / d).toFixed(2));
          if (r && r.percentTop === h) return r;
          let g = (p ? c : (i * (c || 0)) / 100) / d,
            O,
            I,
            C = 0;
          r &&
            ((O = h > r.percentTop),
            (I = r.scrollingDown !== O),
            (C = I ? h : r.anchorTop));
          let A = s === Sy ? h >= C + g : h <= C - g,
            R = (0, Be.default)({}, r, {
              percentTop: h,
              inBounds: A,
              anchorTop: C,
              scrollingDown: O,
            });
          return (r && A && (I || R.inBounds !== r.inBounds) && e(t, R)) || R;
        },
      dU = (e, t) =>
        e.left > t.left &&
        e.left < t.right &&
        e.top > t.top &&
        e.top < t.bottom,
      pU = (e) => (t, r) => {
        let n = { finished: document.readyState === "complete" };
        return n.finished && !(r && r.finshed) && e(t), n;
      },
      vU = (e) => (t, r) => {
        let n = { started: !0 };
        return r || e(t), n;
      },
      Oy =
        (e) =>
        (t, r = { clickCount: 0 }) => {
          let n = { clickCount: (r.clickCount % 2) + 1 };
          return (n.clickCount !== r.clickCount && e(t, n)) || n;
        },
      Ai = (e = !0) =>
        (0, Be.default)({}, Ly, {
          handler: Qe(
            e ? ct : nn,
            xy((t, r) => (r.isActive ? on.handler(t, r) : r)),
          ),
        }),
      Si = (e = !0) =>
        (0, Be.default)({}, Ly, {
          handler: Qe(
            e ? ct : nn,
            xy((t, r) => (r.isActive ? r : on.handler(t, r))),
          ),
        }),
      by = (0, Be.default)({}, fs, {
        handler: fU((e, t) => {
          let { elementVisible: r } = t,
            { event: n, store: o } = e,
            { ixData: i } = o.getState(),
            { events: a } = i;
          return !a[n.action.config.autoStopEventId] && t.triggered
            ? t
            : (n.eventTypeId === Ry) === r
            ? (Xe(e), (0, Be.default)({}, t, { triggered: !0 }))
            : t;
        }),
      }),
      Ay = 0.05,
      EU = {
        [kV]: Ai(),
        [KV]: Si(),
        [jV]: Ai(),
        [HV]: Si(),
        [QV]: Ai(!1),
        [$V]: Si(!1),
        [zV]: Ai(),
        [YV]: Si(),
        [nU]: { types: "ecommerce-cart-open", handler: Qe(ct, Xe) },
        [rU]: { types: "ecommerce-cart-close", handler: Qe(ct, Xe) },
        [GV]: {
          types: "click",
          handler: Qe(
            ct,
            Oy((e, { clickCount: t }) => {
              aU(e) ? t === 1 && Xe(e) : Xe(e);
            }),
          ),
        },
        [XV]: {
          types: "click",
          handler: Qe(
            ct,
            Oy((e, { clickCount: t }) => {
              t === 2 && Xe(e);
            }),
          ),
        },
        [VV]: (0, Be.default)({}, on, { types: "mousedown" }),
        [UV]: (0, Be.default)({}, on, { types: "mouseup" }),
        [BV]: {
          types: Iy,
          handler: Qe(
            ct,
            Ty((e, t) => {
              t.elementHovered && Xe(e);
            }),
          ),
        },
        [WV]: {
          types: Iy,
          handler: Qe(
            ct,
            Ty((e, t) => {
              t.elementHovered || Xe(e);
            }),
          ),
        },
        [ZV]: {
          types: "mousemove mouseout scroll",
          handler: (
            {
              store: e,
              element: t,
              eventConfig: r,
              nativeEvent: n,
              eventStateKey: o,
            },
            i = { clientX: 0, clientY: 0, pageX: 0, pageY: 0 },
          ) => {
            let {
                basedOn: a,
                selectedAxis: s,
                continuousParameterGroupId: c,
                reverse: f,
                restingState: p = 0,
              } = r,
              {
                clientX: d = i.clientX,
                clientY: h = i.clientY,
                pageX: g = i.pageX,
                pageY: O = i.pageY,
              } = n,
              I = s === "X_AXIS",
              C = n.type === "mouseout",
              A = p / 100,
              R = c,
              T = !1;
            switch (a) {
              case Bt.EventBasedOn.VIEWPORT: {
                A = I
                  ? Math.min(d, window.innerWidth) / window.innerWidth
                  : Math.min(h, window.innerHeight) / window.innerHeight;
                break;
              }
              case Bt.EventBasedOn.PAGE: {
                let {
                  scrollLeft: q,
                  scrollTop: x,
                  scrollWidth: N,
                  scrollHeight: F,
                } = rn();
                A = I ? Math.min(q + g, N) / N : Math.min(x + O, F) / F;
                break;
              }
              case Bt.EventBasedOn.ELEMENT:
              default: {
                R = yy(o, c);
                let q = n.type.indexOf("mouse") === 0;
                if (q && ct({ element: t, nativeEvent: n }) !== !0) break;
                let x = t.getBoundingClientRect(),
                  { left: N, top: F, width: U, height: W } = x;
                if (!q && !dU({ left: d, top: h }, x)) break;
                (T = !0), (A = I ? (d - N) / U : (h - F) / W);
                break;
              }
            }
            return (
              C && (A > 1 - Ay || A < Ay) && (A = Math.round(A)),
              (a !== Bt.EventBasedOn.ELEMENT || T || T !== i.elementHovered) &&
                ((A = f ? 1 - A : A),
                e.dispatch((0, bi.parameterChanged)(R, A))),
              { elementHovered: T, clientX: d, clientY: h, pageX: g, pageY: O }
            );
          },
        },
        [iU]: {
          types: ls,
          handler: ({ store: e, eventConfig: t }) => {
            let { continuousParameterGroupId: r, reverse: n } = t,
              { scrollTop: o, scrollHeight: i, clientHeight: a } = rn(),
              s = o / (i - a);
            (s = n ? 1 - s : s), e.dispatch((0, bi.parameterChanged)(r, s));
          },
        },
        [tU]: {
          types: ls,
          handler: (
            { element: e, store: t, eventConfig: r, eventStateKey: n },
            o = { scrollPercent: 0 },
          ) => {
            let {
                scrollLeft: i,
                scrollTop: a,
                scrollWidth: s,
                scrollHeight: c,
                clientHeight: f,
              } = rn(),
              {
                basedOn: p,
                selectedAxis: d,
                continuousParameterGroupId: h,
                startsEntering: g,
                startsExiting: O,
                addEndOffset: I,
                addStartOffset: C,
                addOffsetValue: A = 0,
                endOffsetValue: R = 0,
              } = r,
              T = d === "X_AXIS";
            if (p === Bt.EventBasedOn.VIEWPORT) {
              let q = T ? i / s : a / c;
              return (
                q !== o.scrollPercent &&
                  t.dispatch((0, bi.parameterChanged)(h, q)),
                { scrollPercent: q }
              );
            } else {
              let q = yy(n, h),
                x = e.getBoundingClientRect(),
                N = (C ? A : 0) / 100,
                F = (I ? R : 0) / 100;
              (N = g ? N : 1 - N), (F = O ? F : 1 - F);
              let U = x.top + Math.min(x.height * N, f),
                ee = x.top + x.height * F - U,
                K = Math.min(f + ee, c),
                y = Math.min(Math.max(0, f - U), K) / K;
              return (
                y !== o.scrollPercent &&
                  t.dispatch((0, bi.parameterChanged)(q, y)),
                { scrollPercent: y }
              );
            }
          },
        },
        [Ry]: by,
        [JV]: by,
        [Sy]: (0, Be.default)({}, fs, {
          handler: my((e, t) => {
            t.scrollingDown && Xe(e);
          }),
        }),
        [eU]: (0, Be.default)({}, fs, {
          handler: my((e, t) => {
            t.scrollingDown || Xe(e);
          }),
        }),
        [wy]: {
          types: "readystatechange IX2_PAGE_UPDATE",
          handler: Qe(nn, pU(Xe)),
        },
        [Cy]: {
          types: "readystatechange IX2_PAGE_UPDATE",
          handler: Qe(nn, vU(Xe)),
        },
      };
    wi.default = EU;
  });
  var ds = u((St) => {
    "use strict";
    var Je = Ke().default,
      hU = qt().default;
    Object.defineProperty(St, "__esModule", { value: !0 });
    St.observeRequests = kU;
    St.startActionGroup = _s;
    St.startEngine = Li;
    St.stopActionGroup = gs;
    St.stopAllActionGroups = Hy;
    St.stopEngine = xi;
    var gU = Je(er()),
      _U = Je(Zh()),
      yU = Je(Na()),
      At = Je(Qn()),
      IU = Je(gg()),
      TU = Je(Wg()),
      mU = Je(jg()),
      OU = Je(Kg()),
      an = Je(Jg()),
      bU = Je(a_()),
      Ze = Fe(),
      Gy = Ut(),
      Ee = gi(),
      ye = hU(f_()),
      AU = Je(My()),
      SU = ["store", "computedStyle"],
      RU = Object.keys(Ze.QuickEffectIds),
      ps = (e) => RU.includes(e),
      {
        COLON_DELIMITER: vs,
        BOUNDARY_SELECTOR: Ci,
        HTML_ELEMENT: Xy,
        RENDER_GENERAL: wU,
        W_MOD_IX: Dy,
      } = Ze.IX2EngineConstants,
      {
        getAffectedElements: Ni,
        getElementId: CU,
        getDestinationValues: Es,
        observeStore: Wt,
        getInstanceId: NU,
        renderHTMLElement: PU,
        clearAllStyles: Vy,
        getMaxDurationItemIndex: qU,
        getComputedStyle: LU,
        getInstanceOrigin: xU,
        reduceListToGroup: MU,
        shouldNamespaceEventParameter: DU,
        getNamespacedParameterId: FU,
        shouldAllowMediaQuery: Pi,
        cleanupHTMLElement: GU,
        clearObjectCache: XU,
        stringifyTarget: VU,
        mediaQueriesEqual: UU,
        shallowEqual: BU,
      } = Gy.IX2VanillaUtils,
      {
        isPluginType: qi,
        createPluginInstance: hs,
        getPluginDuration: WU,
      } = Gy.IX2VanillaPlugins,
      Fy = navigator.userAgent,
      HU = Fy.match(/iPad/i) || Fy.match(/iPhone/),
      jU = 12;
    function kU(e) {
      Wt({ store: e, select: ({ ixRequest: t }) => t.preview, onChange: YU }),
        Wt({
          store: e,
          select: ({ ixRequest: t }) => t.playback,
          onChange: $U,
        }),
        Wt({ store: e, select: ({ ixRequest: t }) => t.stop, onChange: QU }),
        Wt({ store: e, select: ({ ixRequest: t }) => t.clear, onChange: ZU });
    }
    function KU(e) {
      Wt({
        store: e,
        select: ({ ixSession: t }) => t.mediaQueryKey,
        onChange: () => {
          xi(e),
            Vy({ store: e, elementApi: ye }),
            Li({ store: e, allowEvents: !0 }),
            Uy();
        },
      });
    }
    function zU(e, t) {
      let r = Wt({
        store: e,
        select: ({ ixSession: n }) => n.tick,
        onChange: (n) => {
          t(n), r();
        },
      });
    }
    function YU({ rawData: e, defer: t }, r) {
      let n = () => {
        Li({ store: r, rawData: e, allowEvents: !0 }), Uy();
      };
      t ? setTimeout(n, 0) : n();
    }
    function Uy() {
      document.dispatchEvent(new CustomEvent("IX2_PAGE_UPDATE"));
    }
    function $U(e, t) {
      let {
          actionTypeId: r,
          actionListId: n,
          actionItemId: o,
          eventId: i,
          allowEvents: a,
          immediate: s,
          testManual: c,
          verbose: f = !0,
        } = e,
        { rawData: p } = e;
      if (n && o && p && s) {
        let d = p.actionLists[n];
        d && (p = MU({ actionList: d, actionItemId: o, rawData: p }));
      }
      if (
        (Li({ store: t, rawData: p, allowEvents: a, testManual: c }),
        (n && r === Ze.ActionTypeConsts.GENERAL_START_ACTION) || ps(r))
      ) {
        gs({ store: t, actionListId: n }),
          Wy({ store: t, actionListId: n, eventId: i });
        let d = _s({
          store: t,
          eventId: i,
          actionListId: n,
          immediate: s,
          verbose: f,
        });
        f &&
          d &&
          t.dispatch(
            (0, Ee.actionListPlaybackChanged)({
              actionListId: n,
              isPlaying: !s,
            }),
          );
      }
    }
    function QU({ actionListId: e }, t) {
      e ? gs({ store: t, actionListId: e }) : Hy({ store: t }), xi(t);
    }
    function ZU(e, t) {
      xi(t), Vy({ store: t, elementApi: ye });
    }
    function Li({ store: e, rawData: t, allowEvents: r, testManual: n }) {
      let { ixSession: o } = e.getState();
      t && e.dispatch((0, Ee.rawDataImported)(t)),
        o.active ||
          (e.dispatch(
            (0, Ee.sessionInitialized)({
              hasBoundaryNodes: !!document.querySelector(Ci),
              reducedMotion:
                document.body.hasAttribute("data-wf-ix-vacation") &&
                window.matchMedia("(prefers-reduced-motion)").matches,
            }),
          ),
          r &&
            (iB(e),
            JU(),
            e.getState().ixSession.hasDefinedMediaQueries && KU(e)),
          e.dispatch((0, Ee.sessionStarted)()),
          eB(e, n));
    }
    function JU() {
      let { documentElement: e } = document;
      e.className.indexOf(Dy) === -1 && (e.className += ` ${Dy}`);
    }
    function eB(e, t) {
      let r = (n) => {
        let { ixSession: o, ixParameters: i } = e.getState();
        o.active &&
          (e.dispatch((0, Ee.animationFrameChanged)(n, i)),
          t ? zU(e, r) : requestAnimationFrame(r));
      };
      r(window.performance.now());
    }
    function xi(e) {
      let { ixSession: t } = e.getState();
      if (t.active) {
        let { eventListeners: r } = t;
        r.forEach(tB), XU(), e.dispatch((0, Ee.sessionStopped)());
      }
    }
    function tB({ target: e, listenerParams: t }) {
      e.removeEventListener.apply(e, t);
    }
    function rB({
      store: e,
      eventStateKey: t,
      eventTarget: r,
      eventId: n,
      eventConfig: o,
      actionListId: i,
      parameterGroup: a,
      smoothing: s,
      restingValue: c,
    }) {
      let { ixData: f, ixSession: p } = e.getState(),
        { events: d } = f,
        h = d[n],
        { eventTypeId: g } = h,
        O = {},
        I = {},
        C = [],
        { continuousActionGroups: A } = a,
        { id: R } = a;
      DU(g, o) && (R = FU(t, R));
      let T = p.hasBoundaryNodes && r ? ye.getClosestElement(r, Ci) : null;
      A.forEach((q) => {
        let { keyframe: x, actionItems: N } = q;
        N.forEach((F) => {
          let { actionTypeId: U } = F,
            { target: W } = F.config;
          if (!W) return;
          let ee = W.boundaryMode ? T : null,
            K = VU(W) + vs + U;
          if (((I[K] = nB(I[K], x, F)), !O[K])) {
            O[K] = !0;
            let { config: L } = F;
            Ni({
              config: L,
              event: h,
              eventTarget: r,
              elementRoot: ee,
              elementApi: ye,
            }).forEach((y) => {
              C.push({ element: y, key: K });
            });
          }
        });
      }),
        C.forEach(({ element: q, key: x }) => {
          let N = I[x],
            F = (0, At.default)(N, "[0].actionItems[0]", {}),
            { actionTypeId: U } = F,
            W = qi(U) ? hs(U)(q, F) : null,
            ee = Es({ element: q, actionItem: F, elementApi: ye }, W);
          ys({
            store: e,
            element: q,
            eventId: n,
            actionListId: i,
            actionItem: F,
            destination: ee,
            continuous: !0,
            parameterId: R,
            actionGroups: N,
            smoothing: s,
            restingValue: c,
            pluginInstance: W,
          });
        });
    }
    function nB(e = [], t, r) {
      let n = [...e],
        o;
      return (
        n.some((i, a) => (i.keyframe === t ? ((o = a), !0) : !1)),
        o == null && ((o = n.length), n.push({ keyframe: t, actionItems: [] })),
        n[o].actionItems.push(r),
        n
      );
    }
    function iB(e) {
      let { ixData: t } = e.getState(),
        { eventTypeMap: r } = t;
      By(e),
        (0, an.default)(r, (o, i) => {
          let a = AU.default[i];
          if (!a) {
            console.warn(`IX2 event type not configured: ${i}`);
            return;
          }
          lB({ logic: a, store: e, events: o });
        });
      let { ixSession: n } = e.getState();
      n.eventListeners.length && aB(e);
    }
    var oB = ["resize", "orientationchange"];
    function aB(e) {
      let t = () => {
        By(e);
      };
      oB.forEach((r) => {
        window.addEventListener(r, t),
          e.dispatch((0, Ee.eventListenerAdded)(window, [r, t]));
      }),
        t();
    }
    function By(e) {
      let { ixSession: t, ixData: r } = e.getState(),
        n = window.innerWidth;
      if (n !== t.viewportWidth) {
        let { mediaQueries: o } = r;
        e.dispatch((0, Ee.viewportWidthChanged)({ width: n, mediaQueries: o }));
      }
    }
    var sB = (e, t) => (0, TU.default)((0, OU.default)(e, t), mU.default),
      uB = (e, t) => {
        (0, an.default)(e, (r, n) => {
          r.forEach((o, i) => {
            let a = n + vs + i;
            t(o, n, a);
          });
        });
      },
      cB = (e) => {
        let t = { target: e.target, targets: e.targets };
        return Ni({ config: t, elementApi: ye });
      };
    function lB({ logic: e, store: t, events: r }) {
      fB(r);
      let { types: n, handler: o } = e,
        { ixData: i } = t.getState(),
        { actionLists: a } = i,
        s = sB(r, cB);
      if (!(0, IU.default)(s)) return;
      (0, an.default)(s, (d, h) => {
        let g = r[h],
          { action: O, id: I, mediaQueries: C = i.mediaQueryKeys } = g,
          { actionListId: A } = O.config;
        UU(C, i.mediaQueryKeys) || t.dispatch((0, Ee.mediaQueriesDefined)()),
          O.actionTypeId === Ze.ActionTypeConsts.GENERAL_CONTINUOUS_ACTION &&
            (Array.isArray(g.config) ? g.config : [g.config]).forEach((T) => {
              let { continuousParameterGroupId: q } = T,
                x = (0, At.default)(a, `${A}.continuousParameterGroups`, []),
                N = (0, yU.default)(x, ({ id: W }) => W === q),
                F = (T.smoothing || 0) / 100,
                U = (T.restingState || 0) / 100;
              N &&
                d.forEach((W, ee) => {
                  let K = I + vs + ee;
                  rB({
                    store: t,
                    eventStateKey: K,
                    eventTarget: W,
                    eventId: I,
                    eventConfig: T,
                    actionListId: A,
                    parameterGroup: N,
                    smoothing: F,
                    restingValue: U,
                  });
                });
            }),
          (O.actionTypeId === Ze.ActionTypeConsts.GENERAL_START_ACTION ||
            ps(O.actionTypeId)) &&
            Wy({ store: t, actionListId: A, eventId: I });
      });
      let c = (d) => {
          let { ixSession: h } = t.getState();
          uB(s, (g, O, I) => {
            let C = r[O],
              A = h.eventState[I],
              { action: R, mediaQueries: T = i.mediaQueryKeys } = C;
            if (!Pi(T, h.mediaQueryKey)) return;
            let q = (x = {}) => {
              let N = o(
                {
                  store: t,
                  element: g,
                  event: C,
                  eventConfig: x,
                  nativeEvent: d,
                  eventStateKey: I,
                },
                A,
              );
              BU(N, A) || t.dispatch((0, Ee.eventStateChanged)(I, N));
            };
            R.actionTypeId === Ze.ActionTypeConsts.GENERAL_CONTINUOUS_ACTION
              ? (Array.isArray(C.config) ? C.config : [C.config]).forEach(q)
              : q();
          });
        },
        f = (0, bU.default)(c, jU),
        p = ({ target: d = document, types: h, throttle: g }) => {
          h.split(" ")
            .filter(Boolean)
            .forEach((O) => {
              let I = g ? f : c;
              d.addEventListener(O, I),
                t.dispatch((0, Ee.eventListenerAdded)(d, [O, I]));
            });
        };
      Array.isArray(n) ? n.forEach(p) : typeof n == "string" && p(e);
    }
    function fB(e) {
      if (!HU) return;
      let t = {},
        r = "";
      for (let n in e) {
        let { eventTypeId: o, target: i } = e[n],
          a = ye.getQuerySelector(i);
        t[a] ||
          ((o === Ze.EventTypeConsts.MOUSE_CLICK ||
            o === Ze.EventTypeConsts.MOUSE_SECOND_CLICK) &&
            ((t[a] = !0),
            (r += a + "{cursor: pointer;touch-action: manipulation;}")));
      }
      if (r) {
        let n = document.createElement("style");
        (n.textContent = r), document.body.appendChild(n);
      }
    }
    function Wy({ store: e, actionListId: t, eventId: r }) {
      let { ixData: n, ixSession: o } = e.getState(),
        { actionLists: i, events: a } = n,
        s = a[r],
        c = i[t];
      if (c && c.useFirstGroupAsInitialState) {
        let f = (0, At.default)(c, "actionItemGroups[0].actionItems", []),
          p = (0, At.default)(s, "mediaQueries", n.mediaQueryKeys);
        if (!Pi(p, o.mediaQueryKey)) return;
        f.forEach((d) => {
          var h;
          let { config: g, actionTypeId: O } = d,
            I =
              (g == null || (h = g.target) === null || h === void 0
                ? void 0
                : h.useEventTarget) === !0
                ? { target: s.target, targets: s.targets }
                : g,
            C = Ni({ config: I, event: s, elementApi: ye }),
            A = qi(O);
          C.forEach((R) => {
            let T = A ? hs(O)(R, d) : null;
            ys({
              destination: Es({ element: R, actionItem: d, elementApi: ye }, T),
              immediate: !0,
              store: e,
              element: R,
              eventId: r,
              actionItem: d,
              actionListId: t,
              pluginInstance: T,
            });
          });
        });
      }
    }
    function Hy({ store: e }) {
      let { ixInstances: t } = e.getState();
      (0, an.default)(t, (r) => {
        if (!r.continuous) {
          let { actionListId: n, verbose: o } = r;
          Is(r, e),
            o &&
              e.dispatch(
                (0, Ee.actionListPlaybackChanged)({
                  actionListId: n,
                  isPlaying: !1,
                }),
              );
        }
      });
    }
    function gs({
      store: e,
      eventId: t,
      eventTarget: r,
      eventStateKey: n,
      actionListId: o,
    }) {
      let { ixInstances: i, ixSession: a } = e.getState(),
        s = a.hasBoundaryNodes && r ? ye.getClosestElement(r, Ci) : null;
      (0, an.default)(i, (c) => {
        let f = (0, At.default)(c, "actionItem.config.target.boundaryMode"),
          p = n ? c.eventStateKey === n : !0;
        if (c.actionListId === o && c.eventId === t && p) {
          if (s && f && !ye.elementContains(s, c.element)) return;
          Is(c, e),
            c.verbose &&
              e.dispatch(
                (0, Ee.actionListPlaybackChanged)({
                  actionListId: o,
                  isPlaying: !1,
                }),
              );
        }
      });
    }
    function _s({
      store: e,
      eventId: t,
      eventTarget: r,
      eventStateKey: n,
      actionListId: o,
      groupIndex: i = 0,
      immediate: a,
      verbose: s,
    }) {
      var c;
      let { ixData: f, ixSession: p } = e.getState(),
        { events: d } = f,
        h = d[t] || {},
        { mediaQueries: g = f.mediaQueryKeys } = h,
        O = (0, At.default)(f, `actionLists.${o}`, {}),
        { actionItemGroups: I, useFirstGroupAsInitialState: C } = O;
      if (!I || !I.length) return !1;
      i >= I.length && (0, At.default)(h, "config.loop") && (i = 0),
        i === 0 && C && i++;
      let R =
          (i === 0 || (i === 1 && C)) &&
          ps((c = h.action) === null || c === void 0 ? void 0 : c.actionTypeId)
            ? h.config.delay
            : void 0,
        T = (0, At.default)(I, [i, "actionItems"], []);
      if (!T.length || !Pi(g, p.mediaQueryKey)) return !1;
      let q = p.hasBoundaryNodes && r ? ye.getClosestElement(r, Ci) : null,
        x = qU(T),
        N = !1;
      return (
        T.forEach((F, U) => {
          let { config: W, actionTypeId: ee } = F,
            K = qi(ee),
            { target: L } = W;
          if (!L) return;
          let y = L.boundaryMode ? q : null;
          Ni({
            config: W,
            event: h,
            eventTarget: r,
            elementRoot: y,
            elementApi: ye,
          }).forEach((M, D) => {
            let j = K ? hs(ee)(M, F) : null,
              z = K ? WU(ee)(M, F) : null;
            N = !0;
            let ie = x === U && D === 0,
              Ne = LU({ element: M, actionItem: F }),
              Ve = Es({ element: M, actionItem: F, elementApi: ye }, j);
            ys({
              store: e,
              element: M,
              actionItem: F,
              eventId: t,
              eventTarget: r,
              eventStateKey: n,
              actionListId: o,
              groupIndex: i,
              isCarrier: ie,
              computedStyle: Ne,
              destination: Ve,
              immediate: a,
              verbose: s,
              pluginInstance: j,
              pluginDuration: z,
              instanceDelay: R,
            });
          });
        }),
        N
      );
    }
    function ys(e) {
      var t;
      let { store: r, computedStyle: n } = e,
        o = (0, _U.default)(e, SU),
        {
          element: i,
          actionItem: a,
          immediate: s,
          pluginInstance: c,
          continuous: f,
          restingValue: p,
          eventId: d,
        } = o,
        h = !f,
        g = NU(),
        { ixElements: O, ixSession: I, ixData: C } = r.getState(),
        A = CU(O, i),
        { refState: R } = O[A] || {},
        T = ye.getRefType(i),
        q = I.reducedMotion && Ze.ReducedMotionTypes[a.actionTypeId],
        x;
      if (q && f)
        switch (
          (t = C.events[d]) === null || t === void 0 ? void 0 : t.eventTypeId
        ) {
          case Ze.EventTypeConsts.MOUSE_MOVE:
          case Ze.EventTypeConsts.MOUSE_MOVE_IN_VIEWPORT:
            x = p;
            break;
          default:
            x = 0.5;
            break;
        }
      let N = xU(i, R, n, a, ye, c);
      if (
        (r.dispatch(
          (0, Ee.instanceAdded)(
            (0, gU.default)(
              {
                instanceId: g,
                elementId: A,
                origin: N,
                refType: T,
                skipMotion: q,
                skipToValue: x,
              },
              o,
            ),
          ),
        ),
        jy(document.body, "ix2-animation-started", g),
        s)
      ) {
        dB(r, g);
        return;
      }
      Wt({ store: r, select: ({ ixInstances: F }) => F[g], onChange: ky }),
        h && r.dispatch((0, Ee.instanceStarted)(g, I.tick));
    }
    function Is(e, t) {
      jy(document.body, "ix2-animation-stopping", {
        instanceId: e.id,
        state: t.getState(),
      });
      let { elementId: r, actionItem: n } = e,
        { ixElements: o } = t.getState(),
        { ref: i, refType: a } = o[r] || {};
      a === Xy && GU(i, n, ye), t.dispatch((0, Ee.instanceRemoved)(e.id));
    }
    function jy(e, t, r) {
      let n = document.createEvent("CustomEvent");
      n.initCustomEvent(t, !0, !0, r), e.dispatchEvent(n);
    }
    function dB(e, t) {
      let { ixParameters: r } = e.getState();
      e.dispatch((0, Ee.instanceStarted)(t, 0)),
        e.dispatch((0, Ee.animationFrameChanged)(performance.now(), r));
      let { ixInstances: n } = e.getState();
      ky(n[t], e);
    }
    function ky(e, t) {
      let {
          active: r,
          continuous: n,
          complete: o,
          elementId: i,
          actionItem: a,
          actionTypeId: s,
          renderType: c,
          current: f,
          groupIndex: p,
          eventId: d,
          eventTarget: h,
          eventStateKey: g,
          actionListId: O,
          isCarrier: I,
          styleProp: C,
          verbose: A,
          pluginInstance: R,
        } = e,
        { ixData: T, ixSession: q } = t.getState(),
        { events: x } = T,
        N = x[d] || {},
        { mediaQueries: F = T.mediaQueryKeys } = N;
      if (Pi(F, q.mediaQueryKey) && (n || r || o)) {
        if (f || (c === wU && o)) {
          t.dispatch((0, Ee.elementStateChanged)(i, s, f, a));
          let { ixElements: U } = t.getState(),
            { ref: W, refType: ee, refState: K } = U[i] || {},
            L = K && K[s];
          (ee === Xy || qi(s)) && PU(W, K, L, d, a, C, ye, c, R);
        }
        if (o) {
          if (I) {
            let U = _s({
              store: t,
              eventId: d,
              eventTarget: h,
              eventStateKey: g,
              actionListId: O,
              groupIndex: p + 1,
              verbose: A,
            });
            A &&
              !U &&
              t.dispatch(
                (0, Ee.actionListPlaybackChanged)({
                  actionListId: O,
                  isPlaying: !1,
                }),
              );
          }
          Is(e, t);
        }
      }
    }
  });
  var zy = u((Et) => {
    "use strict";
    var pB = qt().default,
      vB = Ke().default;
    Object.defineProperty(Et, "__esModule", { value: !0 });
    Et.actions = void 0;
    Et.destroy = Ky;
    Et.init = yB;
    Et.setEnv = _B;
    Et.store = void 0;
    ql();
    var EB = Yo(),
      hB = vB(Qh()),
      Ts = ds(),
      gB = pB(gi());
    Et.actions = gB;
    var Mi = (0, EB.createStore)(hB.default);
    Et.store = Mi;
    function _B(e) {
      e() && (0, Ts.observeRequests)(Mi);
    }
    function yB(e) {
      Ky(), (0, Ts.startEngine)({ store: Mi, rawData: e, allowEvents: !0 });
    }
    function Ky() {
      (0, Ts.stopEngine)(Mi);
    }
  });
  var Zy = u((gK, Qy) => {
    var Yy = lt(),
      $y = zy();
    $y.setEnv(Yy.env);
    Yy.define(
      "ix2",
      (Qy.exports = function () {
        return $y;
      }),
    );
  });
  var eI = u((_K, Jy) => {
    var Tr = lt();
    Tr.define(
      "links",
      (Jy.exports = function (e, t) {
        var r = {},
          n = e(window),
          o,
          i = Tr.env(),
          a = window.location,
          s = document.createElement("a"),
          c = "w--current",
          f = /index\.(html|php)$/,
          p = /\/$/,
          d,
          h;
        r.ready = r.design = r.preview = g;
        function g() {
          (o = i && Tr.env("design")),
            (h = Tr.env("slug") || a.pathname || ""),
            Tr.scroll.off(I),
            (d = []);
          for (var A = document.links, R = 0; R < A.length; ++R) O(A[R]);
          d.length && (Tr.scroll.on(I), I());
        }
        function O(A) {
          var R =
            (o && A.getAttribute("href-disabled")) || A.getAttribute("href");
          if (((s.href = R), !(R.indexOf(":") >= 0))) {
            var T = e(A);
            if (
              s.hash.length > 1 &&
              s.host + s.pathname === a.host + a.pathname
            ) {
              if (!/^#[a-zA-Z0-9\-\_]+$/.test(s.hash)) return;
              var q = e(s.hash);
              q.length && d.push({ link: T, sec: q, active: !1 });
              return;
            }
            if (!(R === "#" || R === "")) {
              var x = s.href === a.href || R === h || (f.test(R) && p.test(h));
              C(T, c, x);
            }
          }
        }
        function I() {
          var A = n.scrollTop(),
            R = n.height();
          t.each(d, function (T) {
            var q = T.link,
              x = T.sec,
              N = x.offset().top,
              F = x.outerHeight(),
              U = R * 0.5,
              W = x.is(":visible") && N + F - U >= A && N + U <= A + R;
            T.active !== W && ((T.active = W), C(q, c, W));
          });
        }
        function C(A, R, T) {
          var q = A.hasClass(R);
          (T && q) || (!T && !q) || (T ? A.addClass(R) : A.removeClass(R));
        }
        return r;
      }),
    );
  });
  var rI = u((yK, tI) => {
    var Di = lt();
    Di.define(
      "scroll",
      (tI.exports = function (e) {
        var t = {
            WF_CLICK_EMPTY: "click.wf-empty-link",
            WF_CLICK_SCROLL: "click.wf-scroll",
          },
          r = window.location,
          n = O() ? null : window.history,
          o = e(window),
          i = e(document),
          a = e(document.body),
          s =
            window.requestAnimationFrame ||
            window.mozRequestAnimationFrame ||
            window.webkitRequestAnimationFrame ||
            function (L) {
              window.setTimeout(L, 15);
            },
          c = Di.env("editor") ? ".w-editor-body" : "body",
          f =
            "header, " +
            c +
            " > .header, " +
            c +
            " > .w-nav:not([data-no-scroll])",
          p = 'a[href="#"]',
          d = 'a[href*="#"]:not(.w-tab-link):not(' + p + ")",
          h = '.wf-force-outline-none[tabindex="-1"]:focus{outline:none;}',
          g = document.createElement("style");
        g.appendChild(document.createTextNode(h));
        function O() {
          try {
            return !!window.frameElement;
          } catch {
            return !0;
          }
        }
        var I = /^#[a-zA-Z0-9][\w:.-]*$/;
        function C(L) {
          return I.test(L.hash) && L.host + L.pathname === r.host + r.pathname;
        }
        let A =
          typeof window.matchMedia == "function" &&
          window.matchMedia("(prefers-reduced-motion: reduce)");
        function R() {
          return (
            document.body.getAttribute("data-wf-scroll-motion") === "none" ||
            A.matches
          );
        }
        function T(L, y) {
          var P;
          switch (y) {
            case "add":
              (P = L.attr("tabindex")),
                P
                  ? L.attr("data-wf-tabindex-swap", P)
                  : L.attr("tabindex", "-1");
              break;
            case "remove":
              (P = L.attr("data-wf-tabindex-swap")),
                P
                  ? (L.attr("tabindex", P),
                    L.removeAttr("data-wf-tabindex-swap"))
                  : L.removeAttr("tabindex");
              break;
          }
          L.toggleClass("wf-force-outline-none", y === "add");
        }
        function q(L) {
          var y = L.currentTarget;
          if (
            !(
              Di.env("design") ||
              (window.$.mobile && /(?:^|\s)ui-link(?:$|\s)/.test(y.className))
            )
          ) {
            var P = C(y) ? y.hash : "";
            if (P !== "") {
              var M = e(P);
              M.length &&
                (L && (L.preventDefault(), L.stopPropagation()),
                x(P, L),
                window.setTimeout(
                  function () {
                    N(M, function () {
                      T(M, "add"),
                        M.get(0).focus({ preventScroll: !0 }),
                        T(M, "remove");
                    });
                  },
                  L ? 0 : 300,
                ));
            }
          }
        }
        function x(L) {
          if (
            r.hash !== L &&
            n &&
            n.pushState &&
            !(Di.env.chrome && r.protocol === "file:")
          ) {
            var y = n.state && n.state.hash;
            y !== L && n.pushState({ hash: L }, "", L);
          }
        }
        function N(L, y) {
          var P = o.scrollTop(),
            M = F(L);
          if (P !== M) {
            var D = U(L, P, M),
              j = Date.now(),
              z = function () {
                var ie = Date.now() - j;
                window.scroll(0, W(P, M, ie, D)),
                  ie <= D ? s(z) : typeof y == "function" && y();
              };
            s(z);
          }
        }
        function F(L) {
          var y = e(f),
            P = y.css("position") === "fixed" ? y.outerHeight() : 0,
            M = L.offset().top - P;
          if (L.data("scroll") === "mid") {
            var D = o.height() - P,
              j = L.outerHeight();
            j < D && (M -= Math.round((D - j) / 2));
          }
          return M;
        }
        function U(L, y, P) {
          if (R()) return 0;
          var M = 1;
          return (
            a.add(L).each(function (D, j) {
              var z = parseFloat(j.getAttribute("data-scroll-time"));
              !isNaN(z) && z >= 0 && (M = z);
            }),
            (472.143 * Math.log(Math.abs(y - P) + 125) - 2e3) * M
          );
        }
        function W(L, y, P, M) {
          return P > M ? y : L + (y - L) * ee(P / M);
        }
        function ee(L) {
          return L < 0.5
            ? 4 * L * L * L
            : (L - 1) * (2 * L - 2) * (2 * L - 2) + 1;
        }
        function K() {
          var { WF_CLICK_EMPTY: L, WF_CLICK_SCROLL: y } = t;
          i.on(y, d, q),
            i.on(L, p, function (P) {
              P.preventDefault();
            }),
            document.head.insertBefore(g, document.head.firstChild);
        }
        return { ready: K };
      }),
    );
  });
  var iI = u((IK, nI) => {
    var IB = lt();
    IB.define(
      "touch",
      (nI.exports = function (e) {
        var t = {},
          r = window.getSelection;
        (e.event.special.tap = { bindType: "click", delegateType: "click" }),
          (t.init = function (i) {
            return (
              (i = typeof i == "string" ? e(i).get(0) : i), i ? new n(i) : null
            );
          });
        function n(i) {
          var a = !1,
            s = !1,
            c = Math.min(Math.round(window.innerWidth * 0.04), 40),
            f,
            p;
          i.addEventListener("touchstart", d, !1),
            i.addEventListener("touchmove", h, !1),
            i.addEventListener("touchend", g, !1),
            i.addEventListener("touchcancel", O, !1),
            i.addEventListener("mousedown", d, !1),
            i.addEventListener("mousemove", h, !1),
            i.addEventListener("mouseup", g, !1),
            i.addEventListener("mouseout", O, !1);
          function d(C) {
            var A = C.touches;
            (A && A.length > 1) ||
              ((a = !0),
              A ? ((s = !0), (f = A[0].clientX)) : (f = C.clientX),
              (p = f));
          }
          function h(C) {
            if (a) {
              if (s && C.type === "mousemove") {
                C.preventDefault(), C.stopPropagation();
                return;
              }
              var A = C.touches,
                R = A ? A[0].clientX : C.clientX,
                T = R - p;
              (p = R),
                Math.abs(T) > c &&
                  r &&
                  String(r()) === "" &&
                  (o("swipe", C, { direction: T > 0 ? "right" : "left" }), O());
            }
          }
          function g(C) {
            if (a && ((a = !1), s && C.type === "mouseup")) {
              C.preventDefault(), C.stopPropagation(), (s = !1);
              return;
            }
          }
          function O() {
            a = !1;
          }
          function I() {
            i.removeEventListener("touchstart", d, !1),
              i.removeEventListener("touchmove", h, !1),
              i.removeEventListener("touchend", g, !1),
              i.removeEventListener("touchcancel", O, !1),
              i.removeEventListener("mousedown", d, !1),
              i.removeEventListener("mousemove", h, !1),
              i.removeEventListener("mouseup", g, !1),
              i.removeEventListener("mouseout", O, !1),
              (i = null);
          }
          this.destroy = I;
        }
        function o(i, a, s) {
          var c = e.Event(i, { originalEvent: a });
          e(a.target).trigger(c, s);
        }
        return (t.instance = t.init(document)), t;
      }),
    );
  });
  var aI = u((TK, oI) => {
    var Rt = lt(),
      TB = Hi(),
      Ce = {
        ARROW_LEFT: 37,
        ARROW_UP: 38,
        ARROW_RIGHT: 39,
        ARROW_DOWN: 40,
        ESCAPE: 27,
        SPACE: 32,
        ENTER: 13,
        HOME: 36,
        END: 35,
      };
    Rt.define(
      "navbar",
      (oI.exports = function (e, t) {
        var r = {},
          n = e.tram,
          o = e(window),
          i = e(document),
          a = t.debounce,
          s,
          c,
          f,
          p,
          d = Rt.env(),
          h = '<div class="w-nav-overlay" data-wf-ignore />',
          g = ".w-nav",
          O = "w--open",
          I = "w--nav-dropdown-open",
          C = "w--nav-dropdown-toggle-open",
          A = "w--nav-dropdown-list-open",
          R = "w--nav-link-open",
          T = TB.triggers,
          q = e();
        (r.ready = r.design = r.preview = x),
          (r.destroy = function () {
            (q = e()), N(), c && c.length && c.each(ee);
          });
        function x() {
          (f = d && Rt.env("design")),
            (p = Rt.env("editor")),
            (s = e(document.body)),
            (c = i.find(g)),
            c.length && (c.each(W), N(), F());
        }
        function N() {
          Rt.resize.off(U);
        }
        function F() {
          Rt.resize.on(U);
        }
        function U() {
          c.each(Y);
        }
        function W(v, X) {
          var B = e(X),
            V = e.data(X, g);
          V ||
            (V = e.data(X, g, {
              open: !1,
              el: B,
              config: {},
              selectedIdx: -1,
            })),
            (V.menu = B.find(".w-nav-menu")),
            (V.links = V.menu.find(".w-nav-link")),
            (V.dropdowns = V.menu.find(".w-dropdown")),
            (V.dropdownToggle = V.menu.find(".w-dropdown-toggle")),
            (V.dropdownList = V.menu.find(".w-dropdown-list")),
            (V.button = B.find(".w-nav-button")),
            (V.container = B.find(".w-container")),
            (V.overlayContainerId = "w-nav-overlay-" + v),
            (V.outside = Ve(V));
          var fe = B.find(".w-nav-brand");
          fe &&
            fe.attr("href") === "/" &&
            fe.attr("aria-label") == null &&
            fe.attr("aria-label", "home"),
            V.button.attr("style", "-webkit-user-select: text;"),
            V.button.attr("aria-label") == null &&
              V.button.attr("aria-label", "menu"),
            V.button.attr("role", "button"),
            V.button.attr("tabindex", "0"),
            V.button.attr("aria-controls", V.overlayContainerId),
            V.button.attr("aria-haspopup", "menu"),
            V.button.attr("aria-expanded", "false"),
            document.body.setAttribute("nav-expanded", "false"),
            V.el.off(g),
            V.button.off(g),
            V.menu.off(g),
            y(V),
            f
              ? (K(V), V.el.on("setting" + g, P(V)))
              : (L(V),
                V.button.on("click" + g, ie(V)),
                V.menu.on("click" + g, "a", Ne(V)),
                V.button.on("keydown" + g, M(V)),
                V.el.on("keydown" + g, D(V))),
            Y(v, X);
        }
        function ee(v, X) {
          var B = e.data(X, g);
          B && (K(B), e.removeData(X, g));
        }
        function K(v) {
          v.overlay && (ce(v, !0), v.overlay.remove(), (v.overlay = null));
        }
        function L(v) {
          v.overlay ||
            ((v.overlay = e(h).appendTo(v.el)),
            v.overlay.attr("id", v.overlayContainerId),
            (v.parent = v.menu.parent()),
            ce(v, !0));
        }
        function y(v) {
          var X = {},
            B = v.config || {},
            V = (X.animation = v.el.attr("data-animation") || "default");
          (X.animOver = /^over/.test(V)),
            (X.animDirect = /left$/.test(V) ? -1 : 1),
            B.animation !== V && v.open && t.defer(z, v),
            (X.easing = v.el.attr("data-easing") || "ease"),
            (X.easing2 = v.el.attr("data-easing2") || "ease");
          var fe = v.el.attr("data-duration");
          (X.duration = fe != null ? Number(fe) : 400),
            (X.docHeight = v.el.attr("data-doc-height")),
            (v.config = X);
        }
        function P(v) {
          return function (X, B) {
            B = B || {};
            var V = o.width();
            y(v),
              B.open === !0 && ht(v, !0),
              B.open === !1 && ce(v, !0),
              v.open &&
                t.defer(function () {
                  V !== o.width() && z(v);
                });
          };
        }
        function M(v) {
          return function (X) {
            switch (X.keyCode) {
              case Ce.SPACE:
              case Ce.ENTER:
                return ie(v)(), X.preventDefault(), X.stopPropagation();
              case Ce.ESCAPE:
                return ce(v), X.preventDefault(), X.stopPropagation();
              case Ce.ARROW_RIGHT:
              case Ce.ARROW_DOWN:
              case Ce.HOME:
              case Ce.END:
                return v.open
                  ? (X.keyCode === Ce.END
                      ? (v.selectedIdx = v.links.length - 1)
                      : (v.selectedIdx = 0),
                    j(v),
                    X.preventDefault(),
                    X.stopPropagation())
                  : (X.preventDefault(), X.stopPropagation());
            }
          };
        }
        function D(v) {
          return function (X) {
            if (v.open)
              switch (
                ((v.selectedIdx = v.links.index(document.activeElement)),
                X.keyCode)
              ) {
                case Ce.HOME:
                case Ce.END:
                  return (
                    X.keyCode === Ce.END
                      ? (v.selectedIdx = v.links.length - 1)
                      : (v.selectedIdx = 0),
                    j(v),
                    X.preventDefault(),
                    X.stopPropagation()
                  );
                case Ce.ESCAPE:
                  return (
                    ce(v),
                    v.button.focus(),
                    X.preventDefault(),
                    X.stopPropagation()
                  );
                case Ce.ARROW_LEFT:
                case Ce.ARROW_UP:
                  return (
                    (v.selectedIdx = Math.max(-1, v.selectedIdx - 1)),
                    j(v),
                    X.preventDefault(),
                    X.stopPropagation()
                  );
                case Ce.ARROW_RIGHT:
                case Ce.ARROW_DOWN:
                  return (
                    (v.selectedIdx = Math.min(
                      v.links.length - 1,
                      v.selectedIdx + 1,
                    )),
                    j(v),
                    X.preventDefault(),
                    X.stopPropagation()
                  );
              }
          };
        }
        function j(v) {
          if (v.links[v.selectedIdx]) {
            var X = v.links[v.selectedIdx];
            X.focus(), Ne(X);
          }
        }
        function z(v) {
          v.open && (ce(v, !0), ht(v, !0));
        }
        function ie(v) {
          return a(function () {
            v.open ? ce(v) : ht(v);
          });
        }
        function Ne(v) {
          return function (X) {
            var B = e(this),
              V = B.attr("href");
            if (!Rt.validClick(X.currentTarget)) {
              X.preventDefault();
              return;
            }
            V && V.indexOf("#") === 0 && v.open && ce(v);
          };
        }
        function Ve(v) {
          return (
            v.outside && i.off("click" + g, v.outside),
            function (X) {
              var B = e(X.target);
              (p && B.closest(".w-editor-bem-EditorOverlay").length) ||
                me(v, B);
            }
          );
        }
        var me = a(function (v, X) {
          if (v.open) {
            var B = X.closest(".w-nav-menu");
            v.menu.is(B) || ce(v);
          }
        });
        function Y(v, X) {
          var B = e.data(X, g),
            V = (B.collapsed = B.button.css("display") !== "none");
          if ((B.open && !V && !f && ce(B, !0), B.container.length)) {
            var fe = wt(B);
            B.links.each(fe), B.dropdowns.each(fe);
          }
          B.open && mr(B);
        }
        var Oe = "max-width";
        function wt(v) {
          var X = v.container.css(Oe);
          return (
            X === "none" && (X = ""),
            function (B, V) {
              (V = e(V)), V.css(Oe, ""), V.css(Oe) === "none" && V.css(Oe, X);
            }
          );
        }
        function Ht(v, X) {
          X.setAttribute("data-nav-menu-open", "");
        }
        function Ct(v, X) {
          X.removeAttribute("data-nav-menu-open");
        }
        function ht(v, X) {
          if (v.open) return;
          (v.open = !0),
            v.menu.each(Ht),
            v.links.addClass(R),
            v.dropdowns.addClass(I),
            v.dropdownToggle.addClass(C),
            v.dropdownList.addClass(A),
            v.button.addClass(O);
          var B = v.config,
            V = B.animation;
          (V === "none" || !n.support.transform || B.duration <= 0) && (X = !0);
          var fe = mr(v),
            Or = v.menu.outerHeight(!0),
            Nt = v.menu.outerWidth(!0),
            l = v.el.height(),
            E = v.el[0];
          if (
            (Y(0, E),
            T.intro(0, E),
            Rt.redraw.up(),
            f || i.on("click" + g, v.outside),
            X)
          ) {
            w();
            return;
          }
          var _ = "transform " + B.duration + "ms " + B.easing;
          if (
            (v.overlay &&
              ((q = v.menu.prev()), v.overlay.show().append(v.menu)),
            B.animOver)
          ) {
            n(v.menu)
              .add(_)
              .set({ x: B.animDirect * Nt, height: fe })
              .start({ x: 0 })
              .then(w),
              v.overlay && v.overlay.width(Nt);
            return;
          }
          var m = l + Or;
          n(v.menu).add(_).set({ y: -m }).start({ y: 0 }).then(w);
          function w() {
            v.button.attr("aria-expanded", "true");
            document.body.setAttribute("nav-expanded", "true");
          }
        }
        function mr(v) {
          var X = v.config,
            B = X.docHeight ? i.height() : s.height();
          return (
            X.animOver
              ? v.menu.height(B)
              : v.el.css("position") !== "fixed" && (B -= v.el.outerHeight(!0)),
            v.overlay && v.overlay.height(B),
            B
          );
        }
        function ce(v, X) {
          if (!v.open) return;
          (v.open = !1), v.button.removeClass(O);
          var B = v.config;
          if (
            ((B.animation === "none" ||
              !n.support.transform ||
              B.duration <= 0) &&
              (X = !0),
            T.outro(0, v.el[0]),
            i.off("click" + g, v.outside),
            X)
          ) {
            n(v.menu).stop(), E();
            return;
          }
          var V = "transform " + B.duration + "ms " + B.easing2,
            fe = v.menu.outerHeight(!0),
            Or = v.menu.outerWidth(!0),
            Nt = v.el.height();
          if (B.animOver) {
            n(v.menu)
              .add(V)
              .start({ x: Or * B.animDirect })
              .then(E);
            return;
          }
          var l = Nt + fe;
          n(v.menu).add(V).start({ y: -l }).then(E);
          function E() {
            v.menu.height(""),
              n(v.menu).set({ x: 0, y: 0 }),
              v.menu.each(Ct),
              v.links.removeClass(R),
              v.dropdowns.removeClass(I),
              v.dropdownToggle.removeClass(C),
              v.dropdownList.removeClass(A),
              v.overlay &&
                v.overlay.children().length &&
                (q.length ? v.menu.insertAfter(q) : v.menu.prependTo(v.parent),
                v.overlay.attr("style", "").hide()),
              v.el.triggerHandler("w-close"),
              v.button.attr("aria-expanded", "false");
              document.body.setAttribute("nav-expanded", "false");
          }
        }
        return r;
      }),
    );
  });
  xs();
  Ds();
  Xs();
  Hi();
  Zy();
  eI();
  rI();
  iI();
  aI();
})();
/*!
 * tram.js v0.8.2-global
 * Cross-browser CSS3 transitions in JavaScript
 * https://github.com/bkwld/tram
 * MIT License
 */
/*!
 * Webflow._ (aka) Underscore.js 1.6.0 (custom build)
 * _.each
 * _.map
 * _.find
 * _.filter
 * _.any
 * _.contains
 * _.delay
 * _.defer
 * _.throttle (webflow)
 * _.debounce
 * _.keys
 * _.has
 * _.now
 * _.template (webflow: upgraded to 1.13.6)
 *
 * http://underscorejs.org
 * (c) 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Underscore may be freely distributed under the MIT license.
 * @license MIT
 */
/*! Bundled license information:

timm/lib/timm.js:
  (*!
   * Timm
   *
   * Immutability helpers with fast reads and acceptable writes.
   *
   * @copyright Guillermo Grau Panea 2016
   * @license MIT
   *)
*/
/**
 * ----------------------------------------------------------------------
 * Webflow: Interactions 2.0: Init
 */
Webflow.require("ix2").init({
  events: {
    "e-5": {
      id: "e-5",
      name: "",
      animationType: "preset",
      eventTypeId: "NAVBAR_OPEN",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-6",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "a9649272-70a2-770e-4b9c-a300dcbfa79e",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "a9649272-70a2-770e-4b9c-a300dcbfa79e",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: null,
        scrollOffsetUnit: null,
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1693301587961,
    },
    "e-6": {
      id: "e-6",
      name: "",
      animationType: "preset",
      eventTypeId: "NAVBAR_CLOSE",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-2",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-5",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "a9649272-70a2-770e-4b9c-a300dcbfa79e",
        appliesTo: "ELEMENT",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "a9649272-70a2-770e-4b9c-a300dcbfa79e",
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: null,
        scrollOffsetUnit: null,
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1693301587961,
    },
    "e-7": {
      id: "e-7",
      name: "",
      animationType: "custom",
      eventTypeId: "PAGE_SCROLL",
      action: {
        id: "",
        actionTypeId: "GENERAL_CONTINUOUS_ACTION",
        config: { actionListId: "a-3", affectedElements: {}, duration: 0 },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64ec54d99f92b72fe4466521",
        appliesTo: "PAGE",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64ec54d99f92b72fe4466521",
          appliesTo: "PAGE",
          styleBlockIds: [],
        },
      ],
      config: [
        {
          continuousParameterGroupId: "a-3-p",
          smoothing: 50,
          startsEntering: true,
          addStartOffset: false,
          addOffsetValue: 50,
          startsExiting: false,
          addEndOffset: false,
          endOffsetValue: 50,
        },
      ],
      createdOn: 1693404268252,
    },
    "e-8": {
      id: "e-8",
      name: "",
      animationType: "custom",
      eventTypeId: "PAGE_SCROLL_UP",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-4",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-9",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64ec54d99f92b72fe4466521",
        appliesTo: "PAGE",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64ec54d99f92b72fe4466521",
          appliesTo: "PAGE",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1693404532116,
    },
    "e-9": {
      id: "e-9",
      name: "",
      animationType: "custom",
      eventTypeId: "PAGE_SCROLL_DOWN",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-5",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-8",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64ec54d99f92b72fe4466521",
        appliesTo: "PAGE",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64ec54d99f92b72fe4466521",
          appliesTo: "PAGE",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1693404532116,
    },
    "e-10": {
      id: "e-10",
      name: "",
      animationType: "custom",
      eventTypeId: "PAGE_SCROLL",
      action: {
        id: "",
        actionTypeId: "GENERAL_CONTINUOUS_ACTION",
        config: { actionListId: "a-3", affectedElements: {}, duration: 0 },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64ef503d86e87adfb36d97a3",
        appliesTo: "PAGE",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64ef503d86e87adfb36d97a3",
          appliesTo: "PAGE",
          styleBlockIds: [],
        },
      ],
      config: [
        {
          continuousParameterGroupId: "a-3-p",
          smoothing: 50,
          startsEntering: true,
          addStartOffset: false,
          addOffsetValue: 50,
          startsExiting: false,
          addEndOffset: false,
          endOffsetValue: 50,
        },
      ],
      createdOn: 1693405643068,
    },
    "e-11": {
      id: "e-11",
      name: "",
      animationType: "custom",
      eventTypeId: "PAGE_SCROLL_UP",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-4",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-12",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64ef503d86e87adfb36d97a3",
        appliesTo: "PAGE",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64ef503d86e87adfb36d97a3",
          appliesTo: "PAGE",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1693405649805,
    },
    "e-12": {
      id: "e-12",
      name: "",
      animationType: "custom",
      eventTypeId: "PAGE_SCROLL_DOWN",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-5",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-11",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64ef503d86e87adfb36d97a3",
        appliesTo: "PAGE",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64ef503d86e87adfb36d97a3",
          appliesTo: "PAGE",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1693405649805,
    },
    "e-13": {
      id: "e-13",
      name: "",
      animationType: "custom",
      eventTypeId: "PAGE_SCROLL",
      action: {
        id: "",
        actionTypeId: "GENERAL_CONTINUOUS_ACTION",
        config: { actionListId: "a-3", affectedElements: {}, duration: 0 },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64f09ecc733b8fb626440653",
        appliesTo: "PAGE",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64f09ecc733b8fb626440653",
          appliesTo: "PAGE",
          styleBlockIds: [],
        },
      ],
      config: [
        {
          continuousParameterGroupId: "a-3-p",
          smoothing: 50,
          startsEntering: true,
          addStartOffset: false,
          addOffsetValue: 50,
          startsExiting: false,
          addEndOffset: false,
          endOffsetValue: 50,
        },
      ],
      createdOn: 1693494660906,
    },
    "e-14": {
      id: "e-14",
      name: "",
      animationType: "custom",
      eventTypeId: "PAGE_SCROLL_UP",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-4",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-15",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64f09ecc733b8fb626440653",
        appliesTo: "PAGE",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64f09ecc733b8fb626440653",
          appliesTo: "PAGE",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1693494666205,
    },
    "e-15": {
      id: "e-15",
      name: "",
      animationType: "custom",
      eventTypeId: "PAGE_SCROLL_DOWN",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-5",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-14",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64f09ecc733b8fb626440653",
        appliesTo: "PAGE",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64f09ecc733b8fb626440653",
          appliesTo: "PAGE",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1693494666205,
    },
    "e-16": {
      id: "e-16",
      name: "",
      animationType: "custom",
      eventTypeId: "PAGE_SCROLL",
      action: {
        id: "",
        actionTypeId: "GENERAL_CONTINUOUS_ACTION",
        config: { actionListId: "a-3", affectedElements: {}, duration: 0 },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64f09dcb9a6145cab179c53e",
        appliesTo: "PAGE",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64f09dcb9a6145cab179c53e",
          appliesTo: "PAGE",
          styleBlockIds: [],
        },
      ],
      config: [
        {
          continuousParameterGroupId: "a-3-p",
          smoothing: 50,
          startsEntering: true,
          addStartOffset: false,
          addOffsetValue: 50,
          startsExiting: false,
          addEndOffset: false,
          endOffsetValue: 50,
        },
      ],
      createdOn: 1693494677293,
    },
    "e-17": {
      id: "e-17",
      name: "",
      animationType: "custom",
      eventTypeId: "PAGE_SCROLL_UP",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-4",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-18",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64f09dcb9a6145cab179c53e",
        appliesTo: "PAGE",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64f09dcb9a6145cab179c53e",
          appliesTo: "PAGE",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1693494688306,
    },
    "e-18": {
      id: "e-18",
      name: "",
      animationType: "custom",
      eventTypeId: "PAGE_SCROLL_DOWN",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-5",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-17",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64f09dcb9a6145cab179c53e",
        appliesTo: "PAGE",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64f09dcb9a6145cab179c53e",
          appliesTo: "PAGE",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1693494688307,
    },
    "e-19": {
      id: "e-19",
      name: "",
      animationType: "custom",
      eventTypeId: "PAGE_SCROLL",
      action: {
        id: "",
        actionTypeId: "GENERAL_CONTINUOUS_ACTION",
        config: { actionListId: "a-3", affectedElements: {}, duration: 0 },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64f074c2472b994404e85a83",
        appliesTo: "PAGE",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64f074c2472b994404e85a83",
          appliesTo: "PAGE",
          styleBlockIds: [],
        },
      ],
      config: [
        {
          continuousParameterGroupId: "a-3-p",
          smoothing: 50,
          startsEntering: true,
          addStartOffset: false,
          addOffsetValue: 50,
          startsExiting: false,
          addEndOffset: false,
          endOffsetValue: 50,
        },
      ],
      createdOn: 1693494701592,
    },
    "e-20": {
      id: "e-20",
      name: "",
      animationType: "custom",
      eventTypeId: "PAGE_SCROLL_UP",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-4",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-21",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64f074c2472b994404e85a83",
        appliesTo: "PAGE",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64f074c2472b994404e85a83",
          appliesTo: "PAGE",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1693494708106,
    },
    "e-21": {
      id: "e-21",
      name: "",
      animationType: "custom",
      eventTypeId: "PAGE_SCROLL_DOWN",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-5",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-20",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64f074c2472b994404e85a83",
        appliesTo: "PAGE",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64f074c2472b994404e85a83",
          appliesTo: "PAGE",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1693494708107,
    },
    "e-22": {
      id: "e-22",
      name: "",
      animationType: "custom",
      eventTypeId: "PAGE_SCROLL",
      action: {
        id: "",
        actionTypeId: "GENERAL_CONTINUOUS_ACTION",
        config: { actionListId: "a-3", affectedElements: {}, duration: 0 },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64f0412d538099ccedbb4d19",
        appliesTo: "PAGE",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64f0412d538099ccedbb4d19",
          appliesTo: "PAGE",
          styleBlockIds: [],
        },
      ],
      config: [
        {
          continuousParameterGroupId: "a-3-p",
          smoothing: 50,
          startsEntering: true,
          addStartOffset: false,
          addOffsetValue: 50,
          startsExiting: false,
          addEndOffset: false,
          endOffsetValue: 50,
        },
      ],
      createdOn: 1693494720694,
    },
    "e-23": {
      id: "e-23",
      name: "",
      animationType: "custom",
      eventTypeId: "PAGE_SCROLL_UP",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-4",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-24",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64f0412d538099ccedbb4d19",
        appliesTo: "PAGE",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64f0412d538099ccedbb4d19",
          appliesTo: "PAGE",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1693494725921,
    },
    "e-24": {
      id: "e-24",
      name: "",
      animationType: "custom",
      eventTypeId: "PAGE_SCROLL_DOWN",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-5",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-23",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64f0412d538099ccedbb4d19",
        appliesTo: "PAGE",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64f0412d538099ccedbb4d19",
          appliesTo: "PAGE",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1693494725921,
    },
    "e-25": {
      id: "e-25",
      name: "",
      animationType: "custom",
      eventTypeId: "PAGE_SCROLL",
      action: {
        id: "",
        actionTypeId: "GENERAL_CONTINUOUS_ACTION",
        config: { actionListId: "a-3", affectedElements: {}, duration: 0 },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64ec95bf68c5e77efcff1092",
        appliesTo: "PAGE",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64ec95bf68c5e77efcff1092",
          appliesTo: "PAGE",
          styleBlockIds: [],
        },
      ],
      config: [
        {
          continuousParameterGroupId: "a-3-p",
          smoothing: 50,
          startsEntering: true,
          addStartOffset: false,
          addOffsetValue: 50,
          startsExiting: false,
          addEndOffset: false,
          endOffsetValue: 50,
        },
      ],
      createdOn: 1693494740963,
    },
    "e-26": {
      id: "e-26",
      name: "",
      animationType: "custom",
      eventTypeId: "PAGE_SCROLL_UP",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-4",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-27",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64ec95bf68c5e77efcff1092",
        appliesTo: "PAGE",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64ec95bf68c5e77efcff1092",
          appliesTo: "PAGE",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1693494757194,
    },
    "e-27": {
      id: "e-27",
      name: "",
      animationType: "custom",
      eventTypeId: "PAGE_SCROLL_DOWN",
      action: {
        id: "",
        actionTypeId: "GENERAL_START_ACTION",
        config: {
          delay: 0,
          easing: "",
          duration: 0,
          actionListId: "a-5",
          affectedElements: {},
          playInReverse: false,
          autoStopEventId: "e-26",
        },
      },
      mediaQueries: ["main", "medium", "small", "tiny"],
      target: {
        id: "64ec95bf68c5e77efcff1092",
        appliesTo: "PAGE",
        styleBlockIds: [],
      },
      targets: [
        {
          id: "64ec95bf68c5e77efcff1092",
          appliesTo: "PAGE",
          styleBlockIds: [],
        },
      ],
      config: {
        loop: false,
        playInReverse: false,
        scrollOffsetValue: 0,
        scrollOffsetUnit: "%",
        delay: null,
        direction: null,
        effectIn: null,
      },
      createdOn: 1693494757194,
    },
  },
  actionLists: {
    a: {
      id: "a",
      title: "Navbar - opens",
      actionItemGroups: [
        {
          actionItems: [
            {
              id: "a-n-11",
              actionTypeId: "STYLE_SIZE",
              config: {
                delay: 0,
                easing: "",
                duration: 500,
                target: {
                  useEventTarget: "CHILDREN",
                  selector: ".logo",
                  selectorGuids: ["c55fdfbd-895a-8bdf-4e6e-f240652a9cfc"],
                },
                widthValue: 150,
                heightValue: 70,
                widthUnit: "px",
                heightUnit: "px",
                locked: false,
              },
            },
          ],
        },
        {
          actionItems: [
            {
              id: "a-n-9",
              actionTypeId: "STYLE_OPACITY",
              config: {
                delay: 0,
                easing: "",
                duration: 0,
                target: {
                  useEventTarget: "CHILDREN",
                  selector: ".nav-number",
                  selectorGuids: ["f55137ac-c7af-8f37-a6a1-59f2f9674d00"],
                },
                value: 0,
                unit: "",
              },
            },
            {
              id: "a-n-8",
              actionTypeId: "GENERAL_DISPLAY",
              config: {
                delay: 0,
                easing: "",
                duration: 0,
                target: {
                  useEventTarget: "CHILDREN",
                  selector: ".nav-number",
                  selectorGuids: ["f55137ac-c7af-8f37-a6a1-59f2f9674d00"],
                },
                value: "none",
              },
            },
          ],
        },
        {
          actionItems: [
            {
              id: "a-n",
              actionTypeId: "TRANSFORM_MOVE",
              config: {
                delay: 0,
                easing: "ease",
                duration: 400,
                target: {
                  useEventTarget: "CHILDREN",
                  selector: ".menu-button-icon-top",
                  selectorGuids: ["217f6854-2bcb-8e51-758f-925c519572ed"],
                },
                yValue: 11,
                xUnit: "PX",
                yUnit: "px",
                zUnit: "PX",
              },
            },
            {
              id: "a-n-5",
              actionTypeId: "TRANSFORM_MOVE",
              config: {
                delay: 0,
                easing: "ease",
                duration: 400,
                target: {
                  useEventTarget: "CHILDREN",
                  selector: ".menu-button-icon-middle",
                  selectorGuids: ["18732293-e65a-6acf-d508-d24648be0aea"],
                },
                xValue: 200,
                xUnit: "%",
                yUnit: "PX",
                zUnit: "PX",
              },
            },
            {
              id: "a-n-4",
              actionTypeId: "TRANSFORM_ROTATE",
              config: {
                delay: 0,
                easing: "ease",
                duration: 400,
                target: {
                  useEventTarget: "CHILDREN",
                  selector: ".menu-button-icon-bottom",
                  selectorGuids: ["61642ee6-ac84-00de-56dc-0d174e8c862f"],
                },
                zValue: 225,
                xUnit: "DEG",
                yUnit: "DEG",
                zUnit: "deg",
              },
            },
            {
              id: "a-n-3",
              actionTypeId: "TRANSFORM_MOVE",
              config: {
                delay: 0,
                easing: "ease",
                duration: 400,
                target: {
                  useEventTarget: "CHILDREN",
                  selector: ".menu-button-icon-bottom",
                  selectorGuids: ["61642ee6-ac84-00de-56dc-0d174e8c862f"],
                },
                yValue: -11,
                xUnit: "PX",
                yUnit: "px",
                zUnit: "PX",
              },
            },
            {
              id: "a-n-2",
              actionTypeId: "TRANSFORM_ROTATE",
              config: {
                delay: 0,
                easing: "ease",
                duration: 400,
                target: {
                  useEventTarget: "CHILDREN",
                  selector: ".menu-button-icon-top",
                  selectorGuids: ["217f6854-2bcb-8e51-758f-925c519572ed"],
                },
                zValue: -225,
                xUnit: "DEG",
                yUnit: "DEG",
                zUnit: "deg",
              },
            },
          ],
        },
        {
          actionItems: [
            {
              id: "a-n-10",
              actionTypeId: "STYLE_SIZE",
              config: {
                delay: 0,
                easing: "easeOut",
                duration: 400,
                target: {
                  useEventTarget: "CHILDREN",
                  selector: ".logo",
                  selectorGuids: ["c55fdfbd-895a-8bdf-4e6e-f240652a9cfc"],
                },
                widthValue: 200,
                heightValue: 200,
                widthUnit: "px",
                heightUnit: "px",
                locked: false,
              },
            },
          ],
        },
      ],
      useFirstGroupAsInitialState: true,
      createdOn: 1693228262431,
    },
    "a-2": {
      id: "a-2",
      title: "Navbar - closes",
      actionItemGroups: [
        {
          actionItems: [
            {
              id: "a-2-n",
              actionTypeId: "TRANSFORM_MOVE",
              config: {
                delay: 0,
                easing: "ease",
                duration: 400,
                target: {
                  useEventTarget: "CHILDREN",
                  selector: ".menu-button-icon-top",
                  selectorGuids: ["217f6854-2bcb-8e51-758f-925c519572ed"],
                },
                yValue: 0,
                xUnit: "PX",
                yUnit: "px",
                zUnit: "PX",
              },
            },
            {
              id: "a-2-n-8",
              actionTypeId: "STYLE_SIZE",
              config: {
                delay: 0,
                easing: "ease",
                duration: 400,
                target: {
                  useEventTarget: "CHILDREN",
                  selector: ".logo",
                  selectorGuids: ["c55fdfbd-895a-8bdf-4e6e-f240652a9cfc"],
                },
                widthValue: 150,
                heightValue: 70,
                widthUnit: "px",
                heightUnit: "px",
                locked: false,
              },
            },
            {
              id: "a-2-n-2",
              actionTypeId: "TRANSFORM_MOVE",
              config: {
                delay: 0,
                easing: "ease",
                duration: 400,
                target: {
                  useEventTarget: "CHILDREN",
                  selector: ".menu-button-icon-middle",
                  selectorGuids: ["18732293-e65a-6acf-d508-d24648be0aea"],
                },
                xValue: 0,
                xUnit: "px",
                yUnit: "PX",
                zUnit: "PX",
              },
            },
            {
              id: "a-2-n-3",
              actionTypeId: "TRANSFORM_ROTATE",
              config: {
                delay: 0,
                easing: "ease",
                duration: 400,
                target: {
                  useEventTarget: "CHILDREN",
                  selector: ".menu-button-icon-bottom",
                  selectorGuids: ["61642ee6-ac84-00de-56dc-0d174e8c862f"],
                },
                zValue: 0,
                xUnit: "DEG",
                yUnit: "DEG",
                zUnit: "deg",
              },
            },
            {
              id: "a-2-n-4",
              actionTypeId: "TRANSFORM_MOVE",
              config: {
                delay: 0,
                easing: "ease",
                duration: 400,
                target: {
                  useEventTarget: "CHILDREN",
                  selector: ".menu-button-icon-bottom",
                  selectorGuids: ["61642ee6-ac84-00de-56dc-0d174e8c862f"],
                },
                yValue: 0,
                xUnit: "PX",
                yUnit: "px",
                zUnit: "PX",
              },
            },
            {
              id: "a-2-n-5",
              actionTypeId: "TRANSFORM_ROTATE",
              config: {
                delay: 0,
                easing: "ease",
                duration: 400,
                target: {
                  useEventTarget: "CHILDREN",
                  selector: ".menu-button-icon-top",
                  selectorGuids: ["217f6854-2bcb-8e51-758f-925c519572ed"],
                },
                zValue: 0,
                xUnit: "DEG",
                yUnit: "DEG",
                zUnit: "deg",
              },
            },
          ],
        },
        {
          actionItems: [
            {
              id: "a-2-n-6",
              actionTypeId: "GENERAL_DISPLAY",
              config: {
                delay: 400,
                easing: "",
                duration: 0,
                target: {
                  useEventTarget: "CHILDREN",
                  selector: ".nav-number",
                  selectorGuids: ["f55137ac-c7af-8f37-a6a1-59f2f9674d00"],
                },
                value: "block",
              },
            },
          ],
        },
        {
          actionItems: [
            {
              id: "a-2-n-7",
              actionTypeId: "STYLE_OPACITY",
              config: {
                delay: 0,
                easing: "ease",
                duration: 200,
                target: {
                  useEventTarget: "CHILDREN",
                  selector: ".nav-number",
                  selectorGuids: ["f55137ac-c7af-8f37-a6a1-59f2f9674d00"],
                },
                value: 1,
                unit: "",
              },
            },
          ],
        },
      ],
      useFirstGroupAsInitialState: false,
      createdOn: 1693228262431,
    },
    "a-3": {
      id: "a-3",
      title: "Navbar - background",
      continuousParameterGroups: [
        {
          id: "a-3-p",
          type: "SCROLL_PROGRESS",
          parameterLabel: "Scroll",
          continuousActionGroups: [
            {
              keyframe: 3,
              actionItems: [
                {
                  id: "a-3-n-8",
                  actionTypeId: "STYLE_SIZE",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      selector: ".nav-wrapper",
                      selectorGuids: ["65509ff4-6598-9be8-eed1-3154159e456f"],
                    },
                    heightValue: 88,
                    widthUnit: "PX",
                    heightUnit: "px",
                    locked: false,
                  },
                },
                {
                  id: "a-3-n-6",
                  actionTypeId: "STYLE_SIZE",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      selector: ".brand",
                      selectorGuids: ["aa1e88f1-373e-d92a-6c7d-812f141a5c40"],
                    },
                    heightValue: 88,
                    widthUnit: "PX",
                    heightUnit: "px",
                    locked: false,
                  },
                },
                {
                  id: "a-3-n-4",
                  actionTypeId: "STYLE_BORDER",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      selector: ".navbar",
                      selectorGuids: ["bfcf8a0e-9d6a-d9c2-9e1e-78deabe70cbe"],
                    },
                    globalSwatchId: "",
                    rValue: 177,
                    bValue: 73,
                    gValue: 118,
                    aValue: 0,
                  },
                },
                {
                  id: "a-3-n",
                  actionTypeId: "STYLE_BACKGROUND_COLOR",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      selector: ".navbar",
                      selectorGuids: ["bfcf8a0e-9d6a-d9c2-9e1e-78deabe70cbe"],
                    },
                    globalSwatchId: "",
                    rValue: 0,
                    bValue: 0,
                    gValue: 0,
                    aValue: 0,
                  },
                },
              ],
            },
            {
              keyframe: 4,
              actionItems: [
                {
                  id: "a-3-n-9",
                  actionTypeId: "STYLE_SIZE",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      selector: ".nav-wrapper",
                      selectorGuids: ["65509ff4-6598-9be8-eed1-3154159e456f"],
                    },
                    heightValue: 72,
                    widthUnit: "PX",
                    heightUnit: "px",
                    locked: false,
                  },
                },
                {
                  id: "a-3-n-7",
                  actionTypeId: "STYLE_SIZE",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      selector: ".brand",
                      selectorGuids: ["aa1e88f1-373e-d92a-6c7d-812f141a5c40"],
                    },
                    heightValue: 72,
                    widthUnit: "PX",
                    heightUnit: "px",
                    locked: false,
                  },
                },
                {
                  id: "a-3-n-5",
                  actionTypeId: "STYLE_BORDER",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      selector: ".navbar",
                      selectorGuids: ["bfcf8a0e-9d6a-d9c2-9e1e-78deabe70cbe"],
                    },
                    globalSwatchId: "4fff41c3",
                    rValue: 177,
                    bValue: 73,
                    gValue: 118,
                    aValue: 1,
                  },
                },
                {
                  id: "a-3-n-3",
                  actionTypeId: "STYLE_BACKGROUND_COLOR",
                  config: {
                    delay: 0,
                    easing: "",
                    duration: 500,
                    target: {
                      selector: ".navbar",
                      selectorGuids: ["bfcf8a0e-9d6a-d9c2-9e1e-78deabe70cbe"],
                    },
                    globalSwatchId: "56ccc440",
                    rValue: 255,
                    bValue: 255,
                    gValue: 255,
                    aValue: 1,
                  },
                },
              ],
            },
          ],
        },
      ],
      createdOn: 1693404274252,
    },
    "a-4": {
      id: "a-4",
      title: "Navbar - show",
      actionItemGroups: [
        {
          actionItems: [
            {
              id: "a-4-n",
              actionTypeId: "TRANSFORM_MOVE",
              config: {
                delay: 0,
                easing: "ease",
                duration: 500,
                target: {
                  selector: ".navbar",
                  selectorGuids: ["bfcf8a0e-9d6a-d9c2-9e1e-78deabe70cbe"],
                },
                yValue: 0,
                xUnit: "PX",
                yUnit: "%",
                zUnit: "PX",
              },
            },
          ],
        },
      ],
      useFirstGroupAsInitialState: false,
      createdOn: 1693404537303,
    },
    "a-5": {
      id: "a-5",
      title: "Navbar - hides",
      actionItemGroups: [
        {
          actionItems: [
            {
              id: "a-5-n",
              actionTypeId: "TRANSFORM_MOVE",
              config: {
                delay: 0,
                easing: "ease",
                duration: 500,
                target: {
                  selector: ".navbar",
                  selectorGuids: ["bfcf8a0e-9d6a-d9c2-9e1e-78deabe70cbe"],
                },
                yValue: -110,
                xUnit: "PX",
                yUnit: "%",
                zUnit: "PX",
              },
            },
          ],
        },
      ],
      useFirstGroupAsInitialState: false,
      createdOn: 1693404537303,
    },
  },
  site: {
    mediaQueries: [
      { key: "main", min: 992, max: 10000 },
      { key: "medium", min: 768, max: 991 },
      { key: "small", min: 480, max: 767 },
      { key: "tiny", min: 0, max: 479 },
    ],
  },
});
